var _style, _g, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _defs2, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _polygon285, _polygon286, _defs3, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _defs4, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _defs5, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _defs6, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350, _polygon351, _polygon352, _polygon353, _polygon354, _polygon355, _polygon356, _polygon357, _polygon358, _polygon359, _polygon360, _polygon361, _polygon362, _polygon363, _polygon364, _polygon365, _polygon366, _polygon367, _polygon368, _polygon369, _polygon370, _polygon371, _polygon372, _polygon373, _polygon374, _polygon375, _polygon376, _polygon377, _polygon378, _polygon379, _polygon380, _polygon381, _polygon382, _polygon383, _polygon384, _polygon385, _polygon386, _polygon387, _polygon388, _polygon389, _polygon390, _polygon391, _polygon392, _polygon393, _polygon394, _polygon395, _polygon396, _polygon397, _polygon398, _polygon399, _polygon400, _polygon401, _polygon402, _polygon403, _polygon404, _polygon405, _defs7, _polygon406, _polygon407, _polygon408, _polygon409, _polygon410, _polygon411, _polygon412, _polygon413, _polygon414, _polygon415, _polygon416, _polygon417, _polygon418, _polygon419, _polygon420, _polygon421, _polygon422, _polygon423, _polygon424, _polygon425, _polygon426, _polygon427, _polygon428, _polygon429, _polygon430, _polygon431, _polygon432, _polygon433, _polygon434, _polygon435, _polygon436, _polygon437, _polygon438, _polygon439, _polygon440, _polygon441, _polygon442, _polygon443, _polygon444, _polygon445, _polygon446, _polygon447, _polygon448, _polygon449, _polygon450, _polygon451, _polygon452, _polygon453, _polygon454, _polygon455, _polygon456, _polygon457, _polygon458, _polygon459, _polygon460, _polygon461, _polygon462, _polygon463, _polygon464, _polygon465, _polygon466, _polygon467, _polygon468, _polygon469, _polygon470, _polygon471, _polygon472, _polygon473, _polygon474, _polygon475, _polygon476, _polygon477, _polygon478, _polygon479, _polygon480, _polygon481, _polygon482, _polygon483, _polygon484, _polygon485, _polygon486, _polygon487, _polygon488, _polygon489, _polygon490, _polygon491, _polygon492, _polygon493, _polygon494, _polygon495, _polygon496, _polygon497, _polygon498, _polygon499, _polygon500, _polygon501, _polygon502, _polygon503, _polygon504, _polygon505, _polygon506, _polygon507, _polygon508, _polygon509, _polygon510, _polygon511, _polygon512, _polygon513, _polygon514, _polygon515, _polygon516, _polygon517, _polygon518, _polygon519, _polygon520, _polygon521, _polygon522, _polygon523, _polygon524, _polygon525, _polygon526, _polygon527, _polygon528, _polygon529, _polygon530, _polygon531, _polygon532, _polygon533, _polygon534, _polygon535, _polygon536, _polygon537, _polygon538, _polygon539, _polygon540, _polygon541, _polygon542, _polygon543, _polygon544, _polygon545, _polygon546, _polygon547, _polygon548, _polygon549, _polygon550, _polygon551, _polygon552, _polygon553, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _polygon554, _polygon555, _polygon556, _polygon557, _polygon558, _polygon559, _polygon560, _polygon561, _polygon562, _polygon563, _polygon564, _polygon565, _polygon566, _polygon567, _polygon568, _polygon569, _polygon570, _polygon571, _polygon572, _polygon573, _polygon574, _polygon575, _polygon576, _polygon577, _polygon578, _polygon579, _polygon580, _polygon581, _polygon582, _polygon583, _polygon584, _polygon585, _polygon586, _polygon587, _polygon588, _polygon589, _polygon590, _polygon591, _polygon592, _polygon593, _polygon594, _polygon595, _polygon596, _polygon597, _polygon598, _polygon599, _polygon600, _polygon601, _polygon602, _polygon603, _polygon604, _polygon605, _polygon606, _polygon607, _polygon608, _polygon609, _polygon610, _polygon611, _polygon612, _polygon613, _polygon614, _polygon615, _polygon616, _polygon617, _polygon618, _polygon619, _polygon620, _polygon621, _polygon622, _polygon623, _polygon624, _polygon625, _polygon626, _polygon627, _polygon628, _polygon629, _polygon630, _polygon631, _polygon632, _polygon633, _polygon634, _polygon635, _polygon636, _polygon637, _polygon638, _polygon639, _polygon640, _polygon641, _polygon642, _polygon643, _polygon644, _polygon645, _polygon646, _polygon647, _polygon648, _polygon649, _polygon650, _polygon651, _polygon652, _polygon653, _polygon654, _polygon655, _polygon656, _polygon657, _polygon658, _polygon659, _polygon660, _polygon661, _polygon662, _polygon663, _polygon664, _polygon665, _polygon666, _polygon667, _polygon668, _polygon669, _polygon670, _polygon671, _polygon672, _polygon673, _polygon674, _polygon675, _polygon676, _polygon677, _polygon678, _polygon679, _polygon680, _polygon681, _polygon682, _polygon683, _polygon684, _polygon685, _polygon686, _polygon687, _polygon688, _polygon689, _rect344, _rect345, _rect346, _defs8, _polygon690, _polygon691, _polygon692, _polygon693, _polygon694, _polygon695, _polygon696, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _polygon697, _polygon698, _polygon699, _polygon700, _polygon701, _defs9, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _defs0, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _defs1, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _defs10, _polygon702, _polygon703, _polygon704, _polygon705, _polygon706, _polygon707, _polygon708, _polygon709, _polygon710, _polygon711, _polygon712, _polygon713, _polygon714, _polygon715, _polygon716, _polygon717, _polygon718, _polygon719, _polygon720, _polygon721, _polygon722, _polygon723, _polygon724, _polygon725, _polygon726, _polygon727, _polygon728, _polygon729, _polygon730, _polygon731, _polygon732, _polygon733, _polygon734, _polygon735, _polygon736, _polygon737, _polygon738, _polygon739, _polygon740, _polygon741, _polygon742, _polygon743, _polygon744, _polygon745, _polygon746, _polygon747, _polygon748, _polygon749, _polygon750, _polygon751, _polygon752, _polygon753, _polygon754, _polygon755, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _defs11, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _defs12, _polygon756, _polygon757, _polygon758, _polygon759, _polygon760, _polygon761, _polygon762, _polygon763, _polygon764, _polygon765, _polygon766, _polygon767, _polygon768, _polygon769, _polygon770, _polygon771, _polygon772, _polygon773, _polygon774, _polygon775, _polygon776, _polygon777, _polygon778, _polygon779, _polygon780, _polygon781, _polygon782, _polygon783, _polygon784, _polygon785, _polygon786, _polygon787, _polygon788, _polygon789, _polygon790, _polygon791, _polygon792, _polygon793, _polygon794, _polygon795, _polygon796, _polygon797, _polygon798, _polygon799, _polygon800, _polygon801, _polygon802, _polygon803, _polygon804, _polygon805, _polygon806, _polygon807, _polygon808, _polygon809, _polygon810, _polygon811, _polygon812, _polygon813, _polygon814, _polygon815, _polygon816, _polygon817, _polygon818, _polygon819, _polygon820, _polygon821, _polygon822, _polygon823, _polygon824, _polygon825, _polygon826, _polygon827, _polygon828, _polygon829, _polygon830, _polygon831, _polygon832, _polygon833, _polygon834, _polygon835, _polygon836, _polygon837, _polygon838, _polygon839, _polygon840, _polygon841, _polygon842, _polygon843, _polygon844, _polygon845, _polygon846, _polygon847, _polygon848, _polygon849, _polygon850, _polygon851, _polygon852, _polygon853, _polygon854, _polygon855, _polygon856, _polygon857, _polygon858, _polygon859, _polygon860, _polygon861, _polygon862, _polygon863, _polygon864, _polygon865, _polygon866, _polygon867, _polygon868, _polygon869, _polygon870, _polygon871, _polygon872, _polygon873, _polygon874, _polygon875, _polygon876, _polygon877, _polygon878, _polygon879, _polygon880, _polygon881, _polygon882, _polygon883, _polygon884, _polygon885, _polygon886, _polygon887, _polygon888, _polygon889, _polygon890, _polygon891, _polygon892, _polygon893, _polygon894, _polygon895, _polygon896, _polygon897, _polygon898, _polygon899, _polygon900, _polygon901, _polygon902, _polygon903, _polygon904, _polygon905, _polygon906, _polygon907, _polygon908, _polygon909, _polygon910, _polygon911, _polygon912, _polygon913, _polygon914, _polygon915, _polygon916, _polygon917, _polygon918, _polygon919, _polygon920, _polygon921, _polygon922, _polygon923, _polygon924, _polygon925, _polygon926, _polygon927, _polygon928, _polygon929, _polygon930, _polygon931, _polygon932, _polygon933, _polygon934, _polygon935, _polygon936, _polygon937, _polygon938, _polygon939, _polygon940, _polygon941, _polygon942, _polygon943, _polygon944, _polygon945, _polygon946, _polygon947, _polygon948, _polygon949, _polygon950, _polygon951, _polygon952, _polygon953, _polygon954, _polygon955, _polygon956, _polygon957, _polygon958, _polygon959, _polygon960, _polygon961, _polygon962, _polygon963, _polygon964, _polygon965, _polygon966, _polygon967, _polygon968, _polygon969, _polygon970, _polygon971, _polygon972, _polygon973, _polygon974, _polygon975, _polygon976, _polygon977, _polygon978, _polygon979, _polygon980, _polygon981, _polygon982, _polygon983, _polygon984, _polygon985, _polygon986, _polygon987, _polygon988, _polygon989, _polygon990, _defs13, _polygon991, _polygon992, _polygon993, _polygon994, _polygon995, _polygon996, _polygon997, _polygon998, _polygon999, _polygon1000, _polygon1001, _polygon1002, _polygon1003, _polygon1004, _polygon1005, _polygon1006, _polygon1007, _polygon1008, _polygon1009, _polygon1010, _polygon1011, _polygon1012, _polygon1013, _polygon1014, _polygon1015, _polygon1016, _polygon1017, _polygon1018, _polygon1019, _polygon1020, _polygon1021, _polygon1022, _polygon1023, _polygon1024, _polygon1025, _polygon1026, _polygon1027, _polygon1028, _polygon1029, _polygon1030, _polygon1031, _polygon1032, _polygon1033, _polygon1034, _polygon1035, _polygon1036, _polygon1037, _polygon1038, _polygon1039, _polygon1040, _polygon1041, _polygon1042, _polygon1043, _polygon1044, _polygon1045, _polygon1046, _polygon1047, _polygon1048, _polygon1049, _polygon1050, _polygon1051, _polygon1052, _polygon1053, _polygon1054, _polygon1055, _polygon1056, _polygon1057, _polygon1058, _polygon1059, _polygon1060, _polygon1061, _polygon1062, _polygon1063, _polygon1064, _polygon1065, _polygon1066, _polygon1067, _polygon1068, _polygon1069, _polygon1070, _polygon1071, _polygon1072, _polygon1073, _polygon1074, _polygon1075, _polygon1076, _polygon1077, _polygon1078, _polygon1079, _polygon1080, _polygon1081, _polygon1082, _polygon1083, _polygon1084, _polygon1085, _polygon1086, _polygon1087, _polygon1088, _polygon1089, _polygon1090, _polygon1091, _polygon1092, _polygon1093, _polygon1094, _polygon1095, _polygon1096, _polygon1097, _polygon1098, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _path, _defs14, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _defs15, _polygon1099, _polygon1100, _polygon1101, _polygon1102, _polygon1103, _polygon1104, _polygon1105, _polygon1106, _polygon1107, _polygon1108, _polygon1109, _polygon1110, _polygon1111, _polygon1112, _polygon1113, _rect806, _rect807, _rect808, _polygon1114, _polygon1115, _polygon1116, _polygon1117, _polygon1118, _polygon1119, _polygon1120, _polygon1121, _polygon1122, _polygon1123, _polygon1124, _polygon1125, _polygon1126, _polygon1127, _polygon1128, _polygon1129, _polygon1130, _polygon1131, _polygon1132, _polygon1133, _polygon1134, _polygon1135, _polygon1136, _polygon1137, _polygon1138, _rect809, _rect810, _defs16, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _defs17, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZonedThrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 123 129",
    style: {
      enableBackground: "new 0 0 123 129"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1F3F7;}\n\t.st1{fill:#C6C1C1;}\n\t.st2{fill:#333842;}\n\t.st3{fill:#F0582F;}\n\t.st4{clip-path:url(#SVGID_00000034061651964691697880000013275053445080112826_);}\n\t.st5{fill:#4D4D4E;}\n\t.st6{fill:#4E4E4F;}\n\t.st7{fill:#4F4F50;}\n\t.st8{fill:#505052;}\n\t.st9{fill:#515153;}\n\t.st10{fill:#525254;}\n\t.st11{fill:#535355;}\n\t.st12{fill:#545456;}\n\t.st13{fill:#555557;}\n\t.st14{fill:#565658;}\n\t.st15{fill:#575759;}\n\t.st16{fill:#58585A;}\n\t.st17{fill:#59595B;}\n\t.st18{fill:#5A5A5C;}\n\t.st19{fill:#5B5B5D;}\n\t.st20{fill:#5C5C5E;}\n\t.st21{fill:#5D5E60;}\n\t.st22{fill:#5E5F61;}\n\t.st23{fill:#5F6062;}\n\t.st24{fill:#606163;}\n\t.st25{fill:#616264;}\n\t.st26{fill:#626365;}\n\t.st27{fill:#636466;}\n\t.st28{fill:#646567;}\n\t.st29{fill:#656668;}\n\t.st30{fill:#666769;}\n\t.st31{fill:#67686A;}\n\t.st32{fill:#68696B;}\n\t.st33{fill:#696A6C;}\n\t.st34{fill:#6A6B6D;}\n\t.st35{fill:#6B6C6E;}\n\t.st36{fill:#6C6D6F;}\n\t.st37{fill:#6D6E70;}\n\t.st38{fill:#6E6F71;}\n\t.st39{fill:#6F7072;}\n\t.st40{fill:#707173;}\n\t.st41{fill:#717274;}\n\t.st42{fill:#727375;}\n\t.st43{fill:#737476;}\n\t.st44{fill:#747577;}\n\t.st45{fill:#757678;}\n\t.st46{fill:#75777A;}\n\t.st47{fill:#76787B;}\n\t.st48{fill:#77797C;}\n\t.st49{fill:#787A7D;}\n\t.st50{fill:#797B7E;}\n\t.st51{fill:#7A7C7F;}\n\t.st52{fill:#7B7D80;}\n\t.st53{fill:#7C7E81;}\n\t.st54{fill:#7D7F82;}\n\t.st55{fill:#7E8083;}\n\t.st56{fill:#7F8184;}\n\t.st57{fill:#808285;}\n\t.st58{fill:#818386;}\n\t.st59{fill:#828487;}\n\t.st60{fill:#838588;}\n\t.st61{fill:#848689;}\n\t.st62{fill:#85878A;}\n\t.st63{fill:#86888B;}\n\t.st64{fill:#87898C;}\n\t.st65{fill:#888A8D;}\n\t.st66{fill:#898B8E;}\n\t.st67{fill:#8A8C8F;}\n\t.st68{fill:#8B8D90;}\n\t.st69{fill:#8C8E91;}\n\t.st70{fill:#8D8F92;}\n\t.st71{fill:#8E9093;}\n\t.st72{fill:#8E9295;}\n\t.st73{fill:#8F9396;}\n\t.st74{fill:#909497;}\n\t.st75{fill:#919598;}\n\t.st76{fill:#929699;}\n\t.st77{fill:#93979A;}\n\t.st78{fill:#94989B;}\n\t.st79{fill:#95999C;}\n\t.st80{fill:#969A9D;}\n\t.st81{fill:#979B9E;}\n\t.st82{fill:#989C9F;}\n\t.st83{clip-path:url(#SVGID_00000152963303696910304620000014801915265359920043_);}\n\t.st84{fill:#707578;}\n\t.st85{fill:#6F7477;}\n\t.st86{fill:#6E7376;}\n\t.st87{fill:#6D7275;}\n\t.st88{fill:#6C7174;}\n\t.st89{fill:#6B7073;}\n\t.st90{fill:#6A6F72;}\n\t.st91{fill:#696E71;}\n\t.st92{fill:#686D70;}\n\t.st93{fill:#676C6E;}\n\t.st94{fill:#666B6D;}\n\t.st95{fill:#656A6C;}\n\t.st96{fill:#64696B;}\n\t.st97{fill:#63686A;}\n\t.st98{fill:#626769;}\n\t.st99{fill:#616668;}\n\t.st100{fill:#606567;}\n\t.st101{fill:#5F6466;}\n\t.st102{fill:#686D6F;}\n\t.st103{fill:#696E70;}\n\t.st104{fill:#6A6F71;}\n\t.st105{fill:#717679;}\n\t.st106{fill:#72777A;}\n\t.st107{fill:#73787B;}\n\t.st108{fill:#74797C;}\n\t.st109{fill:#757A7D;}\n\t.st110{fill:#767B7E;}\n\t.st111{fill:#777C7F;}\n\t.st112{fill:#787D80;}\n\t.st113{fill:#797E81;}\n\t.st114{fill:#7A7F82;}\n\t.st115{fill:#7B8083;}\n\t.st116{fill:#7C8184;}\n\t.st117{fill:#7D8285;}\n\t.st118{fill:#7E8386;}\n\t.st119{fill:#7F8487;}\n\t.st120{fill:#808588;}\n\t.st121{fill:#818689;}\n\t.st122{fill:#82878A;}\n\t.st123{fill:#83888B;}\n\t.st124{fill:#84898C;}\n\t.st125{fill:#858A8D;}\n\t.st126{fill:#868B8E;}\n\t.st127{fill:#878D90;}\n\t.st128{fill:#888E91;}\n\t.st129{fill:#898F92;}\n\t.st130{fill:#8A9093;}\n\t.st131{fill:#8B9194;}\n\t.st132{fill:#8C9295;}\n\t.st133{fill:#8D9396;}\n\t.st134{fill:#8E9497;}\n\t.st135{fill:#8F9598;}\n\t.st136{fill:#909699;}\n\t.st137{fill:#91979A;}\n\t.st138{fill:#92989B;}\n\t.st139{fill:#93999C;}\n\t.st140{fill:#949A9D;}\n\t.st141{fill:#959B9E;}\n\t.st142{fill:#969C9F;}\n\t.st143{fill:#979DA0;}\n\t.st144{fill:#989EA1;}\n\t.st145{fill:#999FA2;}\n\t.st146{fill:#9AA0A3;}\n\t.st147{fill:#9BA1A4;}\n\t.st148{fill:#9CA2A5;}\n\t.st149{fill:#9DA3A6;}\n\t.st150{fill:#9EA4A7;}\n\t.st151{fill:#9FA5A8;}\n\t.st152{fill:#A1A6AA;}\n\t.st153{fill:#A2A7AB;}\n\t.st154{fill:#A3A8AC;}\n\t.st155{fill:#A4A9AD;}\n\t.st156{fill:#A5AAAE;}\n\t.st157{fill:#A6ABAF;}\n\t.st158{fill:#A7ACB0;}\n\t.st159{fill:#A8ADB1;}\n\t.st160{fill:#A9AEB2;}\n\t.st161{fill:#AAAFB3;}\n\t.st162{fill:#ABB0B4;}\n\t.st163{fill:#ACB1B5;}\n\t.st164{fill:#ADB2B6;}\n\t.st165{fill:#AEB4B8;}\n\t.st166{fill:#AFB5B9;}\n\t.st167{fill:#B0B6BA;}\n\t.st168{fill:#B1B7BB;}\n\t.st169{fill:#B2B8BC;}\n\t.st170{fill:#B3B9BD;}\n\t.st171{fill:#B4BABE;}\n\t.st172{fill:#B5BBBF;}\n\t.st173{fill:#B6BCC0;}\n\t.st174{fill:#B8BEC1;}\n\t.st175{fill:#B9BFC2;}\n\t.st176{fill:#BAC0C3;}\n\t.st177{fill:#BBC1C4;}\n\t.st178{fill:#BCC2C5;}\n\t.st179{fill:#BDC3C6;}\n\t.st180{fill:#BEC4C7;}\n\t.st181{fill:#BFC5C8;}\n\t.st182{fill:#C0C6C9;}\n\t.st183{fill:#C1C7CA;}\n\t.st184{fill:#C2C8CA;}\n\t.st185{fill:#C3C9CB;}\n\t.st186{fill:#C4C9CC;}\n\t.st187{fill:#C5CACD;}\n\t.st188{fill:#C6CBCE;}\n\t.st189{fill:#C7CCCF;}\n\t.st190{fill:#C8CDD0;}\n\t.st191{fill:#C9CED1;}\n\t.st192{fill:#CBCFD1;}\n\t.st193{fill:#CCD0D2;}\n\t.st194{fill:#CDD1D3;}\n\t.st195{fill:#CED2D4;}\n\t.st196{fill:#CFD3D5;}\n\t.st197{fill:#D0D4D6;}\n\t.st198{fill:#D1D4D7;}\n\t.st199{fill:#D2D5D8;}\n\t.st200{fill:#D3D6D8;}\n\t.st201{fill:#D4D7D9;}\n\t.st202{fill:#D5D8DA;}\n\t.st203{fill:#D6D9DB;}\n\t.st204{fill:#D7DADC;}\n\t.st205{fill:#D8DBDD;}\n\t.st206{fill:#D9DCDE;}\n\t.st207{fill:#DADDDF;}\n\t.st208{fill:#DBDEE0;}\n\t.st209{fill:#DCDFE1;}\n\t.st210{fill:#DDE0E2;}\n\t.st211{fill:#DFE2E3;}\n\t.st212{fill:#E0E3E4;}\n\t.st213{fill:#E1E4E5;}\n\t.st214{fill:#E2E5E6;}\n\t.st215{fill:#E3E6E7;}\n\t.st216{fill:#E4E7E8;}\n\t.st217{fill:#E5E8E9;}\n\t.st218{fill:#E6E9EA;}\n\t.st219{fill:#E7EAEB;}\n\t.st220{fill:#E8EBEC;}\n\t.st221{fill:#EAECED;}\n\t.st222{fill:#EBEDEE;}\n\t.st223{fill:#ECEEEF;}\n\t.st224{fill:#E9EBED;}\n\t.st225{fill:#E8EAEC;}\n\t.st226{fill:#E7E9EB;}\n\t.st227{fill:#E6E8EA;}\n\t.st228{fill:#E5E7E9;}\n\t.st229{fill:#E4E6E8;}\n\t.st230{fill:#E3E5E7;}\n\t.st231{fill:#E2E4E6;}\n\t.st232{fill:#DEE1E2;}\n\t.st233{fill:#DDE0E1;}\n\t.st234{fill:#DCDFE0;}\n\t.st235{fill:#DBDEDF;}\n\t.st236{fill:#DADDDE;}\n\t.st237{fill:#D9DCDD;}\n\t.st238{fill:#D8DBDC;}\n\t.st239{fill:#D7DADB;}\n\t.st240{fill:#D6D9DA;}\n\t.st241{fill:#D5D8D9;}\n\t.st242{fill:#D4D7D8;}\n\t.st243{fill:#D3D6D7;}\n\t.st244{fill:#D2D5D6;}\n\t.st245{fill:#D1D4D5;}\n\t.st246{fill:#D0D3D4;}\n\t.st247{fill:#CFD2D3;}\n\t.st248{fill:#CED1D2;}\n\t.st249{fill:#CDD0D1;}\n\t.st250{fill:#CCCFD0;}\n\t.st251{fill:#CBCDCF;}\n\t.st252{fill:#CACCCE;}\n\t.st253{fill:#C9CBCD;}\n\t.st254{fill:#C8CACC;}\n\t.st255{fill:#C7C9CB;}\n\t.st256{fill:#C6C8CA;}\n\t.st257{fill:#C5C7C9;}\n\t.st258{fill:#C4C6C8;}\n\t.st259{fill:#C3C5C7;}\n\t.st260{fill:#C2C4C6;}\n\t.st261{fill:#C1C3C5;}\n\t.st262{fill:#C0C2C4;}\n\t.st263{fill:#BFC1C3;}\n\t.st264{fill:#BEC0C2;}\n\t.st265{fill:#BDBFC1;}\n\t.st266{fill:#BCBEC0;}\n\t.st267{fill:#BBBDBF;}\n\t.st268{fill:#BABCBE;}\n\t.st269{fill:#B9BBBD;}\n\t.st270{fill:#B8BABC;}\n\t.st271{fill:#B7B9BB;}\n\t.st272{fill:#B6B8BA;}\n\t.st273{fill:#B5B7B9;}\n\t.st274{fill:#B3B6B7;}\n\t.st275{fill:#B2B5B6;}\n\t.st276{fill:#B1B4B5;}\n\t.st277{fill:#B0B3B4;}\n\t.st278{fill:#AFB2B3;}\n\t.st279{fill:#AEB1B2;}\n\t.st280{fill:#ADB0B1;}\n\t.st281{fill:#ACAFB0;}\n\t.st282{clip-path:url(#SVGID_00000159437003963867373430000016332953835967931265_);}\n\t.st283{fill:#BDC0C2;}\n\t.st284{fill:#BCBFC1;}\n\t.st285{fill:#BBBEC0;}\n\t.st286{fill:#BABDBF;}\n\t.st287{fill:#B9BCBE;}\n\t.st288{fill:#B8BBBD;}\n\t.st289{fill:#B7BABC;}\n\t.st290{fill:#B6B9BB;}\n\t.st291{fill:#B5B8BA;}\n\t.st292{fill:#B4B7B9;}\n\t.st293{fill:#B3B6B8;}\n\t.st294{fill:#B2B5B7;}\n\t.st295{fill:#B1B4B6;}\n\t.st296{fill:#B0B3B5;}\n\t.st297{fill:#AFB2B4;}\n\t.st298{fill:#AEB1B3;}\n\t.st299{fill:#ADB0B2;}\n\t.st300{fill:#ADAFB1;}\n\t.st301{fill:#ACAEB0;}\n\t.st302{fill:#ABADAF;}\n\t.st303{fill:#AAACAE;}\n\t.st304{fill:#A9ABAD;}\n\t.st305{fill:#A8AAAC;}\n\t.st306{fill:#A7A9AB;}\n\t.st307{fill:#A6A8AA;}\n\t.st308{fill:#A5A7A9;}\n\t.st309{fill:#A4A6A8;}\n\t.st310{fill:#A3A5A7;}\n\t.st311{fill:#A2A4A6;}\n\t.st312{fill:#A1A3A5;}\n\t.st313{fill:#A0A2A4;}\n\t.st314{fill:#9FA1A3;}\n\t.st315{fill:#9EA0A2;}\n\t.st316{fill:#9D9FA1;}\n\t.st317{fill:#9C9EA0;}\n\t.st318{fill:#9B9D9F;}\n\t.st319{fill:#9A9C9E;}\n\t.st320{fill:#999B9D;}\n\t.st321{fill:#989A9C;}\n\t.st322{fill:#97999B;}\n\t.st323{fill:#96989A;}\n\t.st324{fill:#959799;}\n\t.st325{fill:#949698;}\n\t.st326{fill:#939597;}\n\t.st327{fill:#929496;}\n\t.st328{fill:#919395;}\n\t.st329{fill:#909294;}\n\t.st330{fill:#8F9193;}\n\t.st331{fill:#8E9092;}\n\t.st332{fill:#8D8F91;}\n\t.st333{fill:#8D8E90;}\n\t.st334{fill:#8C8D8E;}\n\t.st335{fill:#8B8C8D;}\n\t.st336{fill:#8A8B8C;}\n\t.st337{fill:#898A8B;}\n\t.st338{fill:#88898A;}\n\t.st339{fill:#878889;}\n\t.st340{fill:#868788;}\n\t.st341{fill:#858687;}\n\t.st342{fill:#848586;}\n\t.st343{fill:#838485;}\n\t.st344{fill:#828384;}\n\t.st345{fill:#818283;}\n\t.st346{fill:#808182;}\n\t.st347{fill:#7F8081;}\n\t.st348{fill:#7E7F80;}\n\t.st349{fill:#7D7E7F;}\n\t.st350{fill:#7C7D7E;}\n\t.st351{fill:#7B7C7D;}\n\t.st352{fill:#7A7B7C;}\n\t.st353{fill:#797A7B;}\n\t.st354{fill:#78797A;}\n\t.st355{fill:#777879;}\n\t.st356{fill:#767778;}\n\t.st357{fill:#757677;}\n\t.st358{fill:#747576;}\n\t.st359{fill:#737475;}\n\t.st360{fill:#727374;}\n\t.st361{fill:#717273;}\n\t.st362{fill:#707172;}\n\t.st363{fill:#6F7071;}\n\t.st364{fill:#6E6F70;}\n\t.st365{fill:#6D6E6F;}\n\t.st366{fill:#6C6D6E;}\n\t.st367{fill:#6C6C6D;}\n\t.st368{fill:#6B6B6C;}\n\t.st369{fill:#6A6A6B;}\n\t.st370{fill:#69696A;}\n\t.st371{fill:#686869;}\n\t.st372{fill:#676768;}\n\t.st373{fill:#666667;}\n\t.st374{fill:#656566;}\n\t.st375{fill:#646465;}\n\t.st376{fill:#636364;}\n\t.st377{fill:#626263;}\n\t.st378{fill:#616162;}\n\t.st379{fill:#606061;}\n\t.st380{fill:#5F5F60;}\n\t.st381{fill:#5E5E5F;}\n\t.st382{fill:#5D5D5E;}\n\t.st383{fill:#5C5C5D;}\n\t.st384{fill:#6D6D6E;}\n\t.st385{fill:#6E6E6F;}\n\t.st386{fill:#707071;}\n\t.st387{fill:#717172;}\n\t.st388{fill:#727273;}\n\t.st389{fill:#737374;}\n\t.st390{fill:#747475;}\n\t.st391{fill:#757576;}\n\t.st392{fill:#767677;}\n\t.st393{fill:#777778;}\n\t.st394{fill:#787879;}\n\t.st395{fill:#79797A;}\n\t.st396{fill:#7A7A7B;}\n\t.st397{fill:#7B7B7C;}\n\t.st398{fill:#7C7C7D;}\n\t.st399{fill:#7D7D7E;}\n\t.st400{fill:#7E7E7F;}\n\t.st401{fill:#7F7F80;}\n\t.st402{fill:#808081;}\n\t.st403{fill:#818182;}\n\t.st404{fill:#828284;}\n\t.st405{fill:#838385;}\n\t.st406{fill:#848486;}\n\t.st407{fill:#858587;}\n\t.st408{fill:#868688;}\n\t.st409{fill:#878789;}\n\t.st410{fill:#88888A;}\n\t.st411{fill:#89898B;}\n\t.st412{fill:#8A8A8C;}\n\t.st413{fill:#8B8B8D;}\n\t.st414{fill:#8C8C8E;}\n\t.st415{fill:#8D8D8F;}\n\t.st416{fill:#8E8E90;}\n\t.st417{fill:#8F8F91;}\n\t.st418{fill:#909092;}\n\t.st419{fill:#919193;}\n\t.st420{fill:#929294;}\n\t.st421{fill:#939395;}\n\t.st422{fill:#949496;}\n\t.st423{fill:#959597;}\n\t.st424{fill:#969698;}\n\t.st425{fill:#979799;}\n\t.st426{fill:#98989A;}\n\t.st427{fill:#99999B;}\n\t.st428{fill:#9B9B9D;}\n\t.st429{fill:#9C9C9E;}\n\t.st430{fill:#9D9D9F;}\n\t.st431{fill:#9E9EA0;}\n\t.st432{fill:#9F9FA1;}\n\t.st433{fill:#A0A0A2;}\n\t.st434{fill:#A1A1A3;}\n\t.st435{fill:#A2A2A4;}\n\t.st436{fill:#A3A3A5;}\n\t.st437{fill:#A4A4A6;}\n\t.st438{fill:#A5A5A7;}\n\t.st439{fill:#A6A6A8;}\n\t.st440{fill:#A7A7A9;}\n\t.st441{fill:#A8A8AA;}\n\t.st442{fill:#A9A9AB;}\n\t.st443{fill:#AAAAAC;}\n\t.st444{fill:#ABABAD;}\n\t.st445{fill:#ACACAE;}\n\t.st446{fill:#ADADAF;}\n\t.st447{fill:#AEAEB0;}\n\t.st448{fill:#AFAFB1;}\n\t.st449{fill:#B0B0B2;}\n\t.st450{fill:#B1B1B3;}\n\t.st451{fill:#B2B2B4;}\n\t.st452{fill:#B3B3B5;}\n\t.st453{fill:#B4B4B6;}\n\t.st454{fill:#B6B6B8;}\n\t.st455{fill:#B7B7B9;}\n\t.st456{fill:#B8B8BA;}\n\t.st457{fill:#B9B9BB;}\n\t.st458{fill:#BABABC;}\n\t.st459{fill:#BBBBBD;}\n\t.st460{fill:#BCBCBE;}\n\t.st461{fill:#BDBDBF;}\n\t.st462{fill:#BEBEC0;}\n\t.st463{fill:#BFBFC1;}\n\t.st464{fill:#C0C0C2;}\n\t.st465{fill:#C1C1C3;}\n\t.st466{fill:#C2C2C4;}\n\t.st467{fill:#C3C3C5;}\n\t.st468{clip-path:url(#SVGID_00000152238522399415410270000002770448319223584429_);}\n\t.st469{fill:#94979A;}\n\t.st470{fill:#939699;}\n\t.st471{fill:#929598;}\n\t.st472{fill:#919497;}\n\t.st473{fill:#909396;}\n\t.st474{fill:#8F9295;}\n\t.st475{fill:#8E9194;}\n\t.st476{fill:#8D9093;}\n\t.st477{fill:#8C8F92;}\n\t.st478{fill:#8B8E91;}\n\t.st479{fill:#8A8D90;}\n\t.st480{fill:#898C8F;}\n\t.st481{fill:#888B8E;}\n\t.st482{fill:#878A8D;}\n\t.st483{fill:#86898C;}\n\t.st484{fill:#85888B;}\n\t.st485{fill:#84878A;}\n\t.st486{fill:#838689;}\n\t.st487{fill:#838587;}\n\t.st488{fill:#828486;}\n\t.st489{fill:#818385;}\n\t.st490{fill:#808284;}\n\t.st491{fill:#7F8183;}\n\t.st492{fill:#7E8082;}\n\t.st493{fill:#7D7F81;}\n\t.st494{fill:#7C7E80;}\n\t.st495{fill:#7B7D7F;}\n\t.st496{fill:#7A7C7E;}\n\t.st497{fill:#797B7D;}\n\t.st498{fill:#787A7C;}\n\t.st499{fill:#77797B;}\n\t.st500{fill:#76787A;}\n\t.st501{fill:#757779;}\n\t.st502{fill:#747678;}\n\t.st503{fill:#737577;}\n\t.st504{fill:#727476;}\n\t.st505{fill:#717375;}\n\t.st506{fill:#707274;}\n\t.st507{fill:#6F7173;}\n\t.st508{fill:#6E7072;}\n\t.st509{fill:#6D6F71;}\n\t.st510{fill:#6C6E70;}\n\t.st511{fill:#6B6D6F;}\n\t.st512{fill:#6B6B6D;}\n\t.st513{fill:#6A6A6C;}\n\t.st514{fill:#69696B;}\n\t.st515{fill:#68686A;}\n\t.st516{fill:#676769;}\n\t.st517{fill:#666668;}\n\t.st518{fill:#656567;}\n\t.st519{fill:#646466;}\n\t.st520{fill:#636365;}\n\t.st521{fill:#626264;}\n\t.st522{fill:#616163;}\n\t.st523{fill:#606062;}\n\t.st524{fill:#5F5F61;}\n\t.st525{clip-path:url(#SVGID_00000163068842578020936900000005617623598039467140_);}\n\t.st526{fill:#394148;}\n\t.st527{fill:#394047;}\n\t.st528{fill:#383F46;}\n\t.st529{fill:#383F45;}\n\t.st530{fill:#373E44;}\n\t.st531{fill:#373D43;}\n\t.st532{fill:#363C42;}\n\t.st533{fill:#363C41;}\n\t.st534{fill:#363B3F;}\n\t.st535{fill:#353A3E;}\n\t.st536{fill:#35393D;}\n\t.st537{fill:#34383C;}\n\t.st538{fill:#34383B;}\n\t.st539{fill:#33373A;}\n\t.st540{fill:#333639;}\n\t.st541{fill:#333538;}\n\t.st542{fill:#323437;}\n\t.st543{fill:#323436;}\n\t.st544{fill:#323334;}\n\t.st545{fill:#313233;}\n\t.st546{fill:#313132;}\n\t.st547{clip-path:url(#SVGID_00000091012707789440731210000000645585638882169758_);}\n\t.st548{fill:#505152;}\n\t.st549{fill:#515253;}\n\t.st550{fill:#525354;}\n\t.st551{fill:#535455;}\n\t.st552{fill:#545556;}\n\t.st553{fill:#555657;}\n\t.st554{fill:#565758;}\n\t.st555{fill:#575859;}\n\t.st556{fill:#58595A;}\n\t.st557{fill:#595A5B;}\n\t.st558{fill:#5A5B5C;}\n\t.st559{fill:#5B5C5D;}\n\t.st560{fill:#5C5D5E;}\n\t.st561{fill:#5E5E60;}\n\t.st562{fill:#6C6C6E;}\n\t.st563{fill:#6D6D6F;}\n\t.st564{fill:#6E6E70;}\n\t.st565{fill:#6F6F71;}\n\t.st566{fill:#707072;}\n\t.st567{fill:#717173;}\n\t.st568{fill:#727274;}\n\t.st569{fill:#737375;}\n\t.st570{fill:#747476;}\n\t.st571{fill:#757577;}\n\t.st572{fill:#767678;}\n\t.st573{fill:#77797A;}\n\t.st574{fill:#787A7B;}\n\t.st575{fill:#797B7C;}\n\t.st576{fill:#7A7C7D;}\n\t.st577{fill:#7B7D7E;}\n\t.st578{fill:#7C7E7F;}\n\t.st579{fill:#7D7F80;}\n\t.st580{fill:#7E8081;}\n\t.st581{fill:#7F8182;}\n\t.st582{fill:#808283;}\n\t.st583{fill:#818384;}\n\t.st584{fill:#828485;}\n\t.st585{fill:#838586;}\n\t.st586{fill:#848687;}\n\t.st587{fill:#858788;}\n\t.st588{fill:#868889;}\n\t.st589{fill:#87898A;}\n\t.st590{fill:#888A8B;}\n\t.st591{fill:#898B8C;}\n\t.st592{fill:#8A8C8D;}\n\t.st593{fill:#8B8D8E;}\n\t.st594{fill:#8C8E8F;}\n\t.st595{fill:#8D8F90;}\n\t.st596{fill:#8E9091;}\n\t.st597{fill:#8F9192;}\n\t.st598{fill:#909293;}\n\t.st599{fill:#919394;}\n\t.st600{fill:#929495;}\n\t.st601{fill:#939596;}\n\t.st602{fill:#949697;}\n\t.st603{fill:#959798;}\n\t.st604{fill:#969899;}\n\t.st605{fill:#97999A;}\n\t.st606{fill:#989A9B;}\n\t.st607{fill:#999B9C;}\n\t.st608{fill:#9A9C9D;}\n\t.st609{fill:#9B9D9E;}\n\t.st610{fill:#9C9FA1;}\n\t.st611{fill:#9DA0A2;}\n\t.st612{fill:#9EA1A3;}\n\t.st613{fill:#9FA2A4;}\n\t.st614{fill:#A0A3A5;}\n\t.st615{fill:#A1A4A6;}\n\t.st616{fill:#A2A5A7;}\n\t.st617{fill:#A3A6A8;}\n\t.st618{fill:#A4A7A9;}\n\t.st619{fill:#A5A8AA;}\n\t.st620{fill:#A6A9AB;}\n\t.st621{fill:#A7AAAC;}\n\t.st622{fill:#A8ABAD;}\n\t.st623{fill:#A9ACAE;}\n\t.st624{fill:#AAADAF;}\n\t.st625{fill:#ABAEB0;}\n\t.st626{fill:#ACAFB1;}\n\t.st627{clip-path:url(#SVGID_00000082353680994633969450000011395290940344589743_);}\n\t.st628{fill:#6F7677;}\n\t.st629{fill:#707778;}\n\t.st630{fill:#717879;}\n\t.st631{fill:#72797A;}\n\t.st632{fill:#737A7B;}\n\t.st633{fill:#747B7C;}\n\t.st634{fill:#757C7D;}\n\t.st635{fill:#767D7E;}\n\t.st636{fill:#787E7F;}\n\t.st637{fill:#797F80;}\n\t.st638{fill:#7A8081;}\n\t.st639{fill:#7B8182;}\n\t.st640{fill:#7C8283;}\n\t.st641{fill:#7D8384;}\n\t.st642{fill:#7E8485;}\n\t.st643{fill:#7F8586;}\n\t.st644{fill:#808687;}\n\t.st645{fill:#818788;}\n\t.st646{fill:#828889;}\n\t.st647{fill:#83898A;}\n\t.st648{fill:#848A8B;}\n\t.st649{fill:#858B8C;}\n\t.st650{fill:#868C8D;}\n\t.st651{fill:#878D8E;}\n\t.st652{fill:#888E8F;}\n\t.st653{fill:#898F90;}\n\t.st654{fill:#8A9091;}\n\t.st655{fill:#8B9192;}\n\t.st656{fill:#8C9293;}\n\t.st657{fill:#8D9394;}\n\t.st658{fill:#8E9495;}\n\t.st659{fill:#909596;}\n\t.st660{fill:#919596;}\n\t.st661{fill:#929697;}\n\t.st662{fill:#939798;}\n\t.st663{fill:#949899;}\n\t.st664{fill:#95999A;}\n\t.st665{fill:#969A9B;}\n\t.st666{fill:#979B9C;}\n\t.st667{fill:#989C9D;}\n\t.st668{fill:#999D9E;}\n\t.st669{fill:#9A9E9F;}\n\t.st670{fill:#9B9FA0;}\n\t.st671{fill:#9CA0A1;}\n\t.st672{fill:#9DA1A2;}\n\t.st673{fill:#9EA2A3;}\n\t.st674{fill:#9FA3A4;}\n\t.st675{fill:#A0A4A5;}\n\t.st676{fill:#A1A5A6;}\n\t.st677{fill:#A2A6A7;}\n\t.st678{fill:#A3A7A8;}\n\t.st679{fill:#A4A8A9;}\n\t.st680{fill:#A6A9AA;}\n\t.st681{fill:#A7AAAB;}\n\t.st682{fill:#A8ABAC;}\n\t.st683{fill:#A9ACAD;}\n\t.st684{fill:#AAADAE;}\n\t.st685{fill:#ABAEAF;}\n\t.st686{fill:#7A7F83;}\n\t.st687{fill:#7A7F84;}\n\t.st688{fill:#7B8085;}\n\t.st689{fill:#7C8186;}\n\t.st690{fill:#7D8287;}\n\t.st691{fill:#7E8388;}\n\t.st692{fill:#7F8489;}\n\t.st693{fill:#80858A;}\n\t.st694{fill:#81868B;}\n\t.st695{fill:#82878C;}\n\t.st696{fill:#83888D;}\n\t.st697{fill:none;}\n\t.st698{clip-path:url(#SVGID_00000175323439746788537720000009839892378989829807_);}\n\t.st699{fill:#E2E5E7;}\n\t.st700{fill:#E3E6E8;}\n\t.st701{fill:#E4E7E9;}\n\t.st702{fill:#E5E8EA;}\n\t.st703{fill:#E6E9EB;}\n\t.st704{fill:#E9ECED;}\n\t.st705{fill:#EAEDEE;}\n\t.st706{fill:#EBEEEF;}\n\t.st707{fill:#ECEFF0;}\n\t.st708{fill:#EDF0F1;}\n\t.st709{fill:#EEF1F2;}\n\t.st710{fill:#EFF2F3;}\n\t.st711{fill:#F1F2F3;}\n\t.st712{fill:#F2F3F4;}\n\t.st713{fill:#F3F4F5;}\n\t.st714{fill:#F4F5F6;}\n\t.st715{fill:#F5F6F7;}\n\t.st716{fill:#F6F7F8;}\n\t.st717{fill:#F7F8F9;}\n\t.st718{fill:#F8F9FA;}\n\t.st719{fill:#F9FAFB;}\n\t.st720{fill:#FAFBFB;}\n\t.st721{fill:#FBFCFC;}\n\t.st722{fill:#FCFDFD;}\n\t.st723{fill:#FDFEFE;}\n\t.st724{fill:#FEFFFF;}\n\t.st725{clip-path:url(#SVGID_00000065045991016981123710000007053461785249281937_);}\n\t.st726{fill:#9DA1A4;}\n\t.st727{fill:#9CA0A3;}\n\t.st728{fill:#9B9FA2;}\n\t.st729{fill:#9A9EA1;}\n\t.st730{fill:#999DA0;}\n\t.st731{fill:#8D9194;}\n\t.st732{fill:#8C9093;}\n\t.st733{fill:#8B8F92;}\n\t.st734{fill:#8A8E91;}\n\t.st735{fill:#898D90;}\n\t.st736{fill:#888C8F;}\n\t.st737{fill:#878B8E;}\n\t.st738{fill:#86898E;}\n\t.st739{fill:#85888D;}\n\t.st740{fill:#84878C;}\n\t.st741{fill:#83868B;}\n\t.st742{fill:#82858A;}\n\t.st743{fill:#818489;}\n\t.st744{fill:#808388;}\n\t.st745{fill:#7F8287;}\n\t.st746{fill:#7E8186;}\n\t.st747{fill:#7D8085;}\n\t.st748{fill:#7C7F84;}\n\t.st749{fill:#7B7E83;}\n\t.st750{fill:#7A7D82;}\n\t.st751{fill:#797C81;}\n\t.st752{fill:#787B80;}\n\t.st753{fill:#777A7F;}\n\t.st754{fill:#76797E;}\n\t.st755{fill:#75787D;}\n\t.st756{fill:#74777C;}\n\t.st757{fill:#73767B;}\n\t.st758{fill:#72757A;}\n\t.st759{fill:#717479;}\n\t.st760{fill:#707378;}\n\t.st761{clip-path:url(#SVGID_00000158718607587692091130000017282703886259844759_);}\n\t.st762{fill:#C1C6CB;}\n\t.st763{fill:#C2C7CC;}\n\t.st764{fill:#C3C8CD;}\n\t.st765{fill:#C4C9CD;}\n\t.st766{fill:#C5CACE;}\n\t.st767{fill:#C6CBCF;}\n\t.st768{fill:#C7CCD0;}\n\t.st769{fill:#C8CDD1;}\n\t.st770{fill:#CACFD2;}\n\t.st771{fill:#CBD0D3;}\n\t.st772{fill:#CCD1D4;}\n\t.st773{fill:#CDD2D5;}\n\t.st774{fill:#CFD3D6;}\n\t.st775{fill:#D1D5D7;}\n\t.st776{fill:#D2D6D8;}\n\t.st777{fill:#D3D7D9;}\n\t.st778{fill:#D4D8DA;}\n\t.st779{fill:#D5D9DA;}\n\t.st780{fill:#D6DADB;}\n\t.st781{fill:#D7DBDC;}\n\t.st782{fill:#D8DCDD;}\n\t.st783{fill:#D9DDDE;}\n\t.st784{fill:#DADEDE;}\n\t.st785{fill:#DBDFDF;}\n\t.st786{fill:#DCE0E0;}\n\t.st787{clip-path:url(#SVGID_00000119077845201714430150000005874021675314124952_);}\n\t.st788{fill:#B2B4B6;}\n\t.st789{fill:#B1B3B4;}\n\t.st790{fill:#B0B2B3;}\n\t.st791{fill:#AFB1B2;}\n\t.st792{fill:#AEB0B1;}\n\t.st793{fill:#ADAFB0;}\n\t.st794{fill:#ACAEAF;}\n\t.st795{fill:#ABADAE;}\n\t.st796{fill:#AAACAD;}\n\t.st797{fill:#A9ABAC;}\n\t.st798{fill:#A8AAAB;}\n\t.st799{fill:#A7A9AA;}\n\t.st800{fill:#A6A8A9;}\n\t.st801{fill:#A5A7A8;}\n\t.st802{fill:#A4A6A7;}\n\t.st803{fill:#A3A5A6;}\n\t.st804{fill:#A2A4A5;}\n\t.st805{fill:#9A9A9C;}\n\t.st806{fill:#959596;}\n\t.st807{fill:#949495;}\n\t.st808{fill:#939394;}\n\t.st809{clip-path:url(#SVGID_00000163058644250171871830000005520022492184791960_);}\n\t.st810{fill:#5A6066;}\n\t.st811{fill:#595F65;}\n\t.st812{fill:#585E64;}\n\t.st813{fill:#585D63;}\n\t.st814{fill:#575C62;}\n\t.st815{fill:#565B61;}\n\t.st816{fill:#555A60;}\n\t.st817{fill:#545A5F;}\n\t.st818{fill:#54595E;}\n\t.st819{fill:#53585D;}\n\t.st820{fill:#52575C;}\n\t.st821{fill:#51565B;}\n\t.st822{fill:#50555A;}\n\t.st823{fill:#505458;}\n\t.st824{fill:#4F5357;}\n\t.st825{fill:#4E5256;}\n\t.st826{fill:#4D5155;}\n\t.st827{fill:#4C5054;}\n\t.st828{fill:#4C4F53;}\n\t.st829{fill:#4B4F52;}\n\t.st830{fill:#4A4E51;}\n\t.st831{fill:#494D50;}\n\t.st832{fill:#484C4F;}\n\t.st833{fill:#484B4E;}\n\t.st834{fill:#474A4D;}\n\t.st835{fill:#46494C;}\n\t.st836{fill:#45484B;}\n\t.st837{fill:#44474A;}\n\t.st838{fill:#434649;}\n\t.st839{fill:#424548;}\n\t.st840{fill:#424447;}\n\t.st841{fill:#414346;}\n\t.st842{fill:#404245;}\n\t.st843{fill:#3F4144;}\n\t.st844{fill:#3E4043;}\n\t.st845{fill:#3D3F41;}\n\t.st846{fill:#3C3E40;}\n\t.st847{fill:#3B3D3F;}\n\t.st848{fill:#3A3C3E;}\n\t.st849{fill:#3A3B3D;}\n\t.st850{fill:#393A3C;}\n\t.st851{fill:#38393B;}\n\t.st852{fill:#37383A;}\n\t.st853{fill:#363739;}\n\t.st854{fill:#353638;}\n\t.st855{fill:#343537;}\n\t.st856{fill:#343436;}\n\t.st857{fill:#333334;}\n\t.st858{fill:#323233;}\n\t.st859{clip-path:url(#SVGID_00000020388667241716765040000010243575329122123448_);}\n\t.st860{clip-path:url(#SVGID_00000012449853859860894040000012571027975067293354_);}\n\t.st861{fill:#F9FAFA;}\n\t.st862{fill:#F8F9F9;}\n\t.st863{fill:#F7F8F8;}\n\t.st864{fill:#F6F7F7;}\n\t.st865{fill:#F5F6F6;}\n\t.st866{fill:#F4F5F5;}\n\t.st867{fill:#F3F4F4;}\n\t.st868{fill:#F0F1F3;}\n\t.st869{fill:#EFF0F2;}\n\t.st870{fill:#EEEFF1;}\n\t.st871{fill:#EDEEF0;}\n\t.st872{fill:#ECEDEF;}\n\t.st873{fill:#EBECEE;}\n\t.st874{fill:#EAEBED;}\n\t.st875{fill:#E9EAEC;}\n\t.st876{fill:#E8E9EB;}\n\t.st877{fill:#E7E8EA;}\n\t.st878{fill:#E7E9EA;}\n\t.st879{fill:#E8EAEB;}\n\t.st880{fill:#E9EBEC;}\n\t.st881{fill:#EDEFF0;}\n\t.st882{fill:#EEF0F1;}\n\t.st883{fill:#EFF1F2;}\n\t.st884{fill:#FAFBFC;}\n\t.st885{fill:#F4F6F6;}\n\t.st886{fill:#F3F5F6;}\n\t.st887{fill:#F2F4F5;}\n\t.st888{fill:#F1F3F4;}\n\t.st889{fill:#F0F2F3;}\n\t.st890{fill:#EBEDEF;}\n\t.st891{fill:#EAECEE;}\n\t.st892{fill:#E4E6E9;}\n\t.st893{fill:#E3E5E8;}\n\t.st894{fill:#E2E4E7;}\n\t.st895{fill:#E1E4E6;}\n\t.st896{fill:#DFE3E5;}\n\t.st897{fill:#DEE2E4;}\n\t.st898{fill:#DDE1E3;}\n\t.st899{fill:#DCE0E3;}\n\t.st900{fill:#DBDFE2;}\n\t.st901{fill:#DADEE1;}\n\t.st902{fill:#D9DDE0;}\n\t.st903{fill:#D8DCDF;}\n\t.st904{fill:#D7DBDE;}\n\t.st905{fill:#D6DADD;}\n\t.st906{fill:#D5D9DD;}\n\t.st907{fill:#D4D8DC;}\n\t.st908{fill:#D3D7DB;}\n\t.st909{fill:#D2D6DA;}\n\t.st910{fill:#D1D5D9;}\n\t.st911{fill:#D0D4D8;}\n\t.st912{fill:#CFD3D7;}\n\t.st913{fill:#CED2D6;}\n\t.st914{fill:#CDD1D6;}\n\t.st915{fill:#CCD1D5;}\n\t.st916{fill:#CBD0D4;}\n\t.st917{fill:#CACFD3;}\n\t.st918{fill:#C9CED2;}\n\t.st919{fill:#C6CBD0;}\n\t.st920{fill:#C5CACF;}\n\t.st921{fill:#C4C9CE;}\n\t.st922{fill:#C0C5CA;}\n\t.st923{fill:#BFC4C9;}\n\t.st924{fill:#BEC3C8;}\n\t.st925{fill:#BDC2C7;}\n\t.st926{fill:#BCC1C5;}\n\t.st927{fill:#BBC0C4;}\n\t.st928{fill:#BABFC3;}\n\t.st929{fill:#B9BEC2;}\n\t.st930{fill:#B8BDC1;}\n\t.st931{fill:#B7BCC0;}\n\t.st932{fill:#B6BBBF;}\n\t.st933{fill:#B5BABE;}\n\t.st934{fill:#B4B9BD;}\n\t.st935{fill:#B3B8BC;}\n\t.st936{fill:#B2B7BB;}\n\t.st937{fill:#B1B6BA;}\n\t.st938{fill:#B0B5B9;}\n\t.st939{fill:#AFB4B8;}\n\t.st940{fill:#AEB3B7;}\n\t.st941{fill:#A6ACB0;}\n\t.st942{fill:#A5ABAF;}\n\t.st943{fill:#A4AAAE;}\n\t.st944{fill:#A3A9AD;}\n\t.st945{fill:#A2A8AC;}\n\t.st946{fill:#A1A7AB;}\n\t.st947{fill:#A0A6AA;}\n\t.st948{fill:#9FA5A9;}\n\t.st949{fill:#9EA4A8;}\n\t.st950{fill:#9DA3A7;}\n\t.st951{fill:#9CA2A6;}\n\t.st952{fill:#9BA1A5;}\n\t.st953{fill:#9AA0A4;}\n\t.st954{fill:#999FA3;}\n\t.st955{fill:#989EA2;}\n\t.st956{fill:#979DA1;}\n\t.st957{fill:#969CA0;}\n\t.st958{fill:#959B9F;}\n\t.st959{fill:#949A9E;}\n\t.st960{fill:#93999D;}\n\t.st961{fill:#92989C;}\n\t.st962{fill:#91979B;}\n\t.st963{fill:#90969A;}\n\t.st964{fill:#8F9599;}\n\t.st965{fill:#8E9498;}\n\t.st966{fill:#8D9397;}\n\t.st967{fill:#8C9296;}\n\t.st968{fill:#8B9195;}\n\t.st969{fill:#8A9094;}\n\t.st970{fill:#898F93;}\n\t.st971{fill:#888E92;}\n\t.st972{fill:#878D91;}\n\t.st973{fill:#868C90;}\n\t.st974{fill:#858B8F;}\n\t.st975{fill:#848A8E;}\n\t.st976{fill:#83898D;}\n\t.st977{fill:#82888C;}\n\t.st978{fill:#81878B;}\n\t.st979{fill:#80868A;}\n\t.st980{fill:#7F8589;}\n\t.st981{fill:#7E8488;}\n\t.st982{fill:#7D8386;}\n\t.st983{fill:#7C8285;}\n\t.st984{fill:#7B8184;}\n\t.st985{fill:#7A8083;}\n\t.st986{fill:#797F82;}\n\t.st987{fill:#787E81;}\n\t.st988{fill:#777D80;}\n\t.st989{fill:#767C7F;}\n\t.st990{fill:#757B7E;}\n\t.st991{fill:#747A7D;}\n\t.st992{fill:#73797C;}\n\t.st993{fill:#72787B;}\n\t.st994{fill:#71777A;}\n\t.st995{fill:#707679;}\n\t.st996{fill:#6F7578;}\n\t.st997{fill:#6E7477;}\n\t.st998{fill:#6D7376;}\n\t.st999{fill:#6C7275;}\n\t.st1000{fill:#6B7174;}\n\t.st1001{fill:#6A7073;}\n\t.st1002{fill:#696F72;}\n\t.st1003{fill:#686E71;}\n\t.st1004{fill:#676D70;}\n\t.st1005{fill:#666C6F;}\n\t.st1006{fill:#656B6E;}\n\t.st1007{fill:#646A6D;}\n\t.st1008{fill:#63696C;}\n\t.st1009{fill:#62686B;}\n\t.st1010{fill:#61676A;}\n\t.st1011{fill:#606669;}\n\t.st1012{fill:#5F6568;}\n\t.st1013{fill:#5E6467;}\n\t.st1014{fill:#5D6366;}\n\t.st1015{fill:#5C6265;}\n\t.st1016{fill:#5B6164;}\n\t.st1017{fill:#5A6063;}\n\t.st1018{fill:#595F62;}\n\t.st1019{fill:#585E61;}\n\t.st1020{fill:#575D60;}\n\t.st1021{fill:#555C5E;}\n\t.st1022{fill:#545B5D;}\n\t.st1023{fill:#535A5C;}\n\t.st1024{fill:#52595B;}\n\t.st1025{fill:#51585A;}\n\t.st1026{fill:#505759;}\n\t.st1027{fill:#4F5658;}\n\t.st1028{fill:#4E5557;}\n\t.st1029{fill:#4D5456;}\n\t.st1030{fill:#4C5355;}\n\t.st1031{fill:#4B5254;}\n\t.st1032{fill:#4A5153;}\n\t.st1033{fill:#495052;}\n\t.st1034{fill:#484F51;}\n\t.st1035{clip-path:url(#SVGID_00000132074007311735583240000011590904869913560213_);}\n\t.st1036{fill:#A0A1A3;}\n\t.st1037{fill:#9FA0A2;}\n\t.st1038{fill:#9E9FA1;}\n\t.st1039{fill:#9D9EA0;}\n\t.st1040{fill:#9C9D9F;}\n\t.st1041{fill:#9B9C9E;}\n\t.st1042{fill:#9A9B9D;}\n\t.st1043{fill:#999A9C;}\n\t.st1044{fill:#98999B;}\n\t.st1045{fill:#97989A;}\n\t.st1046{fill:#969799;}\n\t.st1047{fill:#959698;}\n\t.st1048{fill:#949597;}\n\t.st1049{fill:#939496;}\n\t.st1050{fill:#929395;}\n\t.st1051{fill:#919294;}\n\t.st1052{fill:#909193;}\n\t.st1053{fill:#8F9092;}\n\t.st1054{fill:#8E8F91;}\n\t.st1055{fill:#8C8D8F;}\n\t.st1056{fill:#8B8C8E;}\n\t.st1057{fill:#8A8B8D;}\n\t.st1058{fill:#898A8C;}\n\t.st1059{fill:#89898A;}\n\t.st1060{fill:#888889;}\n\t.st1061{fill:#878788;}\n\t.st1062{fill:#868687;}\n\t.st1063{fill:#858586;}\n\t.st1064{fill:#848485;}\n\t.st1065{fill:#838384;}\n\t.st1066{fill:#828283;}\n\t.st1067{fill:#6F6F70;}\n\t.st1068{fill:#5B5B5C;}\n\t.st1069{fill:#5A5A5B;}\n\t.st1070{fill:#59595A;}\n\t.st1071{fill:#585859;}\n\t.st1072{fill:#575758;}\n\t.st1073{fill:#565657;}\n\t.st1074{fill:#555556;}\n\t.st1075{fill:#545455;}\n\t.st1076{fill:#535354;}\n\t.st1077{fill:#525253;}\n\t.st1078{fill:#515152;}\n\t.st1079{fill:#4C4C4D;}\n\t.st1080{fill:#4B4B4C;}\n\t.st1081{fill:#4A4A4B;}\n\t.st1082{fill:#49494A;}\n\t.st1083{fill:#484849;}\n\t.st1084{fill:#474748;}\n\t.st1085{fill:#464647;}\n\t.st1086{fill:#3C3C3C;}\n\t.st1087{clip-path:url(#SVGID_00000102511045472924616120000005278338938411111866_);}\n\t.st1088{fill:#B4B7B8;}\n\t.st1089{fill:#B5B8B9;}\n\t.st1090{fill:#B6B9BA;}\n\t.st1091{fill:#B7BABB;}\n\t.st1092{fill:#B9BBBC;}\n\t.st1093{fill:#BABCBD;}\n\t.st1094{fill:#BBBDBE;}\n\t.st1095{fill:#BCBEBF;}\n\t.st1096{fill:#BDBFC0;}\n\t.st1097{fill:#BEC0C1;}\n\t.st1098{fill:#BFC1C2;}\n\t.st1099{fill:#C0C2C3;}\n\t.st1100{fill:#C1C3C4;}\n\t.st1101{fill:#C2C4C5;}\n\t.st1102{fill:#C3C5C6;}\n\t.st1103{fill:#C4C6C7;}\n\t.st1104{fill:#C5C7C8;}\n\t.st1105{fill:#C6C8C9;}\n\t.st1106{fill:#C7C9CA;}\n\t.st1107{fill:#C8CACB;}\n\t.st1108{fill:#C9CBCC;}\n\t.st1109{fill:#CACCCD;}\n\t.st1110{fill:#CBCDCE;}\n\t.st1111{fill:#CCCECF;}\n\t.st1112{fill:#CDCFD0;}\n\t.st1113{fill:#CED0D1;}\n\t.st1114{fill:#CFD1D2;}\n\t.st1115{fill:#D0D2D3;}\n\t.st1116{fill:#D1D3D4;}\n\t.st1117{fill:#D2D4D5;}\n\t.st1118{fill:#D3D5D6;}\n\t.st1119{fill:#D4D6D7;}\n\t.st1120{clip-path:url(#SVGID_00000136370177382444171290000007416119498426883458_);}\n\t.st1121{fill:#555658;}\n\t.st1122{fill:#565759;}\n\t.st1123{fill:#57585A;}\n\t.st1124{fill:#58595B;}\n\t.st1125{fill:#595A5C;}\n\t.st1126{fill:#5A5B5D;}\n\t.st1127{fill:#5B5C5E;}\n\t.st1128{fill:#5B5D5F;}\n\t.st1129{fill:#5C5E60;}\n\t.st1130{fill:#5D5F61;}\n\t.st1131{fill:#5E6062;}\n\t.st1132{fill:#5F6164;}\n\t.st1133{fill:#606265;}\n\t.st1134{fill:#616366;}\n\t.st1135{fill:#626467;}\n\t.st1136{fill:#636568;}\n\t.st1137{fill:#636669;}\n\t.st1138{fill:#64676A;}\n\t.st1139{fill:#65686B;}\n\t.st1140{fill:#66696C;}\n\t.st1141{fill:#676A6D;}\n\t.st1142{fill:#686B6E;}\n\t.st1143{fill:#696C6F;}\n\t.st1144{fill:#696D70;}\n\t.st1145{fill:#6A6E71;}\n\t.st1146{fill:#6B6F72;}\n\t.st1147{fill:#6C7073;}\n\t.st1148{fill:#6D7175;}\n\t.st1149{fill:#6D7176;}\n\t.st1150{fill:#6E7277;}\n\t.st1151{fill:#6F7378;}\n\t.st1152{fill:#707479;}\n\t.st1153{fill:#70757A;}\n\t.st1154{fill:#71767B;}\n\t.st1155{fill:#72777C;}\n\t.st1156{clip-path:url(#SVGID_00000067221569690449274670000016190871027650244796_);}\n\t.st1157{fill:#6B7072;}\n\t.st1158{fill:#6C7173;}\n\t.st1159{fill:#6D7274;}\n\t.st1160{fill:#6E7375;}\n\t.st1161{fill:#6F7476;}\n\t.st1162{fill:#707577;}\n\t.st1163{fill:#717678;}\n\t.st1164{fill:#727779;}\n\t.st1165{fill:#73787A;}\n\t.st1166{fill:#74797B;}\n\t.st1167{fill:#757A7C;}\n\t.st1168{fill:#767B7D;}\n\t.st1169{fill:#777C7E;}\n\t.st1170{fill:#787D7F;}\n\t.st1171{fill:#797E7F;}\n\t.st1172{fill:#7A7F80;}\n\t.st1173{fill:#7B8081;}\n\t.st1174{fill:#7C8182;}\n\t.st1175{fill:#7D8283;}\n\t.st1176{fill:#7E8384;}\n\t.st1177{fill:#7F8485;}\n\t.st1178{fill:#808586;}\n\t.st1179{fill:#818687;}\n\t.st1180{fill:#828788;}\n\t.st1181{fill:#838889;}\n\t.st1182{fill:#84898A;}\n\t.st1183{fill:#858A8B;}\n\t.st1184{fill:#868B8C;}\n\t.st1185{fill:#878C8D;}\n\t.st1186{fill:#888D8E;}\n\t.st1187{fill:#898E8F;}\n\t.st1188{fill:#8A8F90;}\n\t.st1189{fill:#8B9091;}\n\t.st1190{fill:#8C9192;}\n\t.st1191{fill:#8D9293;}\n\t.st1192{fill:#8E9394;}\n\t.st1193{fill:#8F9495;}\n\t.st1194{fill:#919697;}\n\t.st1195{fill:#929798;}\n\t.st1196{fill:#949799;}\n\t.st1197{fill:#95989A;}\n\t.st1198{fill:#96999B;}\n\t.st1199{fill:#979A9C;}\n\t.st1200{fill:#989B9D;}\n\t.st1201{fill:#999C9E;}\n\t.st1202{fill:#9A9D9F;}\n\t.st1203{fill:#9B9EA0;}\n\t.st1204{fill:#B8BBBC;}\n\t.st1205{fill:#B9BCBD;}\n\t.st1206{fill:#BABDBE;}\n\t.st1207{fill:#BBBEBF;}\n\t.st1208{fill:#BCBFC0;}\n\t.st1209{fill:#BDC0C1;}\n\t.st1210{fill:#BEC1C2;}\n\t.st1211{fill:#BFC2C3;}\n\t.st1212{fill:#C0C3C4;}\n\t.st1213{fill:#C1C4C5;}\n\t.st1214{fill:#C2C5C6;}\n\t.st1215{fill:#C3C6C7;}\n\t.st1216{fill:#C4C7C8;}\n\t.st1217{fill:#C5C8C9;}\n\t.st1218{fill:#C6C9CA;}\n\t.st1219{fill:#C7CACB;}\n\t.st1220{fill:#C8CBCC;}\n\t.st1221{fill:#C9CCCD;}\n\t.st1222{fill:#CACDCE;}\n\t.st1223{fill:#CBCECF;}\n\t.st1224{fill:#DDDFE0;}\n\t.st1225{fill:#DEE0E1;}\n\t.st1226{fill:#DFE1E2;}\n\t.st1227{fill:#E0E2E3;}\n\t.st1228{fill:#E1E3E4;}\n\t.st1229{fill:#E2E4E5;}\n\t.st1230{fill:#E3E5E6;}\n\t.st1231{fill:#E4E6E7;}\n\t.st1232{fill:#E5E7E8;}\n\t.st1233{fill:#E6E8E9;}\n\t.st1234{clip-path:url(#SVGID_00000105420209537031107710000015186965799428050098_);}\n\t.st1235{fill:#5F6468;}\n\t.st1236{fill:#606569;}\n\t.st1237{fill:#62676A;}\n\t.st1238{fill:#63686B;}\n\t.st1239{fill:#64696C;}\n\t.st1240{fill:#656A6D;}\n\t.st1241{fill:#666B6E;}\n\t.st1242{fill:#676C6F;}\n\t.st1243{fill:#6A6E72;}\n\t.st1244{fill:#6B6F73;}\n\t.st1245{fill:#6C7074;}\n\t.st1246{fill:#6E7276;}\n\t.st1247{fill:#6F7377;}\n\t.st1248{fill:#707478;}\n\t.st1249{fill:#717579;}\n\t.st1250{fill:#72767A;}\n\t.st1251{fill:#73777B;}\n\t.st1252{fill:#74787C;}\n\t.st1253{fill:#75797D;}\n\t.st1254{fill:#767A7E;}\n\t.st1255{fill:#777B7F;}\n\t.st1256{fill:#787C80;}\n\t.st1257{fill:#7A7D81;}\n\t.st1258{fill:#7B7E82;}\n\t.st1259{fill:#7C7F83;}\n\t.st1260{fill:#7D8084;}\n\t.st1261{fill:#7E8185;}\n\t.st1262{fill:#7F8286;}\n\t.st1263{fill:#808387;}\n\t.st1264{fill:#818488;}\n\t.st1265{fill:#828589;}\n\t.st1266{fill:#83868A;}\n\t.st1267{fill:#84878B;}\n\t.st1268{fill:#85888C;}\n\t.st1269{fill:#86898D;}\n\t.st1270{fill:#878A8E;}\n\t.st1271{fill:#888B8F;}\n\t.st1272{fill:#898C90;}\n\t.st1273{fill:#8A8D91;}\n\t.st1274{fill:#8B8E92;}\n\t.st1275{fill:#8C8F93;}\n\t.st1276{fill:#8D9094;}\n\t.st1277{fill:#8E9195;}\n\t.st1278{fill:#909295;}\n\t.st1279{fill:#919396;}\n\t.st1280{fill:#929497;}\n\t.st1281{fill:#939598;}\n\t.st1282{fill:#949699;}\n\t.st1283{fill:#95979A;}\n\t.st1284{fill:#96989B;}\n\t.st1285{fill:#97999C;}\n\t.st1286{fill:#989A9D;}\n\t.st1287{fill:#999B9E;}\n\t.st1288{fill:#9A9C9F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,41.1c0,0.1,0,0.2,0,0.4c-0.1,9.6-3.4,18.4-9.1,25.4c-1.7,2.1-3.6,4.1-5.7,5.8l0,0 c-0.4,0.4-0.9,0.7-1.3,1.1h0c-0.5,0.4-1,0.8-1.6,1.2c0,0-0.1,0.1-0.1,0.1c-6.6,4.5-14.6,7.2-23.2,7.2c-1.9,0-3.7-0.1-5.5-0.4 c0,0,0,0,0,0c-5-0.7-9.7-2.2-13.9-4.5l0,0c-3.9-2.1-7.5-4.9-10.5-8.1c-0.8-0.8-1.5-1.7-2.2-2.6c-3.1-3.9-5.6-8.5-7.1-13.4 c-1-3.1-1.6-6.3-1.8-9.6C1,42.8,1,41.9,1,41.1c0-9.2,3-17.6,8.1-24.5c2.2-3,4.8-5.6,7.7-7.9c0.3-0.2,0.5-0.4,0.8-0.6 c0,0,0.1,0,0.1-0.1c2.7-2,5.7-3.8,9-5.1c4.8-2,10-3,15.5-3c17.6,0,32.7,11.1,38.5,26.7C82.3,31.2,83.2,36,83.2,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.2,3.2c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0-0.1,0C35.6,1.6,31,1.7,26.6,3c-3.2,1.3-6.2,3-9,5.1 c0,0-0.1,0-0.1,0.1c-0.3,0.2-0.5,0.4-0.8,0.6l-4.2,6.2c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.1,0.4c-0.6,2.3-0.7,5.1-0.2,9 c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.1h0.1l14.9-2.3c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0 c4.7-5.7,8.9-9.2,13.6-11.3c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.2-0.2,0.2-0.4L40.2,3.2z M27.3,21.9l-14.1,2.2c0-0.1,0-0.1,0-0.2 c-0.4-3.8-0.3-6.4,0.3-8.5l0.4-0.5c0.6-0.9,1.3-1.9,2-2.9c0.2-0.3,0.4-0.6,0.6-0.9c0.8-1.2,1.5-2.1,1.5-2.1 c6.3-5.2,14.3-7.1,21.3-5.1l1.7,6.8C36.3,12.7,32,16.2,27.3,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.3,29.3c-0.2-0.5-0.4-1-0.6-1.5c-3.4-7.7-8.2-13.1-14.9-16.6c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.4-0.1-0.5,0 l-7.2,4.9c-0.2,0.2-0.3,0.5-0.2,0.7c0.1,0.1,0.2,0.3,0.2,0.4c2.9,5.2,4.3,11.3,3.9,17.2c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0.1 L72.6,43c0.1,0.1,0.2,0.1,0.3,0.1H73c3.1-0.4,6-2.6,8.1-6c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.3l0.1-7 C81.4,29.5,81.3,29.4,81.3,29.3z M80.2,36.4c-1.8,3.1-4.4,5.2-7.2,5.6l-2.7-2.1l0,0l0,0l-5.1-4l-0.1-0.1l0,0L63,34.2 c0.3-6-1.1-12.2-4.1-17.5l6.5-4.5c6.8,3.6,12.1,10.1,15.3,18.2C80.9,32.4,80.7,34.4,80.2,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,68v0.2c0,0.1,0,0.2-0.1,0.3l-2.8,4.1l0,0L68,73.2c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.2-0.7,0.5-1.1,0.7 c-0.5,0.3-0.9,0.6-1.3,0.8c0,0-0.1,0.1-0.1,0.1c-5.7,3.4-11.9,5.1-18.6,5.1c-1.1,0-2.2-0.1-3.3-0.1h0c0,0-0.1,0-0.1,0 c-0.2,0-0.4-0.2-0.5-0.3l-2.5-7.2l-0.1-0.4c0,0,0-0.1,0-0.1c0-0.2,0.1-0.5,0.3-0.5c0.3-0.1,0.6,0.1,0.7,0.3l0.2,0.5l2.4,6.7 c8.6,0.7,16.5-1.5,23.5-6.4l3-4.5c0.1-3.2-0.6-6.1-2.1-8.7l-1.3,0.1l0,0l-10.2,0.9l-1.9,0.2c-0.1,0-0.2,0-0.2,0 c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.2-0.4c0,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0l13.9-1.2c0.1,0,0.2,0,0.3,0.1 c0.1,0,0.2,0.1,0.2,0.2C70.5,61.4,71.3,64.6,71.2,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,59.7l-0.3-1.5v0l0-0.1l-2.4-13.3c0-0.1-0.1-0.2-0.2-0.3c0,0-0.1,0-0.1-0.1l-19.3-6.6c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0.1-0.3,0.1L19,49.8c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0.2,7.2,1.6,12.5,4.6,16.4c0,0,0,0,0,0.1 c4.6,3.9,10.2,5.9,16.6,5.9h0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0.1-0.1,0.3-0.1,0.4-0.2c4.7-2.1,9-5.9,12.9-11.2 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2v0L54.1,59.7z M40.6,71.4c-6.4,0.1-11.9-1.8-16.4-5.6c-2.7-3.6-4.2-8.6-4.3-15.5 l11.8-11.4l18.8,6.3l2.8,15.3C49.4,65.8,45.2,69.4,40.6,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8,46.9c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.4-0.4-0.2-0.7c1.5-3,3.5-5,6.1-6c0.3-0.1,0.6,0,0.7,0.3 c0.1,0.3,0,0.6-0.3,0.7c-2.3,0.9-4.2,2.7-5.5,5.5C3.2,46.8,3,46.9,2.8,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.9,50.3c4.6-4.9,9.3-8.6,12-11.4c-1.2-6-2.2-14.2-4.6-17.1c-5.2-1.2-11.2,0.6-15.1,2.5 c-2.9,6.2-3.5,11.7-3.6,16.3C11.5,44.5,15.7,49.1,19.9,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.5,34.4c-3.7,2.5-9.3,7-11.6,10.5c1.2,6,2.3,11.6,3.6,15.2c5.2,1.2,9.9,0.6,13.9-1.2 c2.9-6.2,4.5-11.8,4.6-16.3C68.9,38.2,66.4,36.2,62.5,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.5,34.4c-3.7,2.5-9.3,7-11.6,10.5c1.2,6,1.6,12.2,2.9,15.8c5.2,1.2,10.7,0,14.6-1.8 c2.9-6.2,4.5-11.8,4.6-16.3C68.9,38.2,66.4,36.2,62.5,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,71.8c-0.1,0.2-0.3,0.4-0.5,0.4c0,0-0.1,0-0.1,0c-0.1,0-0.3-0.1-0.4-0.1c-1.9-0.5-3.9-1.7-5.9-2.9 c-0.8-0.8-1.5-1.7-2.2-2.6c0.1,0,0.2,0,0.3,0.1c2.8,1.8,5.7,3.6,8.1,4.3c0.1,0,0.2,0.1,0.3,0.1C18.9,71.2,19.1,71.5,19,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,17.3c-5.4-3.6-11.3-5.6-16.6-5.8L39.6,3c10-3.9,21.4,0.3,26.8,8.6L58.1,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,79.6c-0.2,0.1-0.4,0.2-0.6,0.3c-1.7,0.8-4.7,1.5-6.8,1.8c0,0,0,0,0,0c-5-0.7-9.7-2.2-13.9-4.5l0,0L18,72h0 l-0.2-0.5l0.5-0.5l5.1-4.6l0.8-0.7c5.7,4.7,12,5.6,16,5.6c0.3,0,0.8-0.2,0.8-0.2l0.3,1.1l2.3,6.7L44,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.9,8.9c0,0-0.6,0.9-1.5,2.1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.7,1-1.4,2.1-2,2.9l-1.5,0.5l-3.3,1.2 c2.2-3,4.8-5.6,7.7-7.9c0.3-0.2,0.5-0.4,0.8-0.6c0,0,0.1,0,0.1-0.1L17.9,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,53.2c-0.9-3.1-1.5-6.3-1.7-9.6l1.5,1.9l0.7,0.9v0C3.4,46.7,3.5,52,2.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.1,66.9c-1.7,2.1-3.6,4.1-5.7,5.8l0,0L68,73.2c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.2-0.7,0.5-1.1,0.7 c0.1-0.1,0.2-0.2,0.2-0.3h0c1.7-2.5,3.7-5.5,3.7-5.5l0.5-0.2L74.1,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.2,41.1c0,0.1,0,0.2,0,0.4L81,37.1l-0.8-0.7c0.5-1.1,0.7-5.7,0.4-8.5c0-0.4-0.1-0.8-0.1-1.1 C82.3,31.2,83.2,36,83.2,41.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "93.7,99.4 80.5,96.3 78.6,91.8 93.2,95.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136413087121155574420000010695113965078782882_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136413087121155574420000010695113965078782882_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.6,96 93.7,98.7 93.7,99.4 78.6,99.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "78.6,95.9 93.7,98.6 93.7,98.7 78.6,96  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "78.6,95.8 93.7,98.5 93.7,98.6 78.6,95.9  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.6,95.7 93.7,98.4 93.7,98.5 78.6,95.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.6,95.6 93.7,98.2 93.7,98.4 78.6,95.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.6,95.5 93.7,98.1 93.7,98.2 78.6,95.6  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "78.6,95.3 93.7,98 93.7,98.1 78.6,95.5  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "78.6,95.2 93.7,97.9 93.7,98 78.6,95.3  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "78.6,95.2 93.7,97.8 93.7,97.9 78.6,95.2  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "78.6,95.1 93.7,97.8 93.7,97.8 78.6,95.2  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "78.6,95.1 93.7,97.7 93.7,97.8 78.6,95.1  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "78.6,95 93.7,97.7 93.7,97.7 78.6,95.1  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "78.6,94.9 93.7,97.6 93.7,97.7 78.6,95  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "78.6,94.9 93.7,97.6 93.7,97.6 78.6,94.9  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "78.6,94.8 93.7,97.5 93.7,97.6 78.6,94.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "78.6,94.8 93.7,97.4 93.7,97.5 78.6,94.8  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "78.6,94.7 93.7,97.4 93.7,97.4 78.6,94.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "78.6,94.7 93.7,97.3 93.7,97.4 78.6,94.7  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "78.6,94.6 93.7,97.3 93.7,97.3 78.6,94.7  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "78.6,94.5 93.7,97.2 93.7,97.3 78.6,94.6  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "78.6,94.5 93.7,97.2 93.7,97.2 78.6,94.5  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "78.6,94.4 93.7,97.1 93.7,97.2 78.6,94.5  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "78.6,94.4 93.7,97 93.7,97.1 78.6,94.4  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "78.6,94.3 93.7,97 93.7,97 78.6,94.4  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "78.6,94.3 93.7,96.9 93.7,97 78.6,94.3  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "78.6,94.2 93.7,96.9 93.7,96.9 78.6,94.3  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "78.6,94.1 93.7,96.8 93.7,96.9 78.6,94.2  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "78.6,94.1 93.7,96.8 93.7,96.8 78.6,94.1  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "78.6,94 93.7,96.7 93.7,96.8 78.6,94.1  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "78.6,94 93.7,96.7 93.7,96.7 78.6,94  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "78.6,93.9 93.7,96.6 93.7,96.7 78.6,94  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "78.6,93.9 93.7,96.6 93.7,96.6 78.6,93.9  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "78.6,93.9 93.7,96.5 93.7,96.6 78.6,93.9  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "78.6,93.8 93.7,96.5 93.7,96.5 78.6,93.9  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "78.6,93.8 93.7,96.4 93.7,96.5 78.6,93.8  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "78.6,93.7 93.7,96.4 93.7,96.4 78.6,93.8  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "78.6,93.7 93.7,96.4 93.7,96.4 78.6,93.7  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "78.6,93.6 93.7,96.3 93.7,96.4 78.6,93.7  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "78.6,93.6 93.7,96.3 93.7,96.3 78.6,93.6  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "78.6,93.5 93.7,96.2 93.7,96.3 78.6,93.6  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "78.6,93.5 93.7,96.2 93.7,96.2 78.6,93.5  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "78.6,93.5 93.7,96.1 93.7,96.2 78.6,93.5  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "78.6,93.4 93.7,96.1 93.7,96.1 78.6,93.5  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "78.6,93.4 93.7,96 93.7,96.1 78.6,93.4  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "78.6,93.3 93.7,96 93.7,96 78.6,93.4  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "78.6,93.3 93.7,96 93.7,96 78.6,93.3  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "78.6,93.2 93.7,95.9 93.7,96 78.6,93.3  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "78.6,93.2 93.7,95.9 93.7,95.9 78.6,93.2  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "78.6,93.2 93.7,95.8 93.7,95.9 78.6,93.2  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "78.6,93.1 93.7,95.8 93.7,95.8 78.6,93.2  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "78.6,93.1 93.7,95.7 93.7,95.8 78.6,93.1  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "78.6,93 93.7,95.7 93.7,95.7 78.6,93.1  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "78.6,93 93.7,95.6 93.7,95.7 78.6,93  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "78.6,92.9 93.7,95.6 93.7,95.6 78.6,93  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "78.6,92.9 93.7,95.6 93.7,95.6 78.6,92.9  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "78.6,92.8 93.7,95.5 93.7,95.6 78.6,92.9  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "78.6,92.8 93.7,95.5 93.7,95.5 78.6,92.8  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "78.6,92.8 93.7,95.4 93.7,95.5 78.6,92.8  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "78.6,92.7 93.7,95.4 93.7,95.4 78.6,92.8  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "78.6,92.7 93.7,95.3 93.7,95.4 78.6,92.7  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "78.6,92.6 93.7,95.3 93.7,95.3 78.6,92.7  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "78.6,92.6 93.7,95.3 93.7,95.3 78.6,92.6  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "78.6,92.6 93.7,95.2 93.7,95.3 78.6,92.6  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "78.6,92.5 93.7,95.2 93.7,95.2 78.6,92.6  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "78.6,92.5 93.7,95.2 93.7,95.2 78.6,92.5  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "78.6,92.5 93.7,95.1 93.7,95.2 78.6,92.5  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "78.6,92.4 93.7,95.1 93.7,95.1 78.6,92.5  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "78.6,92.4 93.7,95.1 93.7,95.1 78.6,92.4  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "78.6,92.4 93.7,95 93.7,95.1 78.6,92.4  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "78.6,92.3 93.7,95 93.7,95 78.6,92.4  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "78.6,92.3 93.7,94.9 93.7,95 78.6,92.3  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "78.6,92.2 93.7,94.9 93.7,94.9 78.6,92.3  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "78.6,92.2 93.7,94.9 93.7,94.9 78.6,92.2  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "78.6,92.2 93.7,94.8 93.7,94.9 78.6,92.2  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "78.6,92.1 93.7,94.8 93.7,94.8 78.6,92.2  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "78.6,92.1 93.7,94.8 93.7,94.8 78.6,92.1  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "78.6,92.1 93.7,94.7 93.7,94.8 78.6,92.1  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "78.6,92 93.7,94.7 93.7,94.7 78.6,92.1  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "78.6,92 93.7,94.7 93.7,94.7 78.6,92  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "78.6,92 93.7,94.6 93.7,94.7 78.6,92  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "78.6,91.9 93.7,94.6 93.7,94.6 78.6,92  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "78.6,91.9 93.7,94.6 93.7,94.6 78.6,91.9  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "93.7,94.6 78.6,91.9 78.6,91.8 93.7,91.8  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151539663094893444190000015825553140418761900_",
    d: "M89.6,58.1L89.6,58.1L89.6,58.1 c4.3-3.8,9.4-5.6,14.6-4.6L82.7,48c-0.4-0.1-0.8-0.2-1.2-0.3c-4.8-1-9.7,0.6-13.7,3.9c-0.4,0.3-0.7,0.6-1.1,1L20,94.6l23.2,9.4 l45.1-44.6C88.7,59,89.2,58.5,89.6,58.1L89.6,58.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096039838392737038120000014759992904782771133_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151539663094893444190000015825553140418761900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096039838392737038120000014759992904782771133_)"
    }
  }, _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "104.2,53.6 78,46.8 104.2,46.8  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "104.2,53.7 77.7,46.8 78,46.8 104.2,53.6  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "104.2,53.7 77.5,46.8 77.7,46.8 104.2,53.7  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "104.2,53.8 77.2,46.8 77.5,46.8 104.2,53.7  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "104.2,53.9 76.9,46.8 77.2,46.8 104.2,53.8  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "104.2,54 76.6,46.8 76.9,46.8 104.2,53.9  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "104.2,54 76.3,46.8 76.6,46.8 104.2,54  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "104.2,54.1 76,46.8 76.3,46.8 104.2,54  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "104.2,54.2 75.7,46.8 76,46.8 104.2,54.1  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "104.2,54.3 75.4,46.8 75.7,46.8 104.2,54.2  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "104.2,54.3 75.1,46.8 75.4,46.8 104.2,54.3  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "104.2,54.4 74.8,46.8 75.1,46.8 104.2,54.3  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "104.2,54.5 74.5,46.8 74.8,46.8 104.2,54.4  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "104.2,54.6 74.2,46.8 74.5,46.8 104.2,54.5  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "104.2,54.6 73.9,46.8 74.2,46.8 104.2,54.6  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "104.2,54.7 73.6,46.8 73.9,46.8 104.2,54.6  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "104.2,54.8 73.4,46.8 73.6,46.8 104.2,54.7  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "104.2,54.9 73.1,46.8 73.4,46.8 104.2,54.8  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "104.2,54.9 72.8,46.8 73.1,46.8 104.2,54.9  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "104.2,55 72.7,46.8 72.8,46.8 104.2,54.9  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "104.2,55 72.6,46.8 72.7,46.8 104.2,55  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "104.2,55 72.5,46.8 72.6,46.8 104.2,55  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "104.2,55.1 72.3,46.8 72.5,46.8 104.2,55  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "104.2,55.1 72.2,46.8 72.3,46.8 104.2,55.1  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "104.2,55.1 72.1,46.8 72.2,46.8 104.2,55.1  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "104.2,55.1 72,46.8 72.1,46.8 104.2,55.1  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "104.2,55.2 71.9,46.8 72,46.8 104.2,55.1  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "104.2,55.2 71.8,46.8 71.9,46.8 104.2,55.2  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "104.2,55.2 71.7,46.8 71.8,46.8 104.2,55.2  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "104.2,55.3 71.6,46.8 71.7,46.8 104.2,55.2  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "104.2,55.3 71.5,46.8 71.6,46.8 104.2,55.3  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "104.2,55.3 71.4,46.8 71.5,46.8 104.2,55.3  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "104.2,55.3 71.3,46.8 71.4,46.8 104.2,55.3  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "104.2,55.4 71.2,46.8 71.3,46.8 104.2,55.3  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "104.2,55.4 71.1,46.8 71.2,46.8 104.2,55.4  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "104.2,55.4 71,46.8 71.1,46.8 104.2,55.4  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "104.2,55.4 70.9,46.8 71,46.8 104.2,55.4  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "104.2,55.5 70.8,46.8 70.9,46.8 104.2,55.4  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "104.2,55.5 70.7,46.8 70.8,46.8 104.2,55.5  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "104.2,55.5 70.6,46.8 70.7,46.8 104.2,55.5  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "104.2,55.6 70.5,46.8 70.6,46.8 104.2,55.5  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "104.2,55.6 70.4,46.8 70.5,46.8 104.2,55.6  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "104.2,55.6 70.2,46.8 70.4,46.8 104.2,55.6  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "104.2,55.6 70.1,46.8 70.2,46.8 104.2,55.6  "
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "104.2,55.7 70,46.8 70.1,46.8 104.2,55.6  "
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "104.2,55.7 69.8,46.8 70,46.8 104.2,55.7  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "104.2,55.8 69.6,46.8 69.8,46.8 104.2,55.7  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "104.2,55.8 69.5,46.8 69.6,46.8 104.2,55.8  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "104.2,55.8 69.3,46.8 69.5,46.8 104.2,55.8  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "104.2,55.9 69.2,46.8 69.3,46.8 104.2,55.8  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "104.2,55.9 69,46.8 69.2,46.8 104.2,55.9  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "104.2,56 68.8,46.8 69,46.8 104.2,55.9  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "104.2,56 68.7,46.8 68.8,46.8 104.2,56  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "104.2,56.1 68.5,46.8 68.7,46.8 104.2,56  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "104.2,56.1 68.3,46.8 68.5,46.8 104.2,56.1  "
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "104.2,56.1 68.2,46.8 68.3,46.8 104.2,56.1  "
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "104.2,56.2 68,46.8 68.2,46.8 104.2,56.1  "
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "104.2,56.2 67.8,46.8 68,46.8 104.2,56.2  "
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "104.2,56.3 67.7,46.8 67.8,46.8 104.2,56.2  "
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "104.2,56.3 67.5,46.8 67.7,46.8 104.2,56.3  "
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "104.2,56.4 67.3,46.8 67.5,46.8 104.2,56.3  "
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "104.2,56.4 67.2,46.8 67.3,46.8 104.2,56.4  "
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "104.2,56.5 67,46.8 67.2,46.8 104.2,56.4  "
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "104.2,56.5 66.9,46.8 67,46.8 104.2,56.5  "
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "104.2,56.5 66.7,46.8 66.9,46.8 104.2,56.5  "
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "104.2,56.6 66.5,46.8 66.7,46.8 104.2,56.5  "
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "104.2,56.6 66.4,46.8 66.5,46.8 104.2,56.6  "
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "104.2,56.7 66.2,46.8 66.4,46.8 104.2,56.6  "
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "104.2,56.7 66,46.8 66.2,46.8 104.2,56.7  "
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "104.2,56.7 65.9,46.8 66,46.8 104.2,56.7  "
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "104.2,56.8 65.7,46.8 65.9,46.8 104.2,56.7  "
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "104.2,56.8 65.5,46.8 65.7,46.8 104.2,56.8  "
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "104.2,56.9 65.4,46.8 65.5,46.8 104.2,56.8  "
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "104.2,56.9 65.2,46.8 65.4,46.8 104.2,56.9  "
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "104.2,57 65,46.8 65.2,46.8 104.2,56.9  "
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "104.2,57 64.9,46.8 65,46.8 104.2,57  "
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "104.2,57 64.7,46.8 64.9,46.8 104.2,57  "
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "104.2,57.1 64.6,46.8 64.7,46.8 104.2,57  "
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "104.2,57.1 64.5,46.8 64.6,46.8 104.2,57.1  "
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "104.2,57.1 64.4,46.8 64.5,46.8 104.2,57.1  "
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "104.2,57.2 64.2,46.8 64.4,46.8 104.2,57.1  "
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "104.2,57.2 64.1,46.8 64.2,46.8 104.2,57.2  "
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "104.2,57.2 64,46.8 64.1,46.8 104.2,57.2  "
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "104.2,57.3 63.8,46.8 64,46.8 104.2,57.2  "
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "104.2,57.3 63.7,46.8 63.8,46.8 104.2,57.3  "
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "104.2,57.3 63.6,46.8 63.7,46.8 104.2,57.3  "
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "104.2,57.4 63.4,46.8 63.6,46.8 104.2,57.3  "
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "104.2,57.4 63.3,46.8 63.4,46.8 104.2,57.4  "
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "104.2,57.5 63.2,46.8 63.3,46.8 104.2,57.4  "
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "104.2,57.5 63,46.8 63.2,46.8 104.2,57.5  "
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "104.2,57.5 62.9,46.8 63,46.8 104.2,57.5  "
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "104.2,57.6 62.8,46.8 62.9,46.8 104.2,57.5  "
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "104.2,57.6 62.6,46.8 62.8,46.8 104.2,57.6  "
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "104.2,57.6 62.5,46.8 62.6,46.8 104.2,57.6  "
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "104.2,57.7 62.4,46.8 62.5,46.8 104.2,57.6  "
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "104.2,57.7 62.2,46.8 62.4,46.8 104.2,57.7  "
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "104.2,57.8 61.9,46.8 62.2,46.8 104.2,57.7  "
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "104.2,57.9 61.6,46.8 61.9,46.8 104.2,57.8  "
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "104.2,57.9 61.3,46.8 61.6,46.8 104.2,57.9  "
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "104.2,58 60.9,46.8 61.3,46.8 104.2,57.9  "
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "104.2,58.1 60.6,46.8 60.9,46.8 104.2,58  "
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "104.2,58.2 60.3,46.8 60.6,46.8 104.2,58.1  "
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "104.2,58.2 104.2,58.3 59.9,46.8 60.3,46.8 104.2,58.2  "
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "104.2,58.3 104.2,58.4 59.6,46.8 59.9,46.8  "
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "104.2,58.4 104.1,58.5 59.2,46.8 59.6,46.8  "
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "104.1,58.5 104.1,58.6 58.7,46.8 59.2,46.8  "
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "104.1,58.6 104.1,58.7 58.3,46.8 58.7,46.8  "
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "104.1,58.7 104.1,58.8 57.9,46.8 58.3,46.8  "
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "104.1,58.8 104,58.9 57.4,46.8 57.9,46.8  "
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "104,58.9 104,59 57,46.8 57.4,46.8  "
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "104,59 104,59.1 56.5,46.8 57,46.8  "
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "104,59.1 103.9,59.2 56.1,46.8 56.5,46.8  "
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "103.9,59.2 103.9,59.3 55.7,46.8 56.1,46.8  "
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "103.9,59.3 103.9,59.4 55.2,46.8 55.7,46.8  "
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st178",
    points: "103.9,59.4 103.9,59.5 54.8,46.8 55.2,46.8  "
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "103.9,59.5 103.8,59.7 54.4,46.8 54.8,46.8  "
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "103.8,59.7 103.8,59.7 53.9,46.8 54.4,46.8  "
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "103.8,59.7 103.8,59.8 53.5,46.8 53.9,46.8  "
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st181",
    points: "103.8,59.8 103.8,59.9 53.1,46.8 53.5,46.8  "
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st182",
    points: "103.8,59.9 103.7,60 52.7,46.8 53.1,46.8  "
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st183",
    points: "103.7,60 103.7,60.1 52.3,46.8 52.7,46.8  "
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "103.7,60.1 103.7,60.2 51.9,46.8 52.3,46.8  "
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "103.7,60.2 103.7,60.3 51.5,46.8 51.9,46.8  "
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "103.7,60.3 103.6,60.4 51.1,46.8 51.5,46.8  "
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "103.6,60.4 103.6,60.5 50.7,46.8 51.1,46.8  "
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st188",
    points: "103.6,60.5 103.6,60.6 50.3,46.8 50.7,46.8  "
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st189",
    points: "103.6,60.6 103.6,60.7 49.9,46.8 50.3,46.8  "
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "103.6,60.7 103.5,60.8 49.5,46.8 49.9,46.8  "
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st191",
    points: "103.5,60.8 103.5,60.9 49.1,46.8 49.5,46.8  "
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "103.5,60.9 103.5,61 48.7,46.8 49.1,46.8  "
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "103.5,61 103.5,61.1 48.3,46.8 48.7,46.8  "
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "103.5,61.1 103.4,61.2 47.9,46.8 48.3,46.8  "
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "103.4,61.2 103.4,61.3 47.5,46.8 47.9,46.8  "
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "103.4,61.3 103.4,61.4 47.1,46.8 47.5,46.8  "
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "103.4,61.4 103.4,61.5 46.7,46.8 47.1,46.8  "
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "103.4,61.5 103.3,61.6 46.3,46.8 46.7,46.8  "
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "103.3,61.6 103.3,61.7 45.9,46.8 46.3,46.8  "
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "103.3,61.7 103.3,61.8 45.5,46.8 45.9,46.8  "
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "103.3,61.8 103.2,61.9 45,46.8 45.5,46.8  "
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "103.2,61.9 103.2,62 44.6,46.8 45,46.8  "
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st203",
    points: "103.2,62 103.2,62.1 44.2,46.8 44.6,46.8  "
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "103.2,62.1 103.2,62.2 43.8,46.8 44.2,46.8  "
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "103.2,62.2 103.1,62.3 43.3,46.8 43.8,46.8  "
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "103.1,62.3 103.1,62.5 42.8,46.8 43.3,46.8  "
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "103.1,62.5 103.1,62.6 42.3,46.8 42.8,46.8  "
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "103.1,62.6 103,62.7 41.7,46.8 42.3,46.8  "
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "103,62.7 103,62.9 41.2,46.8 41.7,46.8  "
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "103,62.9 103,63 40.7,46.8 41.2,46.8  "
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "103,63 102.9,63.1 40.2,46.8 40.7,46.8  "
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "102.9,63.1 102.9,63.2 39.6,46.8 40.2,46.8  "
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "102.9,63.2 102.9,63.4 39.1,46.8 39.6,46.8  "
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "102.9,63.4 102.8,63.5 38.6,46.8 39.1,46.8  "
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "102.8,63.5 102.8,63.6 38,46.8 38.6,46.8  "
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st215",
    points: "102.8,63.6 102.8,63.8 37.5,46.8 38,46.8  "
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st216",
    points: "102.8,63.8 102.7,63.9 37,46.8 37.5,46.8  "
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st217",
    points: "102.7,63.9 102.7,64 36.5,46.8 37,46.8  "
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "102.7,64 102.7,64.1 35.9,46.8 36.5,46.8  "
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "102.7,64.1 102.6,64.5 34.6,46.8 35.9,46.8  "
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "102.6,64.5 102.5,64.8 33.3,46.8 34.6,46.8  "
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "102.5,64.8 102.4,65.1 32,46.8 33.3,46.8  "
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "102.4,65.1 102.3,65.4 31.2,46.9 31.2,46.8 32,46.8  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 19.5,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -4.5999 106.6765)",
    className: "st222",
    width: 0.3,
    height: 73.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 19.9,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -4.9761 106.8356)",
    className: "st223",
    width: 0.3,
    height: 73.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 23.7,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -9.4535 108.7447)",
    className: "st223",
    width: 7.6,
    height: 73.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 31.1,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -18.0379 112.4082)",
    className: "st222",
    width: 7.6,
    height: 73.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 38.5,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -26.6156 116.0687)",
    className: "st224",
    width: 7.6,
    height: 73.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 45.9,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -35.2 119.7322)",
    className: "st225",
    width: 7.6,
    height: 73.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 49.8,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -39.7736 121.6769)",
    className: "st225",
    width: 0.5,
    height: 73.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 50.3,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -40.3417 121.9226)",
    className: "st226",
    width: 0.5,
    height: 73.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3,
    y: 50.8,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -40.9209 122.1655)",
    className: "st227",
    width: 0.5,
    height: 73.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2,
    y: 51.3,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -41.489 122.4112)",
    className: "st228",
    width: 0.5,
    height: 73.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 51.8,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -42.0638 122.6598)",
    className: "st229",
    width: 0.5,
    height: 73.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57.9,
    y: 52.3,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -42.6414 122.9017)",
    className: "st230",
    width: 0.5,
    height: 73.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 52.8,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -43.2139 123.1417)",
    className: "st231",
    width: 0.5,
    height: 73.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 53.3,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -43.7887 123.3903)",
    className: "st212",
    width: 0.5,
    height: 73.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 53.7,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -44.3568 123.636)",
    className: "st211",
    width: 0.5,
    height: 73.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4,
    y: 54.2,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -44.9373 123.8891)",
    className: "st232",
    width: 0.5,
    height: 73.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 54.7,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -45.5127 124.1224)",
    className: "st233",
    width: 0.5,
    height: 73.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 55.2,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -46.0875 124.371)",
    className: "st234",
    width: 0.5,
    height: 73.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 55.7,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -46.6622 124.6196)",
    className: "st235",
    width: 0.5,
    height: 73.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 56.1,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -47.1479 124.8205)",
    className: "st235",
    width: 0.4,
    height: 73.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 56.9,
    y: 56.5,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -47.5404 124.9915)",
    className: "st236",
    width: 0.4,
    height: 73.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8,
    y: 56.8,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -47.9382 125.155)",
    className: "st237",
    width: 0.4,
    height: 73.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 57.2,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -48.3288 125.331)",
    className: "st238",
    width: 0.4,
    height: 73.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 57.5,
    transform: "matrix(0.2521 -0.9677 0.9677 0.2521 -48.728 125.5048)",
    className: "st239",
    width: 0.4,
    height: 73.5
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "92.4,103.7 92.3,104 92.1,104 21.1,85.5 21.2,85.2  "
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st241",
    points: "90.7,104 21,85.9 21.1,85.5 92.1,104  "
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "89.3,104 20.9,86.2 21,85.9 90.7,104  "
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "87.9,104 20.8,86.5 20.9,86.2 89.3,104  "
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "86.5,104 20.8,86.9 20.8,86.5 87.9,104  "
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st245",
    points: "85.1,104 20.7,87.2 20.8,86.9 86.5,104  "
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "83.7,104 20.6,87.6 20.7,87.2 85.1,104  "
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st247",
    points: "82.3,104 20.5,87.9 20.6,87.6 83.7,104  "
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "80.9,104 20.4,88.2 20.5,87.9 82.3,104  "
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st249",
    points: "79.5,104 20.3,88.6 20.4,88.2 80.9,104  "
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "78.1,104 20.2,88.9 20.3,88.6 79.5,104  "
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "76.7,104 20.1,89.3 20.2,88.9 78.1,104  "
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "75.3,104 20,89.6 20.1,89.3 76.7,104  "
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "73.9,104 20,90 20,89.9 20,89.6 75.3,104  "
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "72.5,104 20,90.3 20,90 73.9,104  "
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "71.1,104 20,90.7 20,90.3 72.5,104  "
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "69.7,104 20,91.1 20,90.7 71.1,104  "
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st257",
    points: "68.3,104 20,91.4 20,91.1 69.7,104  "
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "66.9,104 20,91.8 20,91.4 68.3,104  "
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "65.5,104 20,92.1 20,91.8 66.9,104  "
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "64.1,104 20,92.5 20,92.1 65.5,104  "
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st261",
    points: "62.7,104 20,92.9 20,92.5 64.1,104  "
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st262",
    points: "61.3,104 20,93.2 20,92.9 62.7,104  "
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st263",
    points: "59.9,104 20,93.6 20,93.2 61.3,104  "
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "58.5,104 20,94 20,93.6 59.9,104  "
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st265",
    points: "57.1,104 20,94.3 20,94 58.5,104  "
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st266",
    points: "55.7,104 20,94.7 20,94.3 57.1,104  "
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st266",
    points: "54.4,104 20,95 20,94.7 55.7,104  "
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st267",
    points: "53.1,104 20,95.4 20,95 54.4,104  "
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st268",
    points: "51.8,104 20,95.7 20,95.4 53.1,104  "
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st269",
    points: "50.5,104 20,96.1 20,95.7 51.8,104  "
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st270",
    points: "49.2,104 20,96.4 20,96.1 50.5,104  "
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "st271",
    points: "47.8,104 20,96.7 20,96.4 49.2,104  "
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "st272",
    points: "46.5,104 20,97.1 20,96.7 47.8,104  "
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "st273",
    points: "45.2,104 20,97.4 20,97.1 46.5,104  "
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "st274",
    points: "43.9,104 20,97.8 20,97.4 45.2,104  "
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "st275",
    points: "42.6,104 20,98.1 20,97.8 43.9,104  "
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "st276",
    points: "41.3,104 20,98.5 20,98.1 42.6,104  "
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "st277",
    points: "39.9,104 20,98.8 20,98.5 41.3,104  "
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "st278",
    points: "38.6,104 20,99.1 20,98.8 39.9,104  "
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "37.3,104 20,99.5 20,99.1 38.6,104  "
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "st280",
    points: "36,104 20,99.8 20,99.5 37.3,104  "
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "st281",
    points: "34.7,104 20,100.2 20,99.8 36,104  "
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "st281",
    points: "20,100.2 34.7,104 20,104  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070804753805414405390000011639369325611842486_",
    d: "M104.2,53.5c-5.1-1-10.3,0.8-14.5,4.5l0,0l-0.1,0.1 c-0.5,0.4-0.9,0.9-1.3,1.3L43.2,104l6.2,9.4l31.2-16.5c2.8-1.5,6.2-1.4,8.8,0.4c1.7,1.2,3.5,2,5.5,2.4c9.9,2,20.1-6.7,22.7-19.4 C120.1,67.5,114.2,55.5,104.2,53.5L104.2,53.5L104.2,53.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049198020945926537470000007184517169110375870_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070804753805414405390000011639369325611842486_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049198020945926537470000007184517169110375870_)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 52.5,
    className: "st283",
    width: 0.6,
    height: 60.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 52.5,
    className: "st284",
    width: 0.6,
    height: 60.9
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 52.5,
    className: "st285",
    width: 0.6,
    height: 60.9
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 52.5,
    className: "st286",
    width: 0.6,
    height: 60.9
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 52.5,
    className: "st287",
    width: 0.6,
    height: 60.9
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 52.5,
    className: "st288",
    width: 0.6,
    height: 60.9
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 52.5,
    className: "st289",
    width: 0.6,
    height: 60.9
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 52.5,
    className: "st290",
    width: 0.6,
    height: 60.9
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 52.5,
    className: "st291",
    width: 0.6,
    height: 60.9
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2,
    y: 52.5,
    className: "st292",
    width: 0.6,
    height: 60.9
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 52.5,
    className: "st293",
    width: 0.6,
    height: 60.9
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 52.5,
    className: "st294",
    width: 0.6,
    height: 60.9
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9,
    y: 52.5,
    className: "st295",
    width: 0.6,
    height: 60.9
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 52.5,
    className: "st296",
    width: 0.6,
    height: 60.9
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1,
    y: 52.5,
    className: "st297",
    width: 0.6,
    height: 60.9
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 52.5,
    className: "st298",
    width: 0.6,
    height: 60.9
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 52.2,
    y: 52.5,
    className: "st299",
    width: 0.6,
    height: 60.9
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 52.5,
    className: "st300",
    width: 0.6,
    height: 60.9
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 52.5,
    className: "st301",
    width: 0.6,
    height: 60.9
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 52.5,
    className: "st302",
    width: 0.6,
    height: 60.9
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4,
    y: 52.5,
    className: "st303",
    width: 0.6,
    height: 60.9
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 52.5,
    className: "st304",
    width: 0.6,
    height: 60.9
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 52.5,
    className: "st305",
    width: 0.6,
    height: 60.9
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 52.5,
    className: "st306",
    width: 0.6,
    height: 60.9
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 52.5,
    className: "st307",
    width: 0.6,
    height: 60.9
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 52.5,
    className: "st308",
    width: 0.6,
    height: 60.9
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 52.5,
    className: "st309",
    width: 0.6,
    height: 60.9
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 52.5,
    className: "st310",
    width: 0.6,
    height: 60.9
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 52.5,
    className: "st311",
    width: 0.6,
    height: 60.9
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 52.5,
    className: "st312",
    width: 0.6,
    height: 60.9
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 52.5,
    className: "st313",
    width: 0.6,
    height: 60.9
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 52.5,
    className: "st314",
    width: 0.6,
    height: 60.9
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2,
    y: 52.5,
    className: "st315",
    width: 0.6,
    height: 60.9
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 52.5,
    className: "st316",
    width: 0.6,
    height: 60.9
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3,
    y: 52.5,
    className: "st317",
    width: 0.6,
    height: 60.9
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 52.5,
    className: "st318",
    width: 0.6,
    height: 60.9
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 52.5,
    className: "st319",
    width: 0.6,
    height: 60.9
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52.5,
    className: "st320",
    width: 0.6,
    height: 60.9
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 52.5,
    className: "st321",
    width: 0.6,
    height: 60.9
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 52.5,
    className: "st322",
    width: 0.6,
    height: 60.9
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7,
    y: 52.5,
    className: "st323",
    width: 0.6,
    height: 60.9
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3,
    y: 52.5,
    className: "st324",
    width: 0.6,
    height: 60.9
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 52.5,
    className: "st325",
    width: 0.6,
    height: 60.9
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4,
    y: 52.5,
    className: "st326",
    width: 0.6,
    height: 60.9
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 52.5,
    className: "st327",
    width: 0.6,
    height: 60.9
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 52.5,
    className: "st328",
    width: 0.6,
    height: 60.9
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 52.5,
    className: "st329",
    width: 0.6,
    height: 60.9
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7,
    y: 52.5,
    className: "st330",
    width: 0.6,
    height: 60.9
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 52.5,
    className: "st331",
    width: 0.6,
    height: 60.9
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 70.8,
    y: 52.5,
    className: "st332",
    width: 0.6,
    height: 60.9
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 52.5,
    className: "st333",
    width: 0.6,
    height: 60.9
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 52.5,
    className: "st334",
    width: 0.6,
    height: 60.9
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 52.5,
    className: "st335",
    width: 0.6,
    height: 60.9
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1,
    y: 52.5,
    className: "st336",
    width: 0.6,
    height: 60.9
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 73.6,
    y: 52.5,
    className: "st337",
    width: 0.6,
    height: 60.9
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 52.5,
    className: "st338",
    width: 0.6,
    height: 60.9
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 52.5,
    className: "st339",
    width: 0.6,
    height: 60.9
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3,
    y: 52.5,
    className: "st340",
    width: 0.6,
    height: 60.9
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9,
    y: 52.5,
    className: "st341",
    width: 0.6,
    height: 60.9
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4,
    y: 52.5,
    className: "st342",
    width: 0.6,
    height: 60.9
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 52.5,
    className: "st343",
    width: 0.6,
    height: 60.9
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 77.6,
    y: 52.5,
    className: "st344",
    width: 0.6,
    height: 60.9
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1,
    y: 52.5,
    className: "st345",
    width: 0.6,
    height: 60.9
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7,
    y: 52.5,
    className: "st346",
    width: 0.6,
    height: 60.9
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 52.5,
    className: "st347",
    width: 0.6,
    height: 60.9
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 79.8,
    y: 52.5,
    className: "st348",
    width: 0.6,
    height: 60.9
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4,
    y: 52.5,
    className: "st349",
    width: 0.6,
    height: 60.9
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 52.5,
    className: "st350",
    width: 0.6,
    height: 60.9
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 52.5,
    className: "st351",
    width: 0.6,
    height: 60.9
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 82.1,
    y: 52.5,
    className: "st352",
    width: 0.6,
    height: 60.9
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 82.6,
    y: 52.5,
    className: "st353",
    width: 0.6,
    height: 60.9
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 52.5,
    className: "st354",
    width: 0.6,
    height: 60.9
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 52.5,
    className: "st355",
    width: 0.6,
    height: 60.9
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 84.3,
    y: 52.5,
    className: "st356",
    width: 0.6,
    height: 60.9
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    y: 52.5,
    className: "st357",
    width: 0.6,
    height: 60.9
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 52.5,
    className: "st358",
    width: 0.6,
    height: 60.9
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 52.5,
    className: "st359",
    width: 0.6,
    height: 60.9
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6,
    y: 52.5,
    className: "st360",
    width: 0.6,
    height: 60.9
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 87.2,
    y: 52.5,
    className: "st361",
    width: 0.6,
    height: 60.9
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 52.5,
    className: "st362",
    width: 0.6,
    height: 60.9
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3,
    y: 52.5,
    className: "st363",
    width: 0.6,
    height: 60.9
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8,
    y: 52.5,
    className: "st364",
    width: 0.6,
    height: 60.9
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 52.5,
    className: "st365",
    width: 0.6,
    height: 60.9
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 52.5,
    className: "st366",
    width: 0.6,
    height: 60.9
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 52.5,
    className: "st367",
    width: 0.6,
    height: 60.9
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 52.5,
    className: "st368",
    width: 0.6,
    height: 60.9
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 52.5,
    className: "st369",
    width: 0.6,
    height: 60.9
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2,
    y: 52.5,
    className: "st370",
    width: 0.6,
    height: 60.9
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 52.5,
    className: "st371",
    width: 0.6,
    height: 60.9
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4,
    y: 52.5,
    className: "st372",
    width: 0.6,
    height: 60.9
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 52.5,
    className: "st373",
    width: 0.6,
    height: 60.9
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 52.5,
    className: "st374",
    width: 0.6,
    height: 60.9
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1,
    y: 52.5,
    className: "st375",
    width: 0.6,
    height: 60.9
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 95.6,
    y: 52.5,
    className: "st376",
    width: 0.6,
    height: 60.9
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2,
    y: 52.5,
    className: "st377",
    width: 0.6,
    height: 60.9
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 52.5,
    className: "st378",
    width: 0.6,
    height: 60.9
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 52.5,
    className: "st379",
    width: 0.6,
    height: 60.9
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 97.9,
    y: 52.5,
    className: "st380",
    width: 0.6,
    height: 60.9
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 52.5,
    className: "st381",
    width: 0.6,
    height: 60.9
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 52.5,
    className: "st382",
    width: 0.6,
    height: 60.9
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6,
    y: 52.5,
    className: "st383",
    width: 0.6,
    height: 60.9
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 100.1,
    y: 52.5,
    className: "st383",
    width: 2.6,
    height: 60.9
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 52.5,
    className: "st381",
    width: 2.6,
    height: 60.9
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 52.5,
    className: "st381",
    width: 0.3,
    height: 60.9
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 105.7,
    y: 52.5,
    className: "st380",
    width: 0.3,
    height: 60.9
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 52.5,
    className: "st379",
    width: 0.3,
    height: 60.9
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 106.4,
    y: 52.5,
    className: "st378",
    width: 0.3,
    height: 60.9
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 106.7,
    y: 52.5,
    className: "st376",
    width: 0.3,
    height: 60.9
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 52.5,
    className: "st375",
    width: 0.3,
    height: 60.9
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 107.4,
    y: 52.5,
    className: "st374",
    width: 0.3,
    height: 60.9
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 107.7,
    y: 52.5,
    className: "st373",
    width: 0.3,
    height: 60.9
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 52.5,
    className: "st372",
    width: 0.3,
    height: 60.9
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 52.5,
    className: "st372",
    width: 0.2,
    height: 60.9
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 52.5,
    className: "st371",
    width: 0.2,
    height: 60.9
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 52.5,
    className: "st370",
    width: 0.2,
    height: 60.9
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 108.9,
    y: 52.5,
    className: "st369",
    width: 0.2,
    height: 60.9
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 52.5,
    className: "st368",
    width: 0.2,
    height: 60.9
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 109.3,
    y: 52.5,
    className: "st367",
    width: 0.2,
    height: 60.9
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 52.5,
    className: "st384",
    width: 0.2,
    height: 60.9
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 52.5,
    className: "st385",
    width: 0.2,
    height: 60.9
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 52.5,
    className: "st386",
    width: 0.2,
    height: 60.9
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 52.5,
    className: "st387",
    width: 0.2,
    height: 60.9
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 110.3,
    y: 52.5,
    className: "st388",
    width: 0.2,
    height: 60.9
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 52.5,
    className: "st389",
    width: 0.2,
    height: 60.9
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 52.5,
    className: "st390",
    width: 0.2,
    height: 60.9
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 110.8,
    y: 52.5,
    className: "st391",
    width: 0.2,
    height: 60.9
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 52.5,
    className: "st392",
    width: 0.2,
    height: 60.9
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 52.5,
    className: "st393",
    width: 0.2,
    height: 60.9
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 111.4,
    y: 52.5,
    className: "st393",
    width: 0.1,
    height: 60.9
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 52.5,
    className: "st394",
    width: 0.1,
    height: 60.9
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 111.6,
    y: 52.5,
    className: "st395",
    width: 0.1,
    height: 60.9
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 52.5,
    className: "st396",
    width: 0.1,
    height: 60.9
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 111.8,
    y: 52.5,
    className: "st397",
    width: 0.1,
    height: 60.9
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 52.5,
    className: "st398",
    width: 0.1,
    height: 60.9
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 52.5,
    className: "st399",
    width: 0.1,
    height: 60.9
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 52.5,
    className: "st400",
    width: 0.1,
    height: 60.9
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 112.2,
    y: 52.5,
    className: "st401",
    width: 0.1,
    height: 60.9
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 52.5,
    className: "st402",
    width: 0.1,
    height: 60.9
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 52.5,
    className: "st403",
    width: 0.1,
    height: 60.9
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 52.5,
    className: "st404",
    width: 0.1,
    height: 60.9
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 52.5,
    className: "st405",
    width: 0.1,
    height: 60.9
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 112.7,
    y: 52.5,
    className: "st406",
    width: 0.1,
    height: 60.9
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 112.8,
    y: 52.5,
    className: "st407",
    width: 0.1,
    height: 60.9
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 52.5,
    className: "st408",
    width: 0.1,
    height: 60.9
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 52.5,
    className: "st409",
    width: 0.1,
    height: 60.9
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 113.1,
    y: 52.5,
    className: "st410",
    width: 0.1,
    height: 60.9
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 52.5,
    className: "st411",
    width: 0.1,
    height: 60.9
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 52.5,
    className: "st412",
    width: 0.1,
    height: 60.9
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 113.4,
    y: 52.5,
    className: "st413",
    width: 0.1,
    height: 60.9
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 52.5,
    className: "st414",
    width: 0.1,
    height: 60.9
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 113.6,
    y: 52.5,
    className: "st414",
    width: 0.1,
    height: 60.9
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 113.7,
    y: 52.5,
    className: "st415",
    width: 0.1,
    height: 60.9
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 113.8,
    y: 52.5,
    className: "st416",
    width: 0.1,
    height: 60.9
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 113.9,
    y: 52.5,
    className: "st417",
    width: 0.1,
    height: 60.9
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 114.1,
    y: 52.5,
    className: "st418",
    width: 0.1,
    height: 60.9
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 114.2,
    y: 52.5,
    className: "st419",
    width: 0.1,
    height: 60.9
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 114.3,
    y: 52.5,
    className: "st420",
    width: 0.1,
    height: 60.9
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 114.4,
    y: 52.5,
    className: "st421",
    width: 0.1,
    height: 60.9
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 114.5,
    y: 52.5,
    className: "st422",
    width: 0.1,
    height: 60.9
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 114.6,
    y: 52.5,
    className: "st423",
    width: 0.1,
    height: 60.9
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 52.5,
    className: "st424",
    width: 0.1,
    height: 60.9
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 52.5,
    className: "st425",
    width: 0.1,
    height: 60.9
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 114.9,
    y: 52.5,
    className: "st426",
    width: 0.1,
    height: 60.9
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 52.5,
    className: "st427",
    width: 0.1,
    height: 60.9
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 115.1,
    y: 52.5,
    className: "st428",
    width: 0.1,
    height: 60.9
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 115.2,
    y: 52.5,
    className: "st429",
    width: 0.1,
    height: 60.9
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 115.3,
    y: 52.5,
    className: "st430",
    width: 0.1,
    height: 60.9
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 52.5,
    className: "st431",
    width: 0.1,
    height: 60.9
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 115.6,
    y: 52.5,
    className: "st432",
    width: 0.1,
    height: 60.9
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 115.7,
    y: 52.5,
    className: "st433",
    width: 0.1,
    height: 60.9
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 115.8,
    y: 52.5,
    className: "st434",
    width: 0.1,
    height: 60.9
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 115.9,
    y: 52.5,
    className: "st435",
    width: 0.1,
    height: 60.9
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 52.5,
    className: "st436",
    width: 0.1,
    height: 60.9
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 52.5,
    className: "st437",
    width: 0.1,
    height: 60.9
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 52.5,
    className: "st438",
    width: 0.1,
    height: 60.9
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 116.3,
    y: 52.5,
    className: "st439",
    width: 0.1,
    height: 60.9
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 116.4,
    y: 52.5,
    className: "st440",
    width: 0.1,
    height: 60.9
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 52.5,
    className: "st441",
    width: 0.1,
    height: 60.9
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 116.6,
    y: 52.5,
    className: "st441",
    width: 0.1,
    height: 60.9
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 52.5,
    className: "st442",
    width: 0.1,
    height: 60.9
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 52.5,
    className: "st443",
    width: 0.1,
    height: 60.9
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 52.5,
    className: "st444",
    width: 0.1,
    height: 60.9
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 52.5,
    className: "st445",
    width: 0.1,
    height: 60.9
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 116.9,
    y: 52.5,
    className: "st446",
    width: 0.1,
    height: 60.9
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 52.5,
    className: "st447",
    width: 0.1,
    height: 60.9
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 52.5,
    className: "st448",
    width: 0.1,
    height: 60.9
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 117.1,
    y: 52.5,
    className: "st449",
    width: 0.1,
    height: 60.9
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 117.1,
    y: 52.5,
    className: "st450",
    width: 0.1,
    height: 60.9
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 52.5,
    className: "st451",
    width: 0.1,
    height: 60.9
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 52.5,
    className: "st452",
    width: 0.1,
    height: 60.9
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 52.5,
    className: "st453",
    width: 0.1,
    height: 60.9
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 52.5,
    className: "st454",
    width: 0.1,
    height: 60.9
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 117.4,
    y: 52.5,
    className: "st455",
    width: 0.1,
    height: 60.9
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 52.5,
    className: "st456",
    width: 0.1,
    height: 60.9
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 52.5,
    className: "st457",
    width: 0.1,
    height: 60.9
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 52.5,
    className: "st458",
    width: 0.1,
    height: 60.9
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 52.5,
    className: "st459",
    width: 0.1,
    height: 60.9
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 117.7,
    y: 52.5,
    className: "st460",
    width: 0.1,
    height: 60.9
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 117.7,
    y: 52.5,
    className: "st461",
    width: 0.1,
    height: 60.9
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 52.5,
    className: "st462",
    width: 0.1,
    height: 60.9
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 52.5,
    className: "st463",
    width: 0.1,
    height: 60.9
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 117.9,
    y: 52.5,
    className: "st464",
    width: 0.1,
    height: 60.9
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 52.5,
    className: "st465",
    width: 0.1,
    height: 60.9
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 52.5,
    className: "st466",
    width: 0.1,
    height: 60.9
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 118.1,
    y: 52.5,
    className: "st467",
    width: 0.1,
    height: 60.9
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 118.1,
    y: 52.5,
    className: "st467",
    width: 2,
    height: 60.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000144302878186776676730000002381848159791602597_",
    points: "18.7,95.2 42,104.6 48.2,114 24.6,103.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060719614788611256880000006060216089226556607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144302878186776676730000002381848159791602597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060719614788611256880000006060216089226556607_)"
    }
  }, _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 95.2,
    className: "st82",
    width: 0.3,
    height: 18.8
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 95.2,
    className: "st81",
    width: 0.3,
    height: 18.8
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 95.2,
    className: "st80",
    width: 0.3,
    height: 18.8
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 95.2,
    className: "st79",
    width: 0.3,
    height: 18.8
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 95.2,
    className: "st469",
    width: 0.3,
    height: 18.8
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 95.2,
    className: "st470",
    width: 0.3,
    height: 18.8
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 95.2,
    className: "st471",
    width: 0.3,
    height: 18.8
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 95.2,
    className: "st471",
    width: 0.4,
    height: 18.8
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 95.2,
    className: "st472",
    width: 0.4,
    height: 18.8
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 95.2,
    className: "st473",
    width: 0.4,
    height: 18.8
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 95.2,
    className: "st474",
    width: 0.4,
    height: 18.8
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 95.2,
    className: "st475",
    width: 0.4,
    height: 18.8
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 95.2,
    className: "st476",
    width: 0.4,
    height: 18.8
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 95.2,
    className: "st477",
    width: 0.4,
    height: 18.8
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 95.2,
    className: "st478",
    width: 0.4,
    height: 18.8
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 95.2,
    className: "st479",
    width: 0.4,
    height: 18.8
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 95.2,
    className: "st480",
    width: 0.4,
    height: 18.8
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4,
    y: 95.2,
    className: "st481",
    width: 0.4,
    height: 18.8
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 95.2,
    className: "st482",
    width: 0.4,
    height: 18.8
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 95.2,
    className: "st483",
    width: 0.4,
    height: 18.8
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 95.2,
    className: "st484",
    width: 0.4,
    height: 18.8
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 95.2,
    className: "st485",
    width: 0.4,
    height: 18.8
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 95.2,
    className: "st486",
    width: 0.4,
    height: 18.8
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 95.2,
    className: "st487",
    width: 0.4,
    height: 18.8
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 95.2,
    className: "st488",
    width: 0.4,
    height: 18.8
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 95.2,
    className: "st489",
    width: 0.4,
    height: 18.8
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6,
    y: 95.2,
    className: "st490",
    width: 0.4,
    height: 18.8
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 95.2,
    className: "st491",
    width: 0.4,
    height: 18.8
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 95.2,
    className: "st492",
    width: 0.4,
    height: 18.8
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 95.2,
    className: "st493",
    width: 0.4,
    height: 18.8
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 95.2,
    className: "st494",
    width: 0.4,
    height: 18.8
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 95.2,
    className: "st495",
    width: 0.4,
    height: 18.8
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 95.2,
    className: "st496",
    width: 0.4,
    height: 18.8
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1,
    y: 95.2,
    className: "st497",
    width: 0.4,
    height: 18.8
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 95.2,
    className: "st498",
    width: 0.4,
    height: 18.8
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 95.2,
    className: "st499",
    width: 0.4,
    height: 18.8
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 95.2,
    className: "st500",
    width: 0.4,
    height: 18.8
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 95.2,
    className: "st501",
    width: 0.4,
    height: 18.8
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 95.2,
    className: "st502",
    width: 0.4,
    height: 18.8
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 95.2,
    className: "st502",
    width: 0.5,
    height: 18.8
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 95.2,
    className: "st503",
    width: 0.5,
    height: 18.8
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 95.2,
    className: "st504",
    width: 0.5,
    height: 18.8
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 95.2,
    className: "st505",
    width: 0.5,
    height: 18.8
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 95.2,
    className: "st506",
    width: 0.5,
    height: 18.8
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6,
    y: 95.2,
    className: "st507",
    width: 0.5,
    height: 18.8
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1,
    y: 95.2,
    className: "st508",
    width: 0.5,
    height: 18.8
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 95.2,
    className: "st509",
    width: 0.5,
    height: 18.8
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 95.2,
    className: "st510",
    width: 0.5,
    height: 18.8
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 95.2,
    className: "st511",
    width: 0.5,
    height: 18.8
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 95.2,
    className: "st512",
    width: 0.5,
    height: 18.8
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 95.2,
    className: "st513",
    width: 0.5,
    height: 18.8
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 95.2,
    className: "st514",
    width: 0.5,
    height: 18.8
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 95.2,
    className: "st515",
    width: 0.5,
    height: 18.8
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 95.2,
    className: "st516",
    width: 0.5,
    height: 18.8
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 95.2,
    className: "st517",
    width: 0.5,
    height: 18.8
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8,
    y: 95.2,
    className: "st518",
    width: 0.5,
    height: 18.8
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 95.2,
    className: "st519",
    width: 0.5,
    height: 18.8
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8,
    y: 95.2,
    className: "st520",
    width: 0.5,
    height: 18.8
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 95.2,
    className: "st521",
    width: 0.5,
    height: 18.8
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: 95.2,
    className: "st521",
    width: 0.9,
    height: 18.8
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 42.7,
    y: 95.2,
    className: "st522",
    width: 0.9,
    height: 18.8
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 95.2,
    className: "st523",
    width: 0.9,
    height: 18.8
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 95.2,
    className: "st524",
    width: 0.9,
    height: 18.8
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 95.2,
    className: "st381",
    width: 0.9,
    height: 18.8
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 95.2,
    className: "st382",
    width: 0.9,
    height: 18.8
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 95.2,
    className: "st383",
    width: 0.9,
    height: 18.8
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098923205922084330060000001908068039804158638_",
    points: "24,99.3 39.8,105.7 42.3,109.5 26.3,102.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137827538648714160560000009901116781219562668_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098923205922084330060000001908068039804158638_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137827538648714160560000009901116781219562668_)"
    }
  }, _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 99.3,
    className: "st526",
    width: 0.7,
    height: 10.2
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 99.3,
    className: "st527",
    width: 0.7,
    height: 10.2
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 99.3,
    className: "st528",
    width: 0.7,
    height: 10.2
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 99.3,
    className: "st529",
    width: 0.7,
    height: 10.2
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7,
    y: 99.3,
    className: "st530",
    width: 0.7,
    height: 10.2
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 99.3,
    className: "st531",
    width: 0.7,
    height: 10.2
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 99.3,
    className: "st532",
    width: 0.7,
    height: 10.2
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 99.3,
    className: "st533",
    width: 0.7,
    height: 10.2
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 99.3,
    className: "st534",
    width: 0.7,
    height: 10.2
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 99.3,
    className: "st535",
    width: 0.7,
    height: 10.2
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 99.3,
    className: "st536",
    width: 0.7,
    height: 10.2
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3,
    y: 99.3,
    className: "st537",
    width: 0.7,
    height: 10.2
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 99.3,
    className: "st538",
    width: 0.7,
    height: 10.2
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 99.3,
    className: "st539",
    width: 0.7,
    height: 10.2
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 99.3,
    className: "st540",
    width: 0.7,
    height: 10.2
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 99.3,
    className: "st540",
    width: 1.2,
    height: 10.2
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1,
    y: 99.3,
    className: "st541",
    width: 1.2,
    height: 10.2
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 99.3,
    className: "st542",
    width: 1.2,
    height: 10.2
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 99.3,
    className: "st543",
    width: 1.2,
    height: 10.2
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 99.3,
    className: "st544",
    width: 1.2,
    height: 10.2
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 99.3,
    className: "st545",
    width: 1.2,
    height: 10.2
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1,
    y: 99.3,
    className: "st546",
    width: 1.2,
    height: 10.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157303238436304281510000006996741793305943456_",
    d: "M87.6,51.4c3-1.6,6.6-0.5,8.3,0l3.4,0.9l0.3-6.9 c0.1-1.6-0.6-3-1.9-3.9l-0.2-0.1c-1.6-1-3.7-0.5-4.7,1.1L87.6,51.4L87.6,51.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111881229966140701190000009046886464328989884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157303238436304281510000006996741793305943456_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111881229966140701190000009046886464328989884_)"
    }
  }, _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "99.2,52.3 99.6,51.8 99.6,52.3  "
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "98.9,52.3 99.6,51.5 99.6,51.8 99.2,52.3  "
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "98.5,52.3 99.6,51.1 99.6,51.5 98.9,52.3  "
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "98.2,52.3 99.6,50.8 99.6,51.1 98.5,52.3  "
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "st548",
    points: "97.8,52.3 99.6,50.4 99.6,50.8 98.2,52.3  "
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "st549",
    points: "97.5,52.3 99.6,50.1 99.6,50.4 97.8,52.3  "
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "st550",
    points: "97.1,52.3 99.6,49.7 99.6,50.1 97.5,52.3  "
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "st551",
    points: "96.8,52.3 99.6,49.4 99.6,49.7 97.1,52.3  "
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "st551",
    points: "96.6,52.3 99.6,49.2 99.6,49.4 96.8,52.3  "
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "st552",
    points: "96.4,52.3 99.6,49 99.6,49.2 96.6,52.3  "
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "st553",
    points: "96.2,52.3 99.6,48.8 99.6,49 96.4,52.3  "
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "st554",
    points: "96,52.3 99.6,48.7 99.6,48.8 96.2,52.3  "
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "st555",
    points: "95.9,52.3 99.6,48.5 99.6,48.7 96,52.3  "
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "st556",
    points: "95.7,52.3 99.6,48.3 99.6,48.5 95.9,52.3  "
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "st557",
    points: "95.5,52.3 99.6,48.1 99.6,48.3 95.7,52.3  "
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "st558",
    points: "95.3,52.3 99.6,47.9 99.6,48.1 95.5,52.3  "
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "st559",
    points: "95.1,52.3 99.6,47.8 99.6,47.9 95.3,52.3  "
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    className: "st560",
    points: "95,52.3 99.6,47.6 99.6,47.8 95.1,52.3  "
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    className: "st561",
    points: "94.8,52.3 99.6,47.4 99.6,47.6 95,52.3  "
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    className: "st524",
    points: "94.6,52.3 99.6,47.2 99.6,47.4 94.8,52.3  "
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    className: "st523",
    points: "94.4,52.3 99.6,47 99.6,47.2 94.6,52.3  "
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    className: "st522",
    points: "94.2,52.3 99.6,46.9 99.6,47 94.4,52.3  "
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    className: "st521",
    points: "94.1,52.3 99.6,46.7 99.6,46.9 94.2,52.3  "
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    className: "st520",
    points: "93.9,52.3 99.6,46.5 99.6,46.7 94.1,52.3  "
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    className: "st519",
    points: "93.7,52.3 99.6,46.3 99.6,46.5 93.9,52.3  "
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    className: "st518",
    points: "93.5,52.3 99.6,46.1 99.6,46.3 93.7,52.3  "
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    className: "st517",
    points: "93.3,52.3 99.6,46 99.6,46.1 93.5,52.3  "
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    className: "st516",
    points: "93.2,52.3 99.6,45.8 99.6,46 93.3,52.3  "
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    className: "st516",
    points: "93,52.3 99.6,45.6 99.6,45.8 93.2,52.3  "
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    className: "st515",
    points: "92.9,52.3 99.6,45.5 99.6,45.6 93,52.3  "
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    className: "st514",
    points: "92.8,52.3 99.6,45.4 99.6,45.5 92.9,52.3  "
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    className: "st513",
    points: "92.6,52.3 99.6,45.2 99.6,45.4 92.8,52.3  "
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    className: "st512",
    points: "92.5,52.3 99.6,45.1 99.6,45.2 92.6,52.3  "
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    className: "st562",
    points: "92.4,52.3 99.6,45 99.6,45.1 92.5,52.3  "
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    className: "st563",
    points: "92.2,52.3 99.6,44.8 99.6,45 92.4,52.3  "
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    className: "st564",
    points: "92.1,52.3 99.6,44.7 99.6,44.8 92.2,52.3  "
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    className: "st565",
    points: "92,52.3 99.6,44.6 99.6,44.7 92.1,52.3  "
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    className: "st566",
    points: "91.8,52.3 99.6,44.4 99.6,44.6 92,52.3  "
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    className: "st567",
    points: "91.7,52.3 99.6,44.3 99.6,44.4 91.8,52.3  "
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    className: "st568",
    points: "91.6,52.3 99.6,44.2 99.6,44.3 91.7,52.3  "
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    className: "st569",
    points: "91.4,52.3 99.6,44 99.6,44.2 91.6,52.3  "
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    className: "st570",
    points: "91.3,52.3 99.6,43.9 99.6,44 91.4,52.3  "
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    className: "st571",
    points: "91.2,52.3 99.6,43.8 99.6,43.9 91.3,52.3  "
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    className: "st572",
    points: "91,52.3 99.6,43.6 99.6,43.8 91.2,52.3  "
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    className: "st355",
    points: "90.9,52.3 99.6,43.5 99.6,43.6 91,52.3  "
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    className: "st573",
    points: "90.7,52.3 99.6,43.4 99.6,43.5 90.9,52.3  "
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    className: "st574",
    points: "90.6,52.3 99.6,43.2 99.6,43.4 90.7,52.3  "
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    className: "st575",
    points: "90.5,52.3 99.6,43.1 99.6,43.2 90.6,52.3  "
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    className: "st576",
    points: "90.3,52.3 99.6,43 99.6,43.1 90.5,52.3  "
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    className: "st577",
    points: "90.2,52.3 99.6,42.8 99.6,43 90.3,52.3  "
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    className: "st578",
    points: "90.1,52.3 99.6,42.7 99.6,42.8 90.2,52.3  "
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    className: "st579",
    points: "89.9,52.3 99.6,42.5 99.6,42.7 90.1,52.3  "
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    className: "st580",
    points: "89.8,52.3 99.6,42.4 99.6,42.5 89.9,52.3  "
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    className: "st581",
    points: "89.7,52.3 99.6,42.3 99.6,42.4 89.8,52.3  "
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    className: "st582",
    points: "89.5,52.3 99.6,42.1 99.6,42.3 89.7,52.3  "
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    className: "st583",
    points: "89.4,52.3 99.6,42 99.6,42.1 89.5,52.3  "
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    className: "st584",
    points: "89.3,52.3 99.6,41.9 99.6,42 89.4,52.3  "
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    className: "st585",
    points: "89.1,52.3 99.6,41.7 99.6,41.9 89.3,52.3  "
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    className: "st586",
    points: "89,52.3 99.6,41.6 99.6,41.7 89.1,52.3  "
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    className: "st587",
    points: "88.9,52.3 99.6,41.5 99.6,41.6 89,52.3  "
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    className: "st588",
    points: "88.7,52.3 99.6,41.4 99.6,41.4 99.6,41.5 88.9,52.3  "
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    className: "st588",
    points: "88.6,52.3 99.5,41.3 99.6,41.4 88.7,52.3  "
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    className: "st589",
    points: "88.5,52.3 99.5,41.3 99.5,41.3 88.6,52.3  "
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    className: "st590",
    points: "88.4,52.3 99.4,41.2 99.5,41.3 88.5,52.3  "
  })), _polygon351 || (_polygon351 = /*#__PURE__*/React.createElement("polygon", {
    className: "st591",
    points: "88.3,52.3 99.4,41.2 99.4,41.2 88.4,52.3  "
  })), _polygon352 || (_polygon352 = /*#__PURE__*/React.createElement("polygon", {
    className: "st592",
    points: "88.2,52.3 99.3,41.1 99.4,41.2 88.3,52.3  "
  })), _polygon353 || (_polygon353 = /*#__PURE__*/React.createElement("polygon", {
    className: "st593",
    points: "88.1,52.3 99.3,41.1 99.3,41.1 88.2,52.3  "
  })), _polygon354 || (_polygon354 = /*#__PURE__*/React.createElement("polygon", {
    className: "st594",
    points: "88,52.3 99.2,41 99.3,41.1 88.1,52.3  "
  })), _polygon355 || (_polygon355 = /*#__PURE__*/React.createElement("polygon", {
    className: "st595",
    points: "87.9,52.3 99.2,41 99.2,41 88,52.3  "
  })), _polygon356 || (_polygon356 = /*#__PURE__*/React.createElement("polygon", {
    className: "st596",
    points: "87.8,52.3 99.1,40.9 99.2,41 87.9,52.3  "
  })), _polygon357 || (_polygon357 = /*#__PURE__*/React.createElement("polygon", {
    className: "st597",
    points: "87.7,52.3 99.1,40.9 99.1,40.9 87.8,52.3  "
  })), _polygon358 || (_polygon358 = /*#__PURE__*/React.createElement("polygon", {
    className: "st598",
    points: "87.6,52.3 99,40.8 99.1,40.9 87.7,52.3  "
  })), _polygon359 || (_polygon359 = /*#__PURE__*/React.createElement("polygon", {
    className: "st599",
    points: "87.6,52.2 99,40.8 99,40.8 87.6,52.3 87.6,52.3  "
  })), _polygon360 || (_polygon360 = /*#__PURE__*/React.createElement("polygon", {
    className: "st600",
    points: "87.6,52.1 98.9,40.7 99,40.8 87.6,52.2  "
  })), _polygon361 || (_polygon361 = /*#__PURE__*/React.createElement("polygon", {
    className: "st601",
    points: "87.6,52 98.9,40.6 98.9,40.7 87.6,52.1  "
  })), _polygon362 || (_polygon362 = /*#__PURE__*/React.createElement("polygon", {
    className: "st602",
    points: "87.6,51.9 98.8,40.6 98.9,40.6 87.6,52  "
  })), _polygon363 || (_polygon363 = /*#__PURE__*/React.createElement("polygon", {
    className: "st603",
    points: "87.6,51.8 98.7,40.5 98.8,40.6 87.6,51.9  "
  })), _polygon364 || (_polygon364 = /*#__PURE__*/React.createElement("polygon", {
    className: "st604",
    points: "87.6,51.7 98.7,40.5 98.7,40.5 87.6,51.8  "
  })), _polygon365 || (_polygon365 = /*#__PURE__*/React.createElement("polygon", {
    className: "st605",
    points: "87.6,51.6 98.6,40.4 98.7,40.5 87.6,51.7  "
  })), _polygon366 || (_polygon366 = /*#__PURE__*/React.createElement("polygon", {
    className: "st606",
    points: "87.6,51.4 98.6,40.4 98.6,40.4 98.6,40.4 87.6,51.6  "
  })), _polygon367 || (_polygon367 = /*#__PURE__*/React.createElement("polygon", {
    className: "st607",
    points: "87.6,51.3 98.5,40.4 98.6,40.4 87.6,51.4  "
  })), _polygon368 || (_polygon368 = /*#__PURE__*/React.createElement("polygon", {
    className: "st608",
    points: "87.6,51.2 98.3,40.4 98.5,40.4 87.6,51.3  "
  })), _polygon369 || (_polygon369 = /*#__PURE__*/React.createElement("polygon", {
    className: "st609",
    points: "87.6,51.1 98.2,40.4 98.3,40.4 87.6,51.2  "
  })), _polygon370 || (_polygon370 = /*#__PURE__*/React.createElement("polygon", {
    className: "st317",
    points: "87.6,51 98.1,40.4 98.2,40.4 87.6,51.1  "
  })), _polygon371 || (_polygon371 = /*#__PURE__*/React.createElement("polygon", {
    className: "st610",
    points: "87.6,50.9 98,40.4 98.1,40.4 87.6,51  "
  })), _polygon372 || (_polygon372 = /*#__PURE__*/React.createElement("polygon", {
    className: "st611",
    points: "87.6,50.8 97.9,40.4 98,40.4 87.6,50.9  "
  })), _polygon373 || (_polygon373 = /*#__PURE__*/React.createElement("polygon", {
    className: "st612",
    points: "87.6,50.7 97.8,40.4 97.9,40.4 87.6,50.8  "
  })), _polygon374 || (_polygon374 = /*#__PURE__*/React.createElement("polygon", {
    className: "st613",
    points: "87.6,50.6 97.7,40.4 97.8,40.4 87.6,50.7  "
  })), _polygon375 || (_polygon375 = /*#__PURE__*/React.createElement("polygon", {
    className: "st614",
    points: "87.6,50.5 97.6,40.4 97.7,40.4 87.6,50.6  "
  })), _polygon376 || (_polygon376 = /*#__PURE__*/React.createElement("polygon", {
    className: "st615",
    points: "87.6,50.4 97.5,40.4 97.6,40.4 87.6,50.5  "
  })), _polygon377 || (_polygon377 = /*#__PURE__*/React.createElement("polygon", {
    className: "st616",
    points: "87.6,50.3 97.4,40.4 97.5,40.4 87.6,50.4  "
  })), _polygon378 || (_polygon378 = /*#__PURE__*/React.createElement("polygon", {
    className: "st617",
    points: "87.6,50.2 97.3,40.4 97.4,40.4 87.6,50.3  "
  })), _polygon379 || (_polygon379 = /*#__PURE__*/React.createElement("polygon", {
    className: "st618",
    points: "87.6,50.1 97.2,40.4 97.3,40.4 87.6,50.2  "
  })), _polygon380 || (_polygon380 = /*#__PURE__*/React.createElement("polygon", {
    className: "st619",
    points: "87.6,50 97.1,40.4 97.2,40.4 87.6,50.1  "
  })), _polygon381 || (_polygon381 = /*#__PURE__*/React.createElement("polygon", {
    className: "st620",
    points: "87.6,49.9 97,40.4 97.1,40.4 87.6,50  "
  })), _polygon382 || (_polygon382 = /*#__PURE__*/React.createElement("polygon", {
    className: "st621",
    points: "87.6,49.8 96.9,40.4 97,40.4 87.6,49.9  "
  })), _polygon383 || (_polygon383 = /*#__PURE__*/React.createElement("polygon", {
    className: "st622",
    points: "87.6,49.7 96.8,40.4 96.9,40.4 87.6,49.8  "
  })), _polygon384 || (_polygon384 = /*#__PURE__*/React.createElement("polygon", {
    className: "st623",
    points: "87.6,49.5 96.7,40.4 96.8,40.4 87.6,49.7  "
  })), _polygon385 || (_polygon385 = /*#__PURE__*/React.createElement("polygon", {
    className: "st624",
    points: "87.6,49.4 96.6,40.4 96.7,40.4 87.6,49.5  "
  })), _polygon386 || (_polygon386 = /*#__PURE__*/React.createElement("polygon", {
    className: "st625",
    points: "87.6,49.3 96.4,40.4 96.6,40.4 87.6,49.4  "
  })), _polygon387 || (_polygon387 = /*#__PURE__*/React.createElement("polygon", {
    className: "st626",
    points: "87.6,49.2 96.3,40.4 96.4,40.4 87.6,49.3  "
  })), _polygon388 || (_polygon388 = /*#__PURE__*/React.createElement("polygon", {
    className: "st299",
    points: "87.6,49.1 96.2,40.4 96.3,40.4 87.6,49.2  "
  })), _polygon389 || (_polygon389 = /*#__PURE__*/React.createElement("polygon", {
    className: "st298",
    points: "87.6,49 96.1,40.4 96.2,40.4 87.6,49.1  "
  })), _polygon390 || (_polygon390 = /*#__PURE__*/React.createElement("polygon", {
    className: "st297",
    points: "87.6,48.9 96,40.4 96.1,40.4 87.6,49  "
  })), _polygon391 || (_polygon391 = /*#__PURE__*/React.createElement("polygon", {
    className: "st296",
    points: "87.6,48.8 95.9,40.4 96,40.4 87.6,48.9  "
  })), _polygon392 || (_polygon392 = /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "87.6,48.7 95.8,40.4 95.9,40.4 87.6,48.8  "
  })), _polygon393 || (_polygon393 = /*#__PURE__*/React.createElement("polygon", {
    className: "st295",
    points: "87.6,48.6 95.7,40.4 95.8,40.4 87.6,48.7  "
  })), _polygon394 || (_polygon394 = /*#__PURE__*/React.createElement("polygon", {
    className: "st294",
    points: "87.6,48.5 95.6,40.4 95.7,40.4 87.6,48.6  "
  })), _polygon395 || (_polygon395 = /*#__PURE__*/React.createElement("polygon", {
    className: "st293",
    points: "87.6,48.4 95.5,40.4 95.6,40.4 87.6,48.5  "
  })), _polygon396 || (_polygon396 = /*#__PURE__*/React.createElement("polygon", {
    className: "st292",
    points: "87.6,48.3 95.4,40.4 95.5,40.4 87.6,48.4  "
  })), _polygon397 || (_polygon397 = /*#__PURE__*/React.createElement("polygon", {
    className: "st291",
    points: "87.6,48.2 95.3,40.4 95.4,40.4 87.6,48.3  "
  })), _polygon398 || (_polygon398 = /*#__PURE__*/React.createElement("polygon", {
    className: "st290",
    points: "87.6,48.1 95.2,40.4 95.3,40.4 87.6,48.2  "
  })), _polygon399 || (_polygon399 = /*#__PURE__*/React.createElement("polygon", {
    className: "st288",
    points: "87.6,48 95.1,40.4 95.2,40.4 87.6,48.1  "
  })), _polygon400 || (_polygon400 = /*#__PURE__*/React.createElement("polygon", {
    className: "st287",
    points: "87.6,47.9 95.1,40.4 95.1,40.4 87.6,48  "
  })), _polygon401 || (_polygon401 = /*#__PURE__*/React.createElement("polygon", {
    className: "st286",
    points: "87.6,47.8 95,40.4 95.1,40.4 87.6,47.9  "
  })), _polygon402 || (_polygon402 = /*#__PURE__*/React.createElement("polygon", {
    className: "st285",
    points: "87.6,47.7 94.9,40.4 95,40.4 87.6,47.8  "
  })), _polygon403 || (_polygon403 = /*#__PURE__*/React.createElement("polygon", {
    className: "st284",
    points: "87.6,47.6 94.8,40.4 94.9,40.4 87.6,47.7  "
  })), _polygon404 || (_polygon404 = /*#__PURE__*/React.createElement("polygon", {
    className: "st283",
    points: "87.6,47.5 94.7,40.4 94.8,40.4 87.6,47.6  "
  })), _polygon405 || (_polygon405 = /*#__PURE__*/React.createElement("polygon", {
    className: "st283",
    points: "94.7,40.4 87.6,47.5 87.6,40.4  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124859030419600699260000009365650211712827815_",
    d: "M95.9,40.9l-4.4-0.8c-0.1,0-0.1,0-0.2,0h0 c-1.2-0.2-2.5,0.4-3.2,1.5L82.3,50l5.3,1.4l5.2-8.9C93.4,41.4,94.7,40.8,95.9,40.9L95.9,40.9L95.9,40.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117671330484801589240000015121254407632758424_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124859030419600699260000009365650211712827815_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000117671330484801589240000015121254407632758424_)"
    }
  }, _polygon406 || (_polygon406 = /*#__PURE__*/React.createElement("polygon", {
    className: "st628",
    points: "82.3,50.8 85.6,51.4 82.3,51.4  "
  })), _polygon407 || (_polygon407 = /*#__PURE__*/React.createElement("polygon", {
    className: "st628",
    points: "82.3,50.8 85.7,51.4 85.6,51.4 82.3,50.8  "
  })), _polygon408 || (_polygon408 = /*#__PURE__*/React.createElement("polygon", {
    className: "st629",
    points: "82.3,50.8 85.8,51.4 85.7,51.4 82.3,50.8  "
  })), _polygon409 || (_polygon409 = /*#__PURE__*/React.createElement("polygon", {
    className: "st630",
    points: "82.3,50.7 86,51.4 85.8,51.4 82.3,50.8  "
  })), _polygon410 || (_polygon410 = /*#__PURE__*/React.createElement("polygon", {
    className: "st631",
    points: "82.3,50.7 86.1,51.4 86,51.4 82.3,50.7  "
  })), _polygon411 || (_polygon411 = /*#__PURE__*/React.createElement("polygon", {
    className: "st632",
    points: "82.3,50.7 86.2,51.4 86.1,51.4 82.3,50.7  "
  })), _polygon412 || (_polygon412 = /*#__PURE__*/React.createElement("polygon", {
    className: "st633",
    points: "82.3,50.7 86.3,51.4 86.2,51.4 82.3,50.7  "
  })), _polygon413 || (_polygon413 = /*#__PURE__*/React.createElement("polygon", {
    className: "st634",
    points: "82.3,50.7 86.4,51.4 86.3,51.4 82.3,50.7  "
  })), _polygon414 || (_polygon414 = /*#__PURE__*/React.createElement("polygon", {
    className: "st635",
    points: "82.3,50.6 86.5,51.4 86.4,51.4 82.3,50.7  "
  })), _polygon415 || (_polygon415 = /*#__PURE__*/React.createElement("polygon", {
    className: "st636",
    points: "82.3,50.6 86.7,51.4 86.5,51.4 82.3,50.6  "
  })), _polygon416 || (_polygon416 = /*#__PURE__*/React.createElement("polygon", {
    className: "st637",
    points: "82.3,50.6 86.8,51.4 86.7,51.4 82.3,50.6  "
  })), _polygon417 || (_polygon417 = /*#__PURE__*/React.createElement("polygon", {
    className: "st638",
    points: "82.3,50.6 86.9,51.4 86.8,51.4 82.3,50.6  "
  })), _polygon418 || (_polygon418 = /*#__PURE__*/React.createElement("polygon", {
    className: "st639",
    points: "82.3,50.5 87,51.4 86.9,51.4 82.3,50.6  "
  })), _polygon419 || (_polygon419 = /*#__PURE__*/React.createElement("polygon", {
    className: "st640",
    points: "82.3,50.5 87.1,51.4 87,51.4 82.3,50.5  "
  })), _polygon420 || (_polygon420 = /*#__PURE__*/React.createElement("polygon", {
    className: "st641",
    points: "82.3,50.5 87.3,51.4 87.1,51.4 82.3,50.5  "
  })), _polygon421 || (_polygon421 = /*#__PURE__*/React.createElement("polygon", {
    className: "st642",
    points: "82.3,50.5 87.4,51.4 87.3,51.4 82.3,50.5  "
  })), _polygon422 || (_polygon422 = /*#__PURE__*/React.createElement("polygon", {
    className: "st643",
    points: "82.3,50.5 87.5,51.4 87.4,51.4 82.3,50.5  "
  })), _polygon423 || (_polygon423 = /*#__PURE__*/React.createElement("polygon", {
    className: "st644",
    points: "82.3,50.4 87.6,51.4 87.5,51.4 82.3,50.5  "
  })), _polygon424 || (_polygon424 = /*#__PURE__*/React.createElement("polygon", {
    className: "st644",
    points: "82.3,50.4 87.7,51.4 87.6,51.4 82.3,50.4  "
  })), _polygon425 || (_polygon425 = /*#__PURE__*/React.createElement("polygon", {
    className: "st645",
    points: "82.3,50.4 87.9,51.4 87.7,51.4 82.3,50.4  "
  })), _polygon426 || (_polygon426 = /*#__PURE__*/React.createElement("polygon", {
    className: "st646",
    points: "82.3,50.4 88,51.4 87.9,51.4 82.3,50.4  "
  })), _polygon427 || (_polygon427 = /*#__PURE__*/React.createElement("polygon", {
    className: "st647",
    points: "82.3,50.3 88.1,51.4 88,51.4 82.3,50.4  "
  })), _polygon428 || (_polygon428 = /*#__PURE__*/React.createElement("polygon", {
    className: "st648",
    points: "82.3,50.3 88.2,51.4 88.1,51.4 82.3,50.3  "
  })), _polygon429 || (_polygon429 = /*#__PURE__*/React.createElement("polygon", {
    className: "st649",
    points: "82.3,50.3 88.4,51.4 88.2,51.4 82.3,50.3  "
  })), _polygon430 || (_polygon430 = /*#__PURE__*/React.createElement("polygon", {
    className: "st650",
    points: "82.3,50.3 88.5,51.4 88.4,51.4 82.3,50.3  "
  })), _polygon431 || (_polygon431 = /*#__PURE__*/React.createElement("polygon", {
    className: "st651",
    points: "82.3,50.2 88.6,51.4 88.5,51.4 82.3,50.3  "
  })), _polygon432 || (_polygon432 = /*#__PURE__*/React.createElement("polygon", {
    className: "st652",
    points: "82.3,50.2 88.8,51.4 88.6,51.4 82.3,50.2  "
  })), _polygon433 || (_polygon433 = /*#__PURE__*/React.createElement("polygon", {
    className: "st653",
    points: "82.3,50.2 88.9,51.4 88.8,51.4 82.3,50.2  "
  })), _polygon434 || (_polygon434 = /*#__PURE__*/React.createElement("polygon", {
    className: "st654",
    points: "82.3,50.2 89,51.4 88.9,51.4 82.3,50.2  "
  })), _polygon435 || (_polygon435 = /*#__PURE__*/React.createElement("polygon", {
    className: "st655",
    points: "82.3,50.1 89.2,51.4 89,51.4 82.3,50.2  "
  })), _polygon436 || (_polygon436 = /*#__PURE__*/React.createElement("polygon", {
    className: "st656",
    points: "82.3,50.1 89.3,51.4 89.2,51.4 82.3,50.1  "
  })), _polygon437 || (_polygon437 = /*#__PURE__*/React.createElement("polygon", {
    className: "st657",
    points: "82.3,50.1 89.4,51.4 89.3,51.4 82.3,50.1  "
  })), _polygon438 || (_polygon438 = /*#__PURE__*/React.createElement("polygon", {
    className: "st658",
    points: "82.3,50.1 89.5,51.4 89.4,51.4 82.3,50.1  "
  })), _polygon439 || (_polygon439 = /*#__PURE__*/React.createElement("polygon", {
    className: "st659",
    points: "82.3,50.1 89.7,51.4 89.5,51.4 82.3,50.1  "
  })), _polygon440 || (_polygon440 = /*#__PURE__*/React.createElement("polygon", {
    className: "st660",
    points: "82.3,50 89.8,51.4 89.7,51.4 82.3,50.1  "
  })), _polygon441 || (_polygon441 = /*#__PURE__*/React.createElement("polygon", {
    className: "st661",
    points: "82.3,50 89.9,51.4 89.8,51.4 82.3,50  "
  })), _polygon442 || (_polygon442 = /*#__PURE__*/React.createElement("polygon", {
    className: "st662",
    points: "82.3,50 90.1,51.4 89.9,51.4 82.3,50  "
  })), _polygon443 || (_polygon443 = /*#__PURE__*/React.createElement("polygon", {
    className: "st663",
    points: "82.3,50 90.2,51.4 90.1,51.4 82.3,50  "
  })), _polygon444 || (_polygon444 = /*#__PURE__*/React.createElement("polygon", {
    className: "st664",
    points: "82.3,49.9 90.3,51.4 90.2,51.4 82.3,50  "
  })), _polygon445 || (_polygon445 = /*#__PURE__*/React.createElement("polygon", {
    className: "st665",
    points: "82.3,49.9 90.4,51.4 90.3,51.4 82.3,49.9  "
  })), _polygon446 || (_polygon446 = /*#__PURE__*/React.createElement("polygon", {
    className: "st666",
    points: "82.3,49.9 90.6,51.4 90.4,51.4 82.3,49.9  "
  })), _polygon447 || (_polygon447 = /*#__PURE__*/React.createElement("polygon", {
    className: "st667",
    points: "82.3,49.9 90.7,51.4 90.6,51.4 82.3,49.9  "
  })), _polygon448 || (_polygon448 = /*#__PURE__*/React.createElement("polygon", {
    className: "st668",
    points: "82.3,49.8 90.8,51.4 90.7,51.4 82.3,49.9  "
  })), _polygon449 || (_polygon449 = /*#__PURE__*/React.createElement("polygon", {
    className: "st669",
    points: "82.3,49.8 91,51.4 90.8,51.4 82.3,49.8  "
  })), _polygon450 || (_polygon450 = /*#__PURE__*/React.createElement("polygon", {
    className: "st670",
    points: "82.3,49.8 91.1,51.4 91,51.4 82.3,49.8  "
  })), _polygon451 || (_polygon451 = /*#__PURE__*/React.createElement("polygon", {
    className: "st671",
    points: "82.3,49.8 91.2,51.4 91.1,51.4 82.3,49.8  "
  })), _polygon452 || (_polygon452 = /*#__PURE__*/React.createElement("polygon", {
    className: "st672",
    points: "82.3,49.7 91.4,51.4 91.2,51.4 82.3,49.8  "
  })), _polygon453 || (_polygon453 = /*#__PURE__*/React.createElement("polygon", {
    className: "st673",
    points: "82.3,49.7 91.5,51.4 91.4,51.4 82.3,49.7  "
  })), _polygon454 || (_polygon454 = /*#__PURE__*/React.createElement("polygon", {
    className: "st674",
    points: "82.3,49.7 91.6,51.4 91.5,51.4 82.3,49.7  "
  })), _polygon455 || (_polygon455 = /*#__PURE__*/React.createElement("polygon", {
    className: "st674",
    points: "82.3,49.7 91.8,51.4 91.6,51.4 82.3,49.7  "
  })), _polygon456 || (_polygon456 = /*#__PURE__*/React.createElement("polygon", {
    className: "st675",
    points: "82.3,49.6 91.9,51.4 91.8,51.4 82.3,49.7  "
  })), _polygon457 || (_polygon457 = /*#__PURE__*/React.createElement("polygon", {
    className: "st676",
    points: "82.3,49.6 92.1,51.4 91.9,51.4 82.3,49.6  "
  })), _polygon458 || (_polygon458 = /*#__PURE__*/React.createElement("polygon", {
    className: "st677",
    points: "82.3,49.6 92.2,51.4 92.1,51.4 82.3,49.6  "
  })), _polygon459 || (_polygon459 = /*#__PURE__*/React.createElement("polygon", {
    className: "st678",
    points: "82.3,49.5 92.4,51.4 92.2,51.4 82.3,49.6  "
  })), _polygon460 || (_polygon460 = /*#__PURE__*/React.createElement("polygon", {
    className: "st679",
    points: "82.3,49.5 92.5,51.4 92.4,51.4 82.3,49.5  "
  })), _polygon461 || (_polygon461 = /*#__PURE__*/React.createElement("polygon", {
    className: "st680",
    points: "82.3,49.5 92.7,51.4 92.5,51.4 82.3,49.5  "
  })), _polygon462 || (_polygon462 = /*#__PURE__*/React.createElement("polygon", {
    className: "st681",
    points: "82.3,49.5 92.8,51.4 92.7,51.4 82.3,49.5  "
  })), _polygon463 || (_polygon463 = /*#__PURE__*/React.createElement("polygon", {
    className: "st682",
    points: "82.3,49.4 93,51.4 92.8,51.4 82.3,49.5  "
  })), _polygon464 || (_polygon464 = /*#__PURE__*/React.createElement("polygon", {
    className: "st683",
    points: "82.3,49.4 93.1,51.4 93,51.4 82.3,49.4  "
  })), _polygon465 || (_polygon465 = /*#__PURE__*/React.createElement("polygon", {
    className: "st684",
    points: "82.3,49.4 93.3,51.4 93.1,51.4 82.3,49.4  "
  })), _polygon466 || (_polygon466 = /*#__PURE__*/React.createElement("polygon", {
    className: "st685",
    points: "82.3,49.3 93.5,51.4 93.3,51.4 82.3,49.4  "
  })), _polygon467 || (_polygon467 = /*#__PURE__*/React.createElement("polygon", {
    className: "st281",
    points: "82.3,49.3 93.6,51.4 93.5,51.4 82.3,49.3  "
  })), _polygon468 || (_polygon468 = /*#__PURE__*/React.createElement("polygon", {
    className: "st281",
    points: "82.3,49.3 93.8,51.4 93.6,51.4 82.3,49.3  "
  })), _polygon469 || (_polygon469 = /*#__PURE__*/React.createElement("polygon", {
    className: "st280",
    points: "82.3,49.2 94,51.4 93.8,51.4 82.3,49.3  "
  })), _polygon470 || (_polygon470 = /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "82.3,49.2 94.2,51.4 94,51.4 82.3,49.2  "
  })), _polygon471 || (_polygon471 = /*#__PURE__*/React.createElement("polygon", {
    className: "st278",
    points: "82.3,49.2 94.4,51.4 94.2,51.4 82.3,49.2  "
  })), _polygon472 || (_polygon472 = /*#__PURE__*/React.createElement("polygon", {
    className: "st277",
    points: "82.3,49.1 94.6,51.4 94.4,51.4 82.3,49.2  "
  })), _polygon473 || (_polygon473 = /*#__PURE__*/React.createElement("polygon", {
    className: "st276",
    points: "82.3,49.1 94.9,51.4 94.6,51.4 82.3,49.1  "
  })), _polygon474 || (_polygon474 = /*#__PURE__*/React.createElement("polygon", {
    className: "st275",
    points: "82.3,49 95.1,51.4 94.9,51.4 82.3,49.1  "
  })), _polygon475 || (_polygon475 = /*#__PURE__*/React.createElement("polygon", {
    className: "st274",
    points: "82.3,49 95.1,51.4 95.1,51.4 95.1,51.4 82.3,49  "
  })), _polygon476 || (_polygon476 = /*#__PURE__*/React.createElement("polygon", {
    className: "st273",
    points: "82.3,49 95.2,51.4 95.1,51.4 82.3,49  "
  })), _polygon477 || (_polygon477 = /*#__PURE__*/React.createElement("polygon", {
    className: "st272",
    points: "82.3,48.9 95.2,51.3 95.2,51.4 82.3,49  "
  })), _polygon478 || (_polygon478 = /*#__PURE__*/React.createElement("polygon", {
    className: "st271",
    points: "82.3,48.9 95.2,51.3 95.2,51.3 82.3,48.9  "
  })), _polygon479 || (_polygon479 = /*#__PURE__*/React.createElement("polygon", {
    className: "st270",
    points: "82.3,48.8 95.2,51.3 95.2,51.3 82.3,48.9  "
  })), _polygon480 || (_polygon480 = /*#__PURE__*/React.createElement("polygon", {
    className: "st269",
    points: "82.3,48.8 95.2,51.2 95.2,51.3 82.3,48.8  "
  })), _polygon481 || (_polygon481 = /*#__PURE__*/React.createElement("polygon", {
    className: "st268",
    points: "82.3,48.8 95.2,51.2 95.2,51.2 82.3,48.8  "
  })), _polygon482 || (_polygon482 = /*#__PURE__*/React.createElement("polygon", {
    className: "st267",
    points: "82.3,48.7 95.2,51.1 95.2,51.2 82.3,48.8  "
  })), _polygon483 || (_polygon483 = /*#__PURE__*/React.createElement("polygon", {
    className: "st266",
    points: "82.3,48.7 95.2,51.1 95.2,51.1 82.3,48.7  "
  })), _polygon484 || (_polygon484 = /*#__PURE__*/React.createElement("polygon", {
    className: "st266",
    points: "82.3,48.7 95.2,51.1 95.2,51.1 82.3,48.7  "
  })), _polygon485 || (_polygon485 = /*#__PURE__*/React.createElement("polygon", {
    className: "st265",
    points: "82.3,48.6 95.2,51 95.2,51.1 82.3,48.7  "
  })), _polygon486 || (_polygon486 = /*#__PURE__*/React.createElement("polygon", {
    className: "st264",
    points: "82.3,48.6 95.2,51 95.2,51 82.3,48.6  "
  })), _polygon487 || (_polygon487 = /*#__PURE__*/React.createElement("polygon", {
    className: "st263",
    points: "82.3,48.5 95.2,50.9 95.2,51 82.3,48.6  "
  })), _polygon488 || (_polygon488 = /*#__PURE__*/React.createElement("polygon", {
    className: "st262",
    points: "82.3,48.5 95.2,50.9 95.2,50.9 82.3,48.5  "
  })), _polygon489 || (_polygon489 = /*#__PURE__*/React.createElement("polygon", {
    className: "st261",
    points: "82.3,48.4 95.3,50.9 95.2,50.9 82.3,48.5  "
  })), _polygon490 || (_polygon490 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "82.3,48.4 95.3,50.8 95.3,50.9 82.3,48.4  "
  })), _polygon491 || (_polygon491 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "82.3,48.4 95.3,50.8 95.3,50.8 82.3,48.4  "
  })), _polygon492 || (_polygon492 = /*#__PURE__*/React.createElement("polygon", {
    className: "st258",
    points: "82.3,48.3 95.3,50.7 95.3,50.8 82.3,48.4  "
  })), _polygon493 || (_polygon493 = /*#__PURE__*/React.createElement("polygon", {
    className: "st257",
    points: "82.3,48.3 95.3,50.7 95.3,50.7 82.3,48.3  "
  })), _polygon494 || (_polygon494 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "82.3,48.2 95.3,50.7 95.3,50.7 82.3,48.3  "
  })), _polygon495 || (_polygon495 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "82.3,48.2 95.3,50.6 95.3,50.7 82.3,48.2  "
  })), _polygon496 || (_polygon496 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "82.3,48.1 95.3,50.6 95.3,50.6 82.3,48.2  "
  })), _polygon497 || (_polygon497 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "82.3,48.1 95.3,50.5 95.3,50.6 82.3,48.1  "
  })), _polygon498 || (_polygon498 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "82.3,48 95.3,50.5 95.3,50.5 82.3,48.1  "
  })), _polygon499 || (_polygon499 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "82.3,48 95.3,50.4 95.3,50.5 82.3,48  "
  })), _polygon500 || (_polygon500 = /*#__PURE__*/React.createElement("polygon", {
    className: "st250",
    points: "82.3,48 95.3,50.4 95.3,50.4 82.3,48  "
  })), _polygon501 || (_polygon501 = /*#__PURE__*/React.createElement("polygon", {
    className: "st249",
    points: "82.3,47.9 95.3,50.4 95.3,50.4 82.3,48  "
  })), _polygon502 || (_polygon502 = /*#__PURE__*/React.createElement("polygon", {
    className: "st248",
    points: "82.3,47.9 95.4,50.3 95.3,50.4 82.3,47.9  "
  })), _polygon503 || (_polygon503 = /*#__PURE__*/React.createElement("polygon", {
    className: "st247",
    points: "82.3,47.8 95.4,50.3 95.4,50.3 82.3,47.9  "
  })), _polygon504 || (_polygon504 = /*#__PURE__*/React.createElement("polygon", {
    className: "st246",
    points: "82.3,47.8 95.4,50.2 95.4,50.3 82.3,47.8  "
  })), _polygon505 || (_polygon505 = /*#__PURE__*/React.createElement("polygon", {
    className: "st245",
    points: "82.3,47.8 95.4,50.2 95.4,50.2 82.3,47.8  "
  })), _polygon506 || (_polygon506 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "82.3,47.7 95.4,50.2 95.4,50.2 82.3,47.8  "
  })), _polygon507 || (_polygon507 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "82.3,47.7 95.4,50.1 95.4,50.2 82.3,47.7  "
  })), _polygon508 || (_polygon508 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "82.3,47.6 95.4,50.1 95.4,50.1 82.3,47.7  "
  })), _polygon509 || (_polygon509 = /*#__PURE__*/React.createElement("polygon", {
    className: "st241",
    points: "82.3,47.6 95.4,50 95.4,50.1 82.3,47.6  "
  })), _polygon510 || (_polygon510 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "82.3,47.5 95.4,50 95.4,50 82.3,47.6  "
  })), _polygon511 || (_polygon511 = /*#__PURE__*/React.createElement("polygon", {
    className: "st239",
    points: "82.3,47.5 95.4,50 95.4,50 82.3,47.5  "
  })), _polygon512 || (_polygon512 = /*#__PURE__*/React.createElement("polygon", {
    className: "st238",
    points: "82.3,47.5 95.4,49.9 95.4,50 82.3,47.5  "
  })), _polygon513 || (_polygon513 = /*#__PURE__*/React.createElement("polygon", {
    className: "st237",
    points: "82.3,47.4 95.4,49.9 95.4,49.9 82.3,47.5  "
  })), _polygon514 || (_polygon514 = /*#__PURE__*/React.createElement("polygon", {
    className: "st236",
    points: "82.3,47.4 95.4,49.8 95.4,49.9 82.3,47.4  "
  })), _polygon515 || (_polygon515 = /*#__PURE__*/React.createElement("polygon", {
    className: "st235",
    points: "82.3,47.3 95.5,49.8 95.4,49.8 82.3,47.4  "
  })), _polygon516 || (_polygon516 = /*#__PURE__*/React.createElement("polygon", {
    className: "st235",
    points: "82.3,47.3 95.5,49.7 95.5,49.8 82.3,47.3  "
  })), _polygon517 || (_polygon517 = /*#__PURE__*/React.createElement("polygon", {
    className: "st234",
    points: "82.3,47.2 95.5,49.7 95.5,49.7 82.3,47.3  "
  })), _polygon518 || (_polygon518 = /*#__PURE__*/React.createElement("polygon", {
    className: "st233",
    points: "82.3,47.1 95.5,49.6 95.5,49.7 82.3,47.2  "
  })), _polygon519 || (_polygon519 = /*#__PURE__*/React.createElement("polygon", {
    className: "st232",
    points: "82.3,47.1 95.5,49.5 95.5,49.6 82.3,47.1  "
  })), _polygon520 || (_polygon520 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "82.3,47 95.5,49.5 95.5,49.5 82.3,47.1  "
  })), _polygon521 || (_polygon521 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "82.3,46.9 95.5,49.4 95.5,49.5 82.3,47  "
  })), _polygon522 || (_polygon522 = /*#__PURE__*/React.createElement("polygon", {
    className: "st231",
    points: "82.3,46.9 95.5,49.3 95.5,49.4 82.3,46.9  "
  })), _polygon523 || (_polygon523 = /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "82.3,46.8 95.6,49.3 95.5,49.3 82.3,46.9  "
  })), _polygon524 || (_polygon524 = /*#__PURE__*/React.createElement("polygon", {
    className: "st229",
    points: "82.3,46.7 95.6,49.2 95.6,49.3 82.3,46.8  "
  })), _polygon525 || (_polygon525 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "82.3,46.7 95.6,49.1 95.6,49.2 82.3,46.7  "
  })), _polygon526 || (_polygon526 = /*#__PURE__*/React.createElement("polygon", {
    className: "st227",
    points: "82.3,46.6 95.6,49.1 95.6,49.1 82.3,46.7  "
  })), _polygon527 || (_polygon527 = /*#__PURE__*/React.createElement("polygon", {
    className: "st226",
    points: "82.3,46.5 95.6,49 95.6,49.1 82.3,46.6  "
  })), _polygon528 || (_polygon528 = /*#__PURE__*/React.createElement("polygon", {
    className: "st225",
    points: "82.3,46.5 95.6,48.9 95.6,49 82.3,46.5  "
  })), _polygon529 || (_polygon529 = /*#__PURE__*/React.createElement("polygon", {
    className: "st225",
    points: "82.3,45.1 95.8,47.7 95.6,48.9 82.3,46.5  "
  })), _polygon530 || (_polygon530 = /*#__PURE__*/React.createElement("polygon", {
    className: "st224",
    points: "82.3,43.8 95.9,46.4 95.9,47.4 95.8,47.7 82.3,45.1  "
  })), _polygon531 || (_polygon531 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "82.3,43.5 82.5,42.6 95.9,45.1 95.9,46.4 82.3,43.8  "
  })), _polygon532 || (_polygon532 = /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "82.5,42.6 82.7,41.3 95.9,43.8 95.9,45.1  "
  })), _polygon533 || (_polygon533 = /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "82.7,41.3 82.7,41.2 95.9,43.7 95.9,43.8  "
  })), _polygon534 || (_polygon534 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "82.7,41.2 82.7,41.2 95.9,43.6 95.9,43.7  "
  })), _polygon535 || (_polygon535 = /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "82.7,41.2 82.7,41.1 95.9,43.6 95.9,43.6  "
  })), _polygon536 || (_polygon536 = /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "82.7,41.1 82.7,41.1 95.9,43.5 95.9,43.6  "
  })), _polygon537 || (_polygon537 = /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "82.7,41.1 82.7,41 95.9,43.5 95.9,43.5  "
  })), _polygon538 || (_polygon538 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "82.7,41 82.8,40.9 95.9,43.4 95.9,43.5  "
  })), _polygon539 || (_polygon539 = /*#__PURE__*/React.createElement("polygon", {
    className: "st218",
    points: "82.8,40.9 82.8,40.9 95.9,43.4 95.9,43.4  "
  })), _polygon540 || (_polygon540 = /*#__PURE__*/React.createElement("polygon", {
    className: "st217",
    points: "82.8,40.9 82.8,40.9 95.9,43.3 95.9,43.4  "
  })), _polygon541 || (_polygon541 = /*#__PURE__*/React.createElement("polygon", {
    className: "st216",
    points: "82.8,40.9 82.8,40.8 95.9,43.3 95.9,43.3  "
  })), _polygon542 || (_polygon542 = /*#__PURE__*/React.createElement("polygon", {
    className: "st215",
    points: "82.8,40.8 82.8,40.8 95.9,43.3 95.9,43.3  "
  })), _polygon543 || (_polygon543 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "82.8,40.8 82.8,40.8 95.9,43.2 95.9,43.3  "
  })), _polygon544 || (_polygon544 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "82.8,40.8 82.8,40.7 95.9,43.2 95.9,43.2  "
  })), _polygon545 || (_polygon545 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "82.8,40.7 82.8,40.7 95.9,43.2 95.9,43.2  "
  })), _polygon546 || (_polygon546 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "82.8,40.7 82.8,40.7 95.9,43.1 95.9,43.2  "
  })), _polygon547 || (_polygon547 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "82.8,40.7 82.8,40.7 95.9,43.1 95.9,43.1  "
  })), _polygon548 || (_polygon548 = /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "82.8,40.7 82.8,40.6 95.9,43.1 95.9,43.1  "
  })), _polygon549 || (_polygon549 = /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "82.8,40.6 82.8,40.6 95.9,43 95.9,43.1  "
  })), _polygon550 || (_polygon550 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "82.8,40.6 82.8,40.5 95.9,43 95.9,43  "
  })), _polygon551 || (_polygon551 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "82.8,40.5 82.8,40.5 95.9,43 95.9,43  "
  })), _polygon552 || (_polygon552 = /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "82.8,40.5 82.8,40.5 95.9,42.9 95.9,43  "
  })), _polygon553 || (_polygon553 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "82.8,40.5 82.8,40.5 95.9,42.9 95.9,42.9  "
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 35,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.005 121.8656)",
    className: "st204",
    width: 0,
    height: 13.3
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 35,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.0232 121.8561)",
    className: "st203",
    width: 0,
    height: 13.3
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 35,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.0451 121.8402)",
    className: "st202",
    width: 0,
    height: 13.3
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 35,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.068 121.8266)",
    className: "st201",
    width: 0,
    height: 13.3
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 35,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.088 121.8203)",
    className: "st200",
    width: 0,
    height: 13.3
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.108 121.8012)",
    className: "st199",
    width: 0,
    height: 13.3
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.1272 121.7809)",
    className: "st198",
    width: 0,
    height: 13.2
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.1473 121.7746)",
    className: "st197",
    width: 0,
    height: 13.2
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.1607 121.7592)",
    className: "st196",
    width: 0,
    height: 13.2
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.1884 121.7385)",
    className: "st195",
    width: 0,
    height: 13.2
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.9,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.2066 121.7289)",
    className: "st194",
    width: 0,
    height: 13.2
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.2236 121.7201)",
    className: "st193",
    width: 0,
    height: 13.2
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.2504 121.7101)",
    className: "st192",
    width: 0,
    height: 13.2
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.2696 121.6898)",
    className: "st191",
    width: 0,
    height: 13.2
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.2848 121.6777)",
    className: "st190",
    width: 0,
    height: 13.2
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.303 121.6681)",
    className: "st189",
    width: 0,
    height: 13.2
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.8,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.3288 121.6441)",
    className: "st188",
    width: 0,
    height: 13.2
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.344 121.632)",
    className: "st187",
    width: 0,
    height: 13.2
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.3659 121.629)",
    className: "st186",
    width: 0,
    height: 13.2
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.3937 121.6083)",
    className: "st185",
    width: 0,
    height: 13.2
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.407 121.5929)",
    className: "st184",
    width: 0,
    height: 13.2
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.4252 121.5833)",
    className: "st183",
    width: 0,
    height: 13.2
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.7,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.4404 121.5712)",
    className: "st182",
    width: 0,
    height: 13.2
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.6,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.4663 121.5472)",
    className: "st181",
    width: 0,
    height: 13.2
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.6,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.4863 121.5409)",
    className: "st180",
    width: 0,
    height: 13.2
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.6,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.4997 121.5255)",
    className: "st179",
    width: 0,
    height: 13.2
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: 34.6,
    transform: "matrix(0.1836 -0.983 0.983 0.1836 32.5171 121.5123)",
    className: "st179",
    width: 0,
    height: 13.2
  })), _polygon554 || (_polygon554 = /*#__PURE__*/React.createElement("polygon", {
    className: "st178",
    points: "82.9,40 82.9,40 83,40 95.9,42.4 95.9,42.4  "
  })), _polygon555 || (_polygon555 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "83,40 95.9,42.4 95.9,42.4 83,40  "
  })), _polygon556 || (_polygon556 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "83.1,40 95.9,42.4 95.9,42.4 83,40  "
  })), _polygon557 || (_polygon557 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "83.2,40 95.9,42.3 95.9,42.4 83.1,40  "
  })), _polygon558 || (_polygon558 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "83.2,40 95.9,42.3 95.9,42.3 83.2,40  "
  })), _polygon559 || (_polygon559 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "83.3,40 95.9,42.3 95.9,42.3 83.2,40  "
  })), _polygon560 || (_polygon560 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "83.3,40 95.9,42.3 95.9,42.3 83.3,40  "
  })), _polygon561 || (_polygon561 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "83.4,40 95.9,42.3 95.9,42.3 83.3,40  "
  })), _polygon562 || (_polygon562 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "83.4,40 95.9,42.3 95.9,42.3 83.4,40  "
  })), _polygon563 || (_polygon563 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "83.5,40 95.9,42.3 95.9,42.3 83.4,40  "
  })), _polygon564 || (_polygon564 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "83.5,40 95.9,42.3 95.9,42.3 83.5,40  "
  })), _polygon565 || (_polygon565 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "83.7,40 95.9,42.2 95.9,42.3 83.5,40  "
  })), _polygon566 || (_polygon566 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "83.9,40 95.9,42.2 95.9,42.2 83.7,40  "
  })), _polygon567 || (_polygon567 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "84,40 95.9,42.2 95.9,42.2 83.9,40  "
  })), _polygon568 || (_polygon568 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "84.2,40 95.9,42.1 95.9,42.2 84,40  "
  })), _polygon569 || (_polygon569 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "84.4,40 95.9,42.1 95.9,42.1 84.2,40  "
  })), _polygon570 || (_polygon570 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "84.5,40 95.9,42.1 95.9,42.1 84.4,40  "
  })), _polygon571 || (_polygon571 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "84.7,40 95.9,42.1 95.9,42.1 84.5,40  "
  })), _polygon572 || (_polygon572 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "84.9,40 95.9,42 95.9,42.1 84.7,40  "
  })), _polygon573 || (_polygon573 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "84.9,40 95.9,42 95.9,42 84.9,40  "
  })), _polygon574 || (_polygon574 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "85,40 95.9,42 95.9,42 84.9,40  "
  })), _polygon575 || (_polygon575 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "85.1,40 95.9,42 95.9,42 85,40  "
  })), _polygon576 || (_polygon576 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "85.1,40 95.9,42 95.9,42 85.1,40  "
  })), _polygon577 || (_polygon577 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "85.2,40 95.9,42 95.9,42 85.1,40  "
  })), _polygon578 || (_polygon578 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "85.3,40 95.9,41.9 95.9,42 85.2,40  "
  })), _polygon579 || (_polygon579 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "85.3,40 95.9,41.9 95.9,41.9 85.3,40  "
  })), _polygon580 || (_polygon580 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "85.4,40 95.9,41.9 95.9,41.9 85.3,40  "
  })), _polygon581 || (_polygon581 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "85.5,40 95.9,41.9 95.9,41.9 85.4,40  "
  })), _polygon582 || (_polygon582 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "85.5,40 95.9,41.9 95.9,41.9 85.5,40  "
  })), _polygon583 || (_polygon583 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "85.6,40 95.9,41.9 95.9,41.9 85.5,40  "
  })), _polygon584 || (_polygon584 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "85.7,40 95.9,41.9 95.9,41.9 85.6,40  "
  })), _polygon585 || (_polygon585 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "85.7,40 95.9,41.9 95.9,41.9 85.7,40  "
  })), _polygon586 || (_polygon586 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "85.8,40 95.9,41.8 95.9,41.9 85.7,40  "
  })), _polygon587 || (_polygon587 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "85.9,40 95.9,41.8 95.9,41.8 85.8,40  "
  })), _polygon588 || (_polygon588 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "85.9,40 95.9,41.8 95.9,41.8 85.9,40  "
  })), _polygon589 || (_polygon589 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "86,40 95.9,41.8 95.9,41.8 85.9,40  "
  })), _polygon590 || (_polygon590 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "86.1,40 95.9,41.8 95.9,41.8 86,40  "
  })), _polygon591 || (_polygon591 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "86.1,40 95.9,41.8 95.9,41.8 86.1,40  "
  })), _polygon592 || (_polygon592 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "86.2,40 95.9,41.8 95.9,41.8 86.1,40  "
  })), _polygon593 || (_polygon593 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "86.3,40 95.9,41.8 95.9,41.8 86.2,40  "
  })), _polygon594 || (_polygon594 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "86.3,40 95.9,41.7 95.9,41.8 86.3,40  "
  })), _polygon595 || (_polygon595 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "86.4,40 95.9,41.7 95.9,41.7 86.3,40  "
  })), _polygon596 || (_polygon596 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "86.5,40 95.9,41.7 95.9,41.7 86.4,40  "
  })), _polygon597 || (_polygon597 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "86.5,40 95.9,41.7 95.9,41.7 86.5,40  "
  })), _polygon598 || (_polygon598 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "86.6,40 95.9,41.7 95.9,41.7 86.5,40  "
  })), _polygon599 || (_polygon599 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "86.7,40 95.9,41.7 95.9,41.7 86.6,40  "
  })), _polygon600 || (_polygon600 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "86.7,40 95.9,41.7 95.9,41.7 86.7,40  "
  })), _polygon601 || (_polygon601 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "86.8,40 95.9,41.7 95.9,41.7 86.7,40  "
  })), _polygon602 || (_polygon602 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "86.8,40 95.9,41.7 95.9,41.7 86.8,40  "
  })), _polygon603 || (_polygon603 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "86.9,40 95.9,41.6 95.9,41.7 86.8,40  "
  })), _polygon604 || (_polygon604 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "87,40 95.9,41.6 95.9,41.6 86.9,40  "
  })), _polygon605 || (_polygon605 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "87,40 95.9,41.6 95.9,41.6 87,40  "
  })), _polygon606 || (_polygon606 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "87.1,40 95.9,41.6 95.9,41.6 87,40  "
  })), _polygon607 || (_polygon607 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "87.2,40 95.9,41.6 95.9,41.6 87.1,40  "
  })), _polygon608 || (_polygon608 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "87.2,40 95.9,41.6 95.9,41.6 87.2,40  "
  })), _polygon609 || (_polygon609 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "87.3,40 95.9,41.6 95.9,41.6 87.2,40  "
  })), _polygon610 || (_polygon610 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "87.3,40 95.9,41.6 95.9,41.6 87.3,40  "
  })), _polygon611 || (_polygon611 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "87.4,40 95.9,41.6 95.9,41.6 87.3,40  "
  })), _polygon612 || (_polygon612 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "87.5,40 95.9,41.5 95.9,41.6 87.4,40  "
  })), _polygon613 || (_polygon613 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "87.5,40 95.9,41.5 95.9,41.5 87.5,40  "
  })), _polygon614 || (_polygon614 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "87.6,40 95.9,41.5 95.9,41.5 87.5,40  "
  })), _polygon615 || (_polygon615 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "87.7,40 95.9,41.5 95.9,41.5 87.6,40  "
  })), _polygon616 || (_polygon616 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "87.7,40 95.9,41.5 95.9,41.5 87.7,40  "
  })), _polygon617 || (_polygon617 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "87.8,40 95.9,41.5 95.9,41.5 87.7,40  "
  })), _polygon618 || (_polygon618 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "87.8,40 95.9,41.5 95.9,41.5 87.8,40  "
  })), _polygon619 || (_polygon619 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "87.9,40 95.9,41.5 95.9,41.5 87.8,40  "
  })), _polygon620 || (_polygon620 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "88,40 95.9,41.4 95.9,41.5 87.9,40  "
  })), _polygon621 || (_polygon621 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "88,40 95.9,41.4 95.9,41.4 88,40  "
  })), _polygon622 || (_polygon622 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "88.1,40 95.9,41.4 95.9,41.4 88,40  "
  })), _polygon623 || (_polygon623 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "88.2,40 95.9,41.4 95.9,41.4 88.1,40  "
  })), _polygon624 || (_polygon624 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "88.2,40 95.9,41.4 95.9,41.4 88.2,40  "
  })), _polygon625 || (_polygon625 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "88.2,40 95.9,41.4 95.9,41.4 88.2,40  "
  })), _polygon626 || (_polygon626 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "88.3,40 95.9,41.4 95.9,41.4 88.2,40  "
  })), _polygon627 || (_polygon627 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "88.3,40 95.9,41.4 95.9,41.4 88.3,40  "
  })), _polygon628 || (_polygon628 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "88.3,40 95.9,41.4 95.9,41.4 88.3,40  "
  })), _polygon629 || (_polygon629 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "88.4,40 95.9,41.4 95.9,41.4 88.3,40  "
  })), _polygon630 || (_polygon630 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "88.4,40 95.9,41.4 95.9,41.4 88.4,40  "
  })), _polygon631 || (_polygon631 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "88.4,40 95.9,41.4 95.9,41.4 88.4,40  "
  })), _polygon632 || (_polygon632 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "88.4,40 95.9,41.4 95.9,41.4 88.4,40  "
  })), _polygon633 || (_polygon633 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "88.5,40 95.9,41.4 95.9,41.4 88.4,40  "
  })), _polygon634 || (_polygon634 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "88.5,40 95.9,41.3 95.9,41.4 88.5,40  "
  })), _polygon635 || (_polygon635 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "88.5,40 95.9,41.3 95.9,41.3 88.5,40  "
  })), _polygon636 || (_polygon636 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "88.5,40 95.9,41.3 95.9,41.3 88.5,40  "
  })), _polygon637 || (_polygon637 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "88.6,40 95.9,41.3 95.9,41.3 88.5,40  "
  })), _polygon638 || (_polygon638 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "88.6,40 95.9,41.3 95.9,41.3 88.6,40  "
  })), _polygon639 || (_polygon639 = /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "88.6,40 95.9,41.3 95.9,41.3 88.6,40  "
  })), _polygon640 || (_polygon640 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "88.6,40 95.9,41.3 95.9,41.3 88.6,40  "
  })), _polygon641 || (_polygon641 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "88.7,40 95.9,41.3 95.9,41.3 88.6,40  "
  })), _polygon642 || (_polygon642 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "88.7,40 95.9,41.3 95.9,41.3 88.7,40  "
  })), _polygon643 || (_polygon643 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "88.7,40 95.9,41.3 95.9,41.3 88.7,40  "
  })), _polygon644 || (_polygon644 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "88.8,40 95.9,41.3 95.9,41.3 88.7,40  "
  })), _polygon645 || (_polygon645 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "88.8,40 95.9,41.3 95.9,41.3 88.8,40  "
  })), _polygon646 || (_polygon646 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "88.8,40 95.9,41.3 95.9,41.3 88.8,40  "
  })), _polygon647 || (_polygon647 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "88.8,40 95.9,41.3 95.9,41.3 88.8,40  "
  })), _polygon648 || (_polygon648 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "88.9,40 95.9,41.3 95.9,41.3 88.8,40  "
  })), _polygon649 || (_polygon649 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "88.9,40 95.9,41.3 95.9,41.3 88.9,40  "
  })), _polygon650 || (_polygon650 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "89,40 95.9,41.3 95.9,41.3 88.9,40  "
  })), _polygon651 || (_polygon651 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "89,40 95.9,41.2 95.9,41.3 89,40  "
  })), _polygon652 || (_polygon652 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "89.1,40 95.9,41.2 95.9,41.2 89,40  "
  })), _polygon653 || (_polygon653 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "89.2,40 95.9,41.2 95.9,41.2 89.1,40  "
  })), _polygon654 || (_polygon654 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "89.3,40 95.9,41.2 95.9,41.2 89.2,40  "
  })), _polygon655 || (_polygon655 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "89.3,40 95.9,41.2 95.9,41.2 89.3,40  "
  })), _polygon656 || (_polygon656 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "89.4,40 95.9,41.2 95.9,41.2 89.3,40  "
  })), _polygon657 || (_polygon657 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "89.5,40 95.9,41.2 95.9,41.2 89.4,40  "
  })), _polygon658 || (_polygon658 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "89.5,40 95.9,41.2 95.9,41.2 89.5,40  "
  })), _polygon659 || (_polygon659 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "89.6,40 95.9,41.1 95.9,41.2 89.5,40  "
  })), _polygon660 || (_polygon660 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "89.7,40 95.9,41.1 95.9,41.1 89.6,40  "
  })), _polygon661 || (_polygon661 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "89.8,40 95.9,41.1 95.9,41.1 89.7,40  "
  })), _polygon662 || (_polygon662 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "89.8,40 95.9,41.1 95.9,41.1 89.8,40  "
  })), _polygon663 || (_polygon663 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "89.9,40 95.9,41.1 95.9,41.1 89.8,40  "
  })), _polygon664 || (_polygon664 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "90,40 95.9,41.1 95.9,41.1 89.9,40  "
  })), _polygon665 || (_polygon665 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "90.1,40 95.9,41 95.9,41.1 90,40  "
  })), _polygon666 || (_polygon666 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "90.1,40 95.9,41 95.9,41 90.1,40  "
  })), _polygon667 || (_polygon667 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "90.2,40 95.9,41 95.9,41 90.1,40  "
  })), _polygon668 || (_polygon668 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "90.2,40 95.9,41 95.9,41 90.2,40  "
  })), _polygon669 || (_polygon669 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "90.3,40 95.9,41 95.9,41 90.2,40  "
  })), _polygon670 || (_polygon670 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "90.3,40 95.9,41 95.9,41 90.3,40  "
  })), _polygon671 || (_polygon671 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "90.3,40 95.9,41 95.9,41 90.3,40  "
  })), _polygon672 || (_polygon672 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "90.4,40 95.9,41 95.9,41 90.3,40  "
  })), _polygon673 || (_polygon673 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "90.4,40 95.9,41 95.9,41 90.4,40  "
  })), _polygon674 || (_polygon674 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "90.4,40 95.9,41 95.9,41 90.4,40  "
  })), _polygon675 || (_polygon675 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "90.5,40 95.9,41 95.9,41 90.4,40  "
  })), _polygon676 || (_polygon676 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "90.5,40 95.9,41 95.9,41 90.5,40  "
  })), _polygon677 || (_polygon677 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "90.5,40 95.9,41 95.9,41 90.5,40  "
  })), _polygon678 || (_polygon678 = /*#__PURE__*/React.createElement("polygon", {
    className: "st686",
    points: "90.6,40 95.9,41 95.9,41 90.5,40  "
  })), _polygon679 || (_polygon679 = /*#__PURE__*/React.createElement("polygon", {
    className: "st687",
    points: "90.6,40 95.9,41 95.9,41 90.6,40  "
  })), _polygon680 || (_polygon680 = /*#__PURE__*/React.createElement("polygon", {
    className: "st688",
    points: "90.6,40 95.9,40.9 95.9,41 90.6,40  "
  })), _polygon681 || (_polygon681 = /*#__PURE__*/React.createElement("polygon", {
    className: "st689",
    points: "90.7,40 95.9,40.9 95.9,40.9 90.6,40  "
  })), _polygon682 || (_polygon682 = /*#__PURE__*/React.createElement("polygon", {
    className: "st690",
    points: "90.7,40 95.9,40.9 95.9,40.9 90.7,40  "
  })), _polygon683 || (_polygon683 = /*#__PURE__*/React.createElement("polygon", {
    className: "st691",
    points: "90.7,40 95.9,40.9 95.9,40.9 90.7,40  "
  })), _polygon684 || (_polygon684 = /*#__PURE__*/React.createElement("polygon", {
    className: "st692",
    points: "90.8,40 95.9,40.9 95.9,40.9 90.7,40  "
  })), _polygon685 || (_polygon685 = /*#__PURE__*/React.createElement("polygon", {
    className: "st693",
    points: "90.8,40 95.9,40.9 95.9,40.9 90.8,40  "
  })), _polygon686 || (_polygon686 = /*#__PURE__*/React.createElement("polygon", {
    className: "st694",
    points: "90.8,40 95.9,40.9 95.9,40.9 90.8,40  "
  })), _polygon687 || (_polygon687 = /*#__PURE__*/React.createElement("polygon", {
    className: "st695",
    points: "90.8,40 95.9,40.9 95.9,40.9 90.8,40  "
  })), _polygon688 || (_polygon688 = /*#__PURE__*/React.createElement("polygon", {
    className: "st696",
    points: "90.9,40 95.9,40.9 95.9,40.9 90.8,40  "
  })), _polygon689 || (_polygon689 = /*#__PURE__*/React.createElement("polygon", {
    className: "st696",
    points: "95.9,40.9 90.9,40 95.9,40  "
  })))), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 95.6,
    className: "st697",
    width: 14.3,
    height: 4.1
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 52.8,
    className: "st697",
    width: 61.7,
    height: 51.8
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: 52.8,
    className: "st697",
    width: 62.5,
    height: 51.8
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000068652100190176781500000005847190485482787762_",
    points: "18.6,93.8 21.4,93.4 44.8,102.4 43.9,104  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047748921215995438000000015277062307769405623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068652100190176781500000005847190485482787762_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047748921215995438000000015277062307769405623_)"
    }
  }, _polygon690 || (_polygon690 = /*#__PURE__*/React.createElement("polygon", {
    className: "st699",
    points: "19.4,93.4 18.6,95.5 18.6,93.4  "
  })), _polygon691 || (_polygon691 = /*#__PURE__*/React.createElement("polygon", {
    className: "st699",
    points: "20.4,93.4 19.3,96.3 18.6,96 18.6,95.5 19.4,93.4  "
  })), _polygon692 || (_polygon692 = /*#__PURE__*/React.createElement("polygon", {
    className: "st700",
    points: "21.4,93.4 20.3,96.6 19.3,96.3 20.4,93.4  "
  })), _polygon693 || (_polygon693 = /*#__PURE__*/React.createElement("polygon", {
    className: "st701",
    points: "22.5,93.4 21.2,96.9 20.3,96.6 21.4,93.4  "
  })), _polygon694 || (_polygon694 = /*#__PURE__*/React.createElement("polygon", {
    className: "st702",
    points: "23.5,93.4 22.1,97.3 21.2,96.9 22.5,93.4  "
  })), _polygon695 || (_polygon695 = /*#__PURE__*/React.createElement("polygon", {
    className: "st703",
    points: "24.5,93.4 23,97.6 22.1,97.3 23.5,93.4  "
  })), _polygon696 || (_polygon696 = /*#__PURE__*/React.createElement("polygon", {
    className: "st219",
    points: "24.9,93.4 25.5,93.6 23.9,97.9 23,97.6 24.5,93.4  "
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 95.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -73.5818 86.4964)",
    className: "st220",
    width: 4.6,
    height: 1
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 95.8,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -73.3072 87.5591)",
    className: "st704",
    width: 4.6,
    height: 1
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6,
    y: 96.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -73.0203 88.6323)",
    className: "st705",
    width: 4.6,
    height: 1
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 96.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -72.7318 89.6959)",
    className: "st706",
    width: 4.6,
    height: 1
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 96.8,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -72.4572 90.7586)",
    className: "st707",
    width: 4.6,
    height: 1
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 97.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -72.1704 91.8318)",
    className: "st708",
    width: 4.6,
    height: 1
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 97.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -71.8892 92.8928)",
    className: "st709",
    width: 4.6,
    height: 1
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1,
    y: 97.8,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -71.6063 93.9603)",
    className: "st710",
    width: 4.6,
    height: 1
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 98.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -71.3299 95.0296)",
    className: "st711",
    width: 4.6,
    height: 1
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 98.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -71.0448 96.0962)",
    className: "st712",
    width: 4.6,
    height: 1
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 98.8,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -70.7619 97.1637)",
    className: "st713",
    width: 4.6,
    height: 1
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 99.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -70.4817 98.2225)",
    className: "st714",
    width: 4.6,
    height: 1
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 99.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -70.1949 99.2957)",
    className: "st715",
    width: 4.6,
    height: 1
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6,
    y: 99.7,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -69.9137 100.3566)",
    className: "st716",
    width: 4.6,
    height: 1
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 100.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -69.6373 101.4259)",
    className: "st717",
    width: 4.6,
    height: 1
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 100.4,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -69.3505 102.4991)",
    className: "st718",
    width: 4.6,
    height: 1
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 100.7,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -69.0693 103.5601)",
    className: "st719",
    width: 4.6,
    height: 1
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 101.1,
    transform: "matrix(0.3442 -0.9389 0.9389 0.3442 -68.793 104.6294)",
    className: "st720",
    width: 4.6,
    height: 1
  })), _polygon697 || (_polygon697 = /*#__PURE__*/React.createElement("polygon", {
    className: "st721",
    points: "41.7,99.5 42.6,99.9 41.1,104 40.5,104 40.2,103.9  "
  })), _polygon698 || (_polygon698 = /*#__PURE__*/React.createElement("polygon", {
    className: "st722",
    points: "42.6,99.9 43.6,100.2 42.2,104 41.1,104  "
  })), _polygon699 || (_polygon699 = /*#__PURE__*/React.createElement("polygon", {
    className: "st723",
    points: "43.6,100.2 44.5,100.5 43.2,104 42.2,104  "
  })), _polygon700 || (_polygon700 = /*#__PURE__*/React.createElement("polygon", {
    className: "st724",
    points: "44.5,100.5 44.8,100.7 44.8,102.4 44.2,104 43.2,104  "
  })), _polygon701 || (_polygon701 = /*#__PURE__*/React.createElement("polygon", {
    className: "st724",
    points: "44.2,104 44.8,102.4 44.8,104  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090977025093234508170000017525494097155358634_",
    points: "50.8,114.2 51.3,112.4 44.8,102.4 43.9,104  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003807763569377095260000009874528872345080463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090977025093234508170000017525494097155358634_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003807763569377095260000009874528872345080463_)"
    }
  }, _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9,
    y: 102.4,
    className: "st726",
    width: 0.2,
    height: 11.9
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 102.4,
    className: "st727",
    width: 0.2,
    height: 11.9
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 102.4,
    className: "st728",
    width: 0.2,
    height: 11.9
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 102.4,
    className: "st729",
    width: 0.2,
    height: 11.9
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 102.4,
    className: "st730",
    width: 0.2,
    height: 11.9
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 102.4,
    className: "st82",
    width: 0.2,
    height: 11.9
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9,
    y: 102.4,
    className: "st81",
    width: 0.2,
    height: 11.9
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1,
    y: 102.4,
    className: "st80",
    width: 0.2,
    height: 11.9
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2,
    y: 102.4,
    className: "st79",
    width: 0.2,
    height: 11.9
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 102.4,
    className: "st78",
    width: 0.2,
    height: 11.9
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 102.4,
    className: "st77",
    width: 0.2,
    height: 11.9
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 102.4,
    className: "st76",
    width: 0.2,
    height: 11.9
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9,
    y: 102.4,
    className: "st75",
    width: 0.2,
    height: 11.9
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 102.4,
    className: "st74",
    width: 0.2,
    height: 11.9
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2,
    y: 102.4,
    className: "st73",
    width: 0.2,
    height: 11.9
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 102.4,
    className: "st72",
    width: 0.2,
    height: 11.9
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 102.4,
    className: "st731",
    width: 0.2,
    height: 11.9
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 102.4,
    className: "st732",
    width: 0.2,
    height: 11.9
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8,
    y: 102.4,
    className: "st733",
    width: 0.2,
    height: 11.9
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 102.4,
    className: "st734",
    width: 0.2,
    height: 11.9
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2,
    y: 102.4,
    className: "st735",
    width: 0.2,
    height: 11.9
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 102.4,
    className: "st736",
    width: 0.2,
    height: 11.9
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 102.4,
    className: "st737",
    width: 0.2,
    height: 11.9
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6,
    y: 102.4,
    className: "st738",
    width: 0.2,
    height: 11.9
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 102.4,
    className: "st739",
    width: 0.2,
    height: 11.9
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 102.4,
    className: "st740",
    width: 0.2,
    height: 11.9
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 102.4,
    className: "st741",
    width: 0.2,
    height: 11.9
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 102.4,
    className: "st742",
    width: 0.2,
    height: 11.9
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 102.4,
    className: "st743",
    width: 0.2,
    height: 11.9
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6,
    y: 102.4,
    className: "st744",
    width: 0.2,
    height: 11.9
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 102.4,
    className: "st745",
    width: 0.2,
    height: 11.9
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 102.4,
    className: "st746",
    width: 0.2,
    height: 11.9
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 102.4,
    className: "st747",
    width: 0.2,
    height: 11.9
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 102.4,
    className: "st748",
    width: 0.2,
    height: 11.9
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 102.4,
    className: "st749",
    width: 0.2,
    height: 11.9
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 49.6,
    y: 102.4,
    className: "st750",
    width: 0.2,
    height: 11.9
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 102.4,
    className: "st751",
    width: 0.2,
    height: 11.9
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9,
    y: 102.4,
    className: "st752",
    width: 0.2,
    height: 11.9
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 102.4,
    className: "st753",
    width: 0.2,
    height: 11.9
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2,
    y: 102.4,
    className: "st754",
    width: 0.2,
    height: 11.9
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 102.4,
    className: "st755",
    width: 0.2,
    height: 11.9
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 102.4,
    className: "st756",
    width: 0.2,
    height: 11.9
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7,
    y: 102.4,
    className: "st757",
    width: 0.2,
    height: 11.9
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8,
    y: 102.4,
    className: "st758",
    width: 0.2,
    height: 11.9
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 102.4,
    className: "st759",
    width: 0.2,
    height: 11.9
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2,
    y: 102.4,
    className: "st760",
    width: 0.2,
    height: 11.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003093366810426908370000017434181561593691304_",
    points: "18.6,93.8 18.7,95.2 42,104.6 43.9,104  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139274510832217175260000001115538251468862123_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003093366810426908370000017434181561593691304_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139274510832217175260000001115538251468862123_)"
    }
  }, _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 93.8,
    className: "st762",
    width: 0.9,
    height: 10.9
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 93.8,
    className: "st763",
    width: 0.9,
    height: 10.9
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 93.8,
    className: "st764",
    width: 0.9,
    height: 10.9
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 93.8,
    className: "st765",
    width: 0.9,
    height: 10.9
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 93.8,
    className: "st766",
    width: 0.9,
    height: 10.9
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 93.8,
    className: "st767",
    width: 0.9,
    height: 10.9
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2,
    y: 93.8,
    className: "st768",
    width: 0.9,
    height: 10.9
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 93.8,
    className: "st769",
    width: 0.9,
    height: 10.9
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 93.8,
    className: "st191",
    width: 0.9,
    height: 10.9
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 93.8,
    className: "st770",
    width: 0.9,
    height: 10.9
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 93.8,
    className: "st771",
    width: 0.9,
    height: 10.9
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 93.8,
    className: "st772",
    width: 0.9,
    height: 10.9
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 93.8,
    className: "st773",
    width: 0.9,
    height: 10.9
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 93.8,
    className: "st774",
    width: 0.9,
    height: 10.9
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7,
    y: 93.8,
    className: "st197",
    width: 0.9,
    height: 10.9
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: 93.8,
    className: "st775",
    width: 0.9,
    height: 10.9
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 93.8,
    className: "st776",
    width: 0.9,
    height: 10.9
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6,
    y: 93.8,
    className: "st777",
    width: 0.9,
    height: 10.9
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 93.8,
    className: "st778",
    width: 0.9,
    height: 10.9
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 93.8,
    className: "st779",
    width: 0.9,
    height: 10.9
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4,
    y: 93.8,
    className: "st780",
    width: 0.9,
    height: 10.9
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 93.8,
    className: "st781",
    width: 0.9,
    height: 10.9
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 93.8,
    className: "st782",
    width: 0.9,
    height: 10.9
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2,
    y: 93.8,
    className: "st783",
    width: 0.9,
    height: 10.9
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1,
    y: 93.8,
    className: "st784",
    width: 0.9,
    height: 10.9
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1,
    y: 93.8,
    className: "st785",
    width: 0.9,
    height: 10.9
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 93.8,
    className: "st786",
    width: 0.9,
    height: 10.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026843078109480002840000000780022280721002427_",
    points: "42,104.6 48.2,114 50.8,114.3 43.9,104  42,104.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134969140501616735370000002126035385125919383_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026843078109480002840000000780022280721002427_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134969140501616735370000002126035385125919383_)"
    }
  }, _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 104,
    className: "st288",
    width: 0.1,
    height: 10.2
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1,
    y: 104,
    className: "st289",
    width: 0.1,
    height: 10.2
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 104,
    className: "st290",
    width: 0.1,
    height: 10.2
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4,
    y: 104,
    className: "st291",
    width: 0.1,
    height: 10.2
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6,
    y: 104,
    className: "st292",
    width: 0.1,
    height: 10.2
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 42.7,
    y: 104,
    className: "st293",
    width: 0.1,
    height: 10.2
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8,
    y: 104,
    className: "st294",
    width: 0.1,
    height: 10.2
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 104,
    className: "st788",
    width: 0.1,
    height: 10.2
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 104,
    className: "st789",
    width: 0.1,
    height: 10.2
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 43.3,
    y: 104,
    className: "st790",
    width: 0.1,
    height: 10.2
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 104,
    className: "st791",
    width: 0.1,
    height: 10.2
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 104,
    className: "st792",
    width: 0.1,
    height: 10.2
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 104,
    className: "st793",
    width: 0.1,
    height: 10.2
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9,
    y: 104,
    className: "st794",
    width: 0.1,
    height: 10.2
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 104,
    className: "st795",
    width: 0.1,
    height: 10.2
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 104,
    className: "st795",
    width: 0.2,
    height: 10.2
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 104,
    className: "st796",
    width: 0.2,
    height: 10.2
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 104,
    className: "st797",
    width: 0.2,
    height: 10.2
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 104,
    className: "st798",
    width: 0.2,
    height: 10.2
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 104,
    className: "st799",
    width: 0.2,
    height: 10.2
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2,
    y: 104,
    className: "st800",
    width: 0.2,
    height: 10.2
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 104,
    className: "st801",
    width: 0.2,
    height: 10.2
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 104,
    className: "st802",
    width: 0.2,
    height: 10.2
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 104,
    className: "st803",
    width: 0.2,
    height: 10.2
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9,
    y: 104,
    className: "st804",
    width: 0.2,
    height: 10.2
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1,
    y: 104,
    className: "st435",
    width: 0.2,
    height: 10.2
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 104,
    className: "st434",
    width: 0.2,
    height: 10.2
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 104,
    className: "st433",
    width: 0.2,
    height: 10.2
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 104,
    className: "st432",
    width: 0.2,
    height: 10.2
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 104,
    className: "st431",
    width: 0.2,
    height: 10.2
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 104,
    className: "st430",
    width: 0.2,
    height: 10.2
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 104,
    className: "st429",
    width: 0.2,
    height: 10.2
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 104,
    className: "st428",
    width: 0.2,
    height: 10.2
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 104,
    className: "st805",
    width: 0.2,
    height: 10.2
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 104,
    className: "st427",
    width: 0.2,
    height: 10.2
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 104,
    className: "st427",
    width: 0.4,
    height: 10.2
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 104,
    className: "st426",
    width: 0.4,
    height: 10.2
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 104,
    className: "st425",
    width: 0.4,
    height: 10.2
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 104,
    className: "st424",
    width: 0.4,
    height: 10.2
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 49.6,
    y: 104,
    className: "st806",
    width: 0.4,
    height: 10.2
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 104,
    className: "st807",
    width: 0.4,
    height: 10.2
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 104,
    className: "st808",
    width: 0.4,
    height: 10.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083055542124977224200000000695920659996648338_",
    d: "M97.8,45.9c-0.2,1.5-1.3,2.5-2.5,2.3s-1.9-1.5-1.7-3 c0.2-1.5,1.3-2.5,2.5-2.3C97.2,43.1,98,44.4,97.8,45.9L97.8,45.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005959708636931029700000017720824342877478334_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083055542124977224200000000695920659996648338_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005959708636931029700000017720824342877478334_)"
    }
  }, _polygon702 || (_polygon702 = /*#__PURE__*/React.createElement("polygon", {
    className: "st810",
    points: "93.4,48.3 98,48.1 98,48.4 93.4,48.4  "
  })), _polygon703 || (_polygon703 = /*#__PURE__*/React.createElement("polygon", {
    className: "st810",
    points: "93.4,48.3 98,48.1 98,48.1 93.4,48.3  "
  })), _polygon704 || (_polygon704 = /*#__PURE__*/React.createElement("polygon", {
    className: "st811",
    points: "93.4,48.2 98,48 98,48.1 93.4,48.3  "
  })), _polygon705 || (_polygon705 = /*#__PURE__*/React.createElement("polygon", {
    className: "st812",
    points: "93.4,48.1 98,47.9 98,48 93.4,48.2  "
  })), _polygon706 || (_polygon706 = /*#__PURE__*/React.createElement("polygon", {
    className: "st813",
    points: "93.4,48 98,47.8 98,47.9 93.4,48.1  "
  })), _polygon707 || (_polygon707 = /*#__PURE__*/React.createElement("polygon", {
    className: "st814",
    points: "93.4,48 98,47.8 98,47.8 93.4,48  "
  })), _polygon708 || (_polygon708 = /*#__PURE__*/React.createElement("polygon", {
    className: "st815",
    points: "93.4,47.9 98,47.7 98,47.8 93.4,48  "
  })), _polygon709 || (_polygon709 = /*#__PURE__*/React.createElement("polygon", {
    className: "st816",
    points: "93.4,47.8 98,47.6 98,47.7 93.4,47.9  "
  })), _polygon710 || (_polygon710 = /*#__PURE__*/React.createElement("polygon", {
    className: "st817",
    points: "93.4,47.8 98,47.5 98,47.6 93.4,47.8  "
  })), _polygon711 || (_polygon711 = /*#__PURE__*/React.createElement("polygon", {
    className: "st818",
    points: "93.4,47.7 98,47.5 98,47.5 93.4,47.8  "
  })), _polygon712 || (_polygon712 = /*#__PURE__*/React.createElement("polygon", {
    className: "st819",
    points: "93.4,47.6 98,47.4 98,47.5 93.4,47.7  "
  })), _polygon713 || (_polygon713 = /*#__PURE__*/React.createElement("polygon", {
    className: "st820",
    points: "93.4,47.5 98,47.3 98,47.4 93.4,47.6  "
  })), _polygon714 || (_polygon714 = /*#__PURE__*/React.createElement("polygon", {
    className: "st821",
    points: "93.4,47.5 98,47.2 98,47.3 93.4,47.5  "
  })), _polygon715 || (_polygon715 = /*#__PURE__*/React.createElement("polygon", {
    className: "st822",
    points: "93.4,47.4 98,47.2 98,47.2 93.4,47.5  "
  })), _polygon716 || (_polygon716 = /*#__PURE__*/React.createElement("polygon", {
    className: "st823",
    points: "93.4,47.3 98,47.1 98,47.2 93.4,47.4  "
  })), _polygon717 || (_polygon717 = /*#__PURE__*/React.createElement("polygon", {
    className: "st824",
    points: "93.4,47.2 98,47 98,47.1 93.4,47.3  "
  })), _polygon718 || (_polygon718 = /*#__PURE__*/React.createElement("polygon", {
    className: "st825",
    points: "93.4,47.2 98,46.9 98,47 93.4,47.2  "
  })), _polygon719 || (_polygon719 = /*#__PURE__*/React.createElement("polygon", {
    className: "st826",
    points: "93.4,47.1 98,46.9 98,46.9 93.4,47.2  "
  })), _polygon720 || (_polygon720 = /*#__PURE__*/React.createElement("polygon", {
    className: "st827",
    points: "93.4,47 98,46.8 98,46.9 93.4,47.1  "
  })), _polygon721 || (_polygon721 = /*#__PURE__*/React.createElement("polygon", {
    className: "st828",
    points: "93.4,46.9 98,46.7 98,46.8 93.4,47  "
  })), _polygon722 || (_polygon722 = /*#__PURE__*/React.createElement("polygon", {
    className: "st829",
    points: "93.4,46.9 98,46.6 98,46.7 93.4,46.9  "
  })), _polygon723 || (_polygon723 = /*#__PURE__*/React.createElement("polygon", {
    className: "st830",
    points: "93.4,46.8 98,46.6 98,46.6 93.4,46.9  "
  })), _polygon724 || (_polygon724 = /*#__PURE__*/React.createElement("polygon", {
    className: "st831",
    points: "93.4,46.7 98,46.5 98,46.6 93.4,46.8  "
  })), _polygon725 || (_polygon725 = /*#__PURE__*/React.createElement("polygon", {
    className: "st832",
    points: "93.4,46.6 98,46.4 98,46.5 93.4,46.7  "
  })), _polygon726 || (_polygon726 = /*#__PURE__*/React.createElement("polygon", {
    className: "st833",
    points: "93.4,46.6 98,46.4 98,46.4 93.4,46.6  "
  })), _polygon727 || (_polygon727 = /*#__PURE__*/React.createElement("polygon", {
    className: "st834",
    points: "93.4,46.5 98,46.3 98,46.4 93.4,46.6  "
  })), _polygon728 || (_polygon728 = /*#__PURE__*/React.createElement("polygon", {
    className: "st835",
    points: "93.4,46.4 98,46.2 98,46.3 93.4,46.5  "
  })), _polygon729 || (_polygon729 = /*#__PURE__*/React.createElement("polygon", {
    className: "st835",
    points: "93.4,46.3 98,46.1 98,46.2 93.4,46.4  "
  })), _polygon730 || (_polygon730 = /*#__PURE__*/React.createElement("polygon", {
    className: "st836",
    points: "93.4,46.2 98,46 98,46.1 93.4,46.3  "
  })), _polygon731 || (_polygon731 = /*#__PURE__*/React.createElement("polygon", {
    className: "st837",
    points: "93.4,46.1 98,45.9 98,46 93.4,46.2  "
  })), _polygon732 || (_polygon732 = /*#__PURE__*/React.createElement("polygon", {
    className: "st838",
    points: "93.4,46 98,45.8 98,45.9 93.4,46.1  "
  })), _polygon733 || (_polygon733 = /*#__PURE__*/React.createElement("polygon", {
    className: "st839",
    points: "93.4,45.9 98,45.7 98,45.8 93.4,46  "
  })), _polygon734 || (_polygon734 = /*#__PURE__*/React.createElement("polygon", {
    className: "st840",
    points: "93.4,45.8 98,45.6 98,45.7 93.4,45.9  "
  })), _polygon735 || (_polygon735 = /*#__PURE__*/React.createElement("polygon", {
    className: "st841",
    points: "93.4,45.7 98,45.5 98,45.6 93.4,45.8  "
  })), _polygon736 || (_polygon736 = /*#__PURE__*/React.createElement("polygon", {
    className: "st842",
    points: "93.4,45.6 98,45.3 98,45.5 93.4,45.7  "
  })), _polygon737 || (_polygon737 = /*#__PURE__*/React.createElement("polygon", {
    className: "st843",
    points: "93.4,45.5 98,45.2 98,45.3 93.4,45.6  "
  })), _polygon738 || (_polygon738 = /*#__PURE__*/React.createElement("polygon", {
    className: "st844",
    points: "93.4,45.4 98,45.1 98,45.2 93.4,45.5  "
  })), _polygon739 || (_polygon739 = /*#__PURE__*/React.createElement("polygon", {
    className: "st845",
    points: "93.4,45.2 98,45 98,45.1 93.4,45.4  "
  })), _polygon740 || (_polygon740 = /*#__PURE__*/React.createElement("polygon", {
    className: "st846",
    points: "93.4,45.1 98,44.9 98,45 93.4,45.2  "
  })), _polygon741 || (_polygon741 = /*#__PURE__*/React.createElement("polygon", {
    className: "st847",
    points: "93.4,45 98,44.8 98,44.9 93.4,45.1  "
  })), _polygon742 || (_polygon742 = /*#__PURE__*/React.createElement("polygon", {
    className: "st848",
    points: "93.4,44.9 98,44.7 98,44.8 93.4,45  "
  })), _polygon743 || (_polygon743 = /*#__PURE__*/React.createElement("polygon", {
    className: "st849",
    points: "93.4,44.8 98,44.6 98,44.7 93.4,44.9  "
  })), _polygon744 || (_polygon744 = /*#__PURE__*/React.createElement("polygon", {
    className: "st850",
    points: "93.4,44.7 98,44.5 98,44.6 93.4,44.8  "
  })), _polygon745 || (_polygon745 = /*#__PURE__*/React.createElement("polygon", {
    className: "st851",
    points: "93.4,44.6 98,44.4 98,44.5 93.4,44.7  "
  })), _polygon746 || (_polygon746 = /*#__PURE__*/React.createElement("polygon", {
    className: "st852",
    points: "93.4,44.5 98,44.3 98,44.4 93.4,44.6  "
  })), _polygon747 || (_polygon747 = /*#__PURE__*/React.createElement("polygon", {
    className: "st853",
    points: "93.4,44.4 98,44.2 98,44.3 93.4,44.5  "
  })), _polygon748 || (_polygon748 = /*#__PURE__*/React.createElement("polygon", {
    className: "st853",
    points: "93.4,44.2 98,44 98,44.2 93.4,44.4  "
  })), _polygon749 || (_polygon749 = /*#__PURE__*/React.createElement("polygon", {
    className: "st854",
    points: "93.4,44 98,43.8 98,44 93.4,44.2  "
  })), _polygon750 || (_polygon750 = /*#__PURE__*/React.createElement("polygon", {
    className: "st855",
    points: "93.4,43.8 98,43.6 98,43.8 93.4,44  "
  })), _polygon751 || (_polygon751 = /*#__PURE__*/React.createElement("polygon", {
    className: "st856",
    points: "93.4,43.6 98,43.4 98,43.6 93.4,43.8  "
  })), _polygon752 || (_polygon752 = /*#__PURE__*/React.createElement("polygon", {
    className: "st857",
    points: "93.4,43.4 98,43.2 98,43.4 93.4,43.6  "
  })), _polygon753 || (_polygon753 = /*#__PURE__*/React.createElement("polygon", {
    className: "st858",
    points: "93.4,43.2 98,43 98,43.2 93.4,43.4  "
  })), _polygon754 || (_polygon754 = /*#__PURE__*/React.createElement("polygon", {
    className: "st546",
    points: "93.4,43 98,42.8 98,43 93.4,43.2  "
  })), _polygon755 || (_polygon755 = /*#__PURE__*/React.createElement("polygon", {
    className: "st546",
    points: "98,42.8 93.4,43 93.4,42.7 98,42.7  "
  })))), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 42.9,
    className: "st697",
    width: 3.8,
    height: 5.4
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 42.9,
    className: "st697",
    width: 3.8,
    height: 5.4
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 93.6,
    className: "st697",
    width: 32.2,
    height: 20.7
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 93.7,
    className: "st697",
    width: 32.2,
    height: 20.6
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 95.1,
    className: "st697",
    width: 29.5,
    height: 18.9
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 99.3,
    className: "st697",
    width: 18.4,
    height: 10.2
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 102.4,
    className: "st697",
    width: 3,
    height: 2.7
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 40.7,
    className: "st697",
    width: 9.6,
    height: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005959816745468632470000005997099793589153169_",
    points: "61.8,66.9 73.4,70.6 68.8,75 57.2,71.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116950786160660420060000007261384666510966966_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005959816745468632470000005997099793589153169_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000116950786160660420060000007261384666510966966_)"
    }
  }, _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 74.7,
    className: "st546",
    width: 16.2,
    height: 0.3
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 74.5,
    className: "st858",
    width: 16.2,
    height: 0.3
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 74.1,
    className: "st857",
    width: 16.2,
    height: 0.3
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 73.8,
    className: "st856",
    width: 16.2,
    height: 0.3
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 73.5,
    className: "st855",
    width: 16.2,
    height: 0.3
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 73.2,
    className: "st854",
    width: 16.2,
    height: 0.3
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.9,
    className: "st853",
    width: 16.2,
    height: 0.3
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.8,
    className: "st853",
    width: 16.2,
    height: 0.2
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.6,
    className: "st852",
    width: 16.2,
    height: 0.2
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.5,
    className: "st851",
    width: 16.2,
    height: 0.2
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.3,
    className: "st850",
    width: 16.2,
    height: 0.2
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72.1,
    className: "st849",
    width: 16.2,
    height: 0.2
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 72,
    className: "st848",
    width: 16.2,
    height: 0.2
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71.8,
    className: "st847",
    width: 16.2,
    height: 0.2
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71.6,
    className: "st846",
    width: 16.2,
    height: 0.2
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71.5,
    className: "st845",
    width: 16.2,
    height: 0.2
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71.3,
    className: "st844",
    width: 16.2,
    height: 0.2
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71.2,
    className: "st843",
    width: 16.2,
    height: 0.2
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 71,
    className: "st842",
    width: 16.2,
    height: 0.2
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70.8,
    className: "st841",
    width: 16.2,
    height: 0.2
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70.7,
    className: "st840",
    width: 16.2,
    height: 0.2
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70.5,
    className: "st839",
    width: 16.2,
    height: 0.2
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70.3,
    className: "st838",
    width: 16.2,
    height: 0.2
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70.2,
    className: "st837",
    width: 16.2,
    height: 0.2
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 70,
    className: "st836",
    width: 16.2,
    height: 0.2
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.9,
    className: "st835",
    width: 16.2,
    height: 0.2
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.8,
    className: "st835",
    width: 16.2,
    height: 0.1
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.6,
    className: "st834",
    width: 16.2,
    height: 0.1
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.5,
    className: "st833",
    width: 16.2,
    height: 0.1
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.4,
    className: "st832",
    width: 16.2,
    height: 0.1
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.3,
    className: "st831",
    width: 16.2,
    height: 0.1
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.2,
    className: "st830",
    width: 16.2,
    height: 0.1
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69.1,
    className: "st829",
    width: 16.2,
    height: 0.1
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 69,
    className: "st828",
    width: 16.2,
    height: 0.1
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.9,
    className: "st827",
    width: 16.2,
    height: 0.1
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.7,
    className: "st826",
    width: 16.2,
    height: 0.1
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.6,
    className: "st825",
    width: 16.2,
    height: 0.1
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.5,
    className: "st824",
    width: 16.2,
    height: 0.1
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.4,
    className: "st823",
    width: 16.2,
    height: 0.1
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.3,
    className: "st822",
    width: 16.2,
    height: 0.1
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.2,
    className: "st821",
    width: 16.2,
    height: 0.1
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68.1,
    className: "st820",
    width: 16.2,
    height: 0.1
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 68,
    className: "st819",
    width: 16.2,
    height: 0.1
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.8,
    className: "st818",
    width: 16.2,
    height: 0.1
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.7,
    className: "st817",
    width: 16.2,
    height: 0.1
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.6,
    className: "st816",
    width: 16.2,
    height: 0.1
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.5,
    className: "st815",
    width: 16.2,
    height: 0.1
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.4,
    className: "st814",
    width: 16.2,
    height: 0.1
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.3,
    className: "st813",
    width: 16.2,
    height: 0.1
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.2,
    className: "st812",
    width: 16.2,
    height: 0.1
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 67.1,
    className: "st811",
    width: 16.2,
    height: 0.1
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 66.9,
    className: "st810",
    width: 16.2,
    height: 0.1
  })))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000136380691108115777750000007449084803905371809_",
    points: "61.8,59.8 61.8,67 73.4,70.6 79.2,65  61.8,59.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011731667566320284930000005437416580923764626_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136380691108115777750000007449084803905371809_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011731667566320284930000005437416580923764626_)"
    }
  }, _polygon756 || (_polygon756 = /*#__PURE__*/React.createElement("polygon", {
    className: "st861",
    points: "79.2,65 62.3,59.8 79.2,59.8  "
  })), _polygon757 || (_polygon757 = /*#__PURE__*/React.createElement("polygon", {
    className: "st861",
    points: "79.2,65 62.2,59.8 62.3,59.8 79.2,65  "
  })), _polygon758 || (_polygon758 = /*#__PURE__*/React.createElement("polygon", {
    className: "st862",
    points: "79.2,65 62.2,59.8 62.2,59.8 79.2,65  "
  })), _polygon759 || (_polygon759 = /*#__PURE__*/React.createElement("polygon", {
    className: "st863",
    points: "79.2,65 62.2,59.8 62.2,59.8 79.2,65  "
  })), _polygon760 || (_polygon760 = /*#__PURE__*/React.createElement("polygon", {
    className: "st864",
    points: "79.2,65 62.1,59.8 62.2,59.8 79.2,65  "
  })), _polygon761 || (_polygon761 = /*#__PURE__*/React.createElement("polygon", {
    className: "st865",
    points: "79.2,65 62.1,59.8 62.1,59.8 79.2,65  "
  })), _polygon762 || (_polygon762 = /*#__PURE__*/React.createElement("polygon", {
    className: "st866",
    points: "79.2,65 62.1,59.8 62.1,59.8 79.2,65  "
  })), _polygon763 || (_polygon763 = /*#__PURE__*/React.createElement("polygon", {
    className: "st867",
    points: "79.2,65.1 62,59.8 62.1,59.8 79.2,65  "
  })), _polygon764 || (_polygon764 = /*#__PURE__*/React.createElement("polygon", {
    className: "st712",
    points: "79.2,65.1 62,59.8 62,59.8 79.2,65.1  "
  })), _polygon765 || (_polygon765 = /*#__PURE__*/React.createElement("polygon", {
    className: "st868",
    points: "79.2,65.1 62,59.8 62,59.8 79.2,65.1  "
  })), _polygon766 || (_polygon766 = /*#__PURE__*/React.createElement("polygon", {
    className: "st869",
    points: "79.2,65.1 61.9,59.8 62,59.8 79.2,65.1  "
  })), _polygon767 || (_polygon767 = /*#__PURE__*/React.createElement("polygon", {
    className: "st870",
    points: "79.2,65.1 61.9,59.8 61.9,59.8 79.2,65.1  "
  })), _polygon768 || (_polygon768 = /*#__PURE__*/React.createElement("polygon", {
    className: "st871",
    points: "79.2,65.1 61.9,59.8 61.9,59.8 79.2,65.1  "
  })), _polygon769 || (_polygon769 = /*#__PURE__*/React.createElement("polygon", {
    className: "st872",
    points: "79.2,65.1 61.8,59.8 61.9,59.8 79.2,65.1  "
  })), _polygon770 || (_polygon770 = /*#__PURE__*/React.createElement("polygon", {
    className: "st873",
    points: "79.2,65.1 61.8,59.8 61.8,59.8 79.2,65.1  "
  })), _polygon771 || (_polygon771 = /*#__PURE__*/React.createElement("polygon", {
    className: "st874",
    points: "79.2,65.1 61.8,59.8 61.8,59.8 61.8,59.8 79.2,65.1  "
  })), _polygon772 || (_polygon772 = /*#__PURE__*/React.createElement("polygon", {
    className: "st874",
    points: "79.2,65.2 61.8,59.8 61.8,59.8 79.2,65.1  "
  })), _polygon773 || (_polygon773 = /*#__PURE__*/React.createElement("polygon", {
    className: "st875",
    points: "79.2,65.2 61.8,59.9 61.8,59.8 79.2,65.2  "
  })), _polygon774 || (_polygon774 = /*#__PURE__*/React.createElement("polygon", {
    className: "st876",
    points: "79.2,65.2 61.8,59.9 61.8,59.9 79.2,65.2  "
  })), _polygon775 || (_polygon775 = /*#__PURE__*/React.createElement("polygon", {
    className: "st877",
    points: "79.2,65.2 61.8,59.9 61.8,59.9 79.2,65.2  "
  })), _polygon776 || (_polygon776 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "79.2,65.3 61.8,59.9 61.8,59.9 79.2,65.2  "
  })), _polygon777 || (_polygon777 = /*#__PURE__*/React.createElement("polygon", {
    className: "st229",
    points: "79.2,65.3 61.8,59.9 61.8,59.9 79.2,65.3  "
  })), _polygon778 || (_polygon778 = /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "79.2,65.3 61.8,60 61.8,59.9 79.2,65.3  "
  })), _polygon779 || (_polygon779 = /*#__PURE__*/React.createElement("polygon", {
    className: "st230",
    points: "79.2,65.3 61.8,60 61.8,60 79.2,65.3  "
  })), _polygon780 || (_polygon780 = /*#__PURE__*/React.createElement("polygon", {
    className: "st229",
    points: "79.2,65.3 61.8,60 61.8,60 79.2,65.3  "
  })), _polygon781 || (_polygon781 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "79.2,65.3 61.8,60 61.8,60 79.2,65.3  "
  })), _polygon782 || (_polygon782 = /*#__PURE__*/React.createElement("polygon", {
    className: "st878",
    points: "79.2,65.3 61.8,60 61.8,60 79.2,65.3  "
  })), _polygon783 || (_polygon783 = /*#__PURE__*/React.createElement("polygon", {
    className: "st879",
    points: "79.2,65.4 61.8,60 61.8,60 79.2,65.3  "
  })), _polygon784 || (_polygon784 = /*#__PURE__*/React.createElement("polygon", {
    className: "st880",
    points: "79.2,65.4 61.8,60 61.8,60 79.2,65.4  "
  })), _polygon785 || (_polygon785 = /*#__PURE__*/React.createElement("polygon", {
    className: "st880",
    points: "79.2,65.4 61.8,60.1 61.8,60 79.2,65.4  "
  })), _polygon786 || (_polygon786 = /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "79.2,65.4 61.8,60.1 61.8,60.1 79.2,65.4  "
  })), _polygon787 || (_polygon787 = /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "79.2,65.4 61.8,60.1 61.8,60.1 79.2,65.4  "
  })), _polygon788 || (_polygon788 = /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "79.2,65.4 61.8,60.1 61.8,60.1 79.2,65.4  "
  })), _polygon789 || (_polygon789 = /*#__PURE__*/React.createElement("polygon", {
    className: "st881",
    points: "79.2,65.4 61.8,60.1 61.8,60.1 79.2,65.4  "
  })), _polygon790 || (_polygon790 = /*#__PURE__*/React.createElement("polygon", {
    className: "st882",
    points: "79.2,65.5 61.8,60.1 61.8,60.1 79.2,65.4  "
  })), _polygon791 || (_polygon791 = /*#__PURE__*/React.createElement("polygon", {
    className: "st883",
    points: "79.2,65.5 61.8,60.2 61.8,60.1 79.2,65.5  "
  })), _polygon792 || (_polygon792 = /*#__PURE__*/React.createElement("polygon", {
    className: "st711",
    points: "79.2,65.5 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon793 || (_polygon793 = /*#__PURE__*/React.createElement("polygon", {
    className: "st712",
    points: "79.2,65.5 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon794 || (_polygon794 = /*#__PURE__*/React.createElement("polygon", {
    className: "st713",
    points: "79.2,65.5 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon795 || (_polygon795 = /*#__PURE__*/React.createElement("polygon", {
    className: "st714",
    points: "79.2,65.5 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon796 || (_polygon796 = /*#__PURE__*/React.createElement("polygon", {
    className: "st715",
    points: "79.2,65.5 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon797 || (_polygon797 = /*#__PURE__*/React.createElement("polygon", {
    className: "st716",
    points: "79.2,65.6 61.8,60.2 61.8,60.2 79.2,65.5  "
  })), _polygon798 || (_polygon798 = /*#__PURE__*/React.createElement("polygon", {
    className: "st717",
    points: "79.2,65.6 61.8,60.3 61.8,60.2 79.2,65.6  "
  })), _polygon799 || (_polygon799 = /*#__PURE__*/React.createElement("polygon", {
    className: "st718",
    points: "79.2,65.6 61.8,60.3 61.8,60.3 79.2,65.6  "
  })), _polygon800 || (_polygon800 = /*#__PURE__*/React.createElement("polygon", {
    className: "st718",
    points: "79.2,65.6 61.8,60.3 61.8,60.3 79.2,65.6  "
  })), _polygon801 || (_polygon801 = /*#__PURE__*/React.createElement("polygon", {
    className: "st719",
    points: "79.2,65.6 61.8,60.3 61.8,60.3 79.2,65.6  "
  })), _polygon802 || (_polygon802 = /*#__PURE__*/React.createElement("polygon", {
    className: "st884",
    points: "79.2,65.7 61.8,60.4 61.8,60.3 79.2,65.6  "
  })), _polygon803 || (_polygon803 = /*#__PURE__*/React.createElement("polygon", {
    className: "st722",
    points: "79.2,65.7 61.8,60.4 61.8,60.4 79.2,65.7  "
  })), _polygon804 || (_polygon804 = /*#__PURE__*/React.createElement("polygon", {
    className: "st723",
    points: "79.2,65.7 61.8,60.4 61.8,60.4 79.2,65.7  "
  })), _polygon805 || (_polygon805 = /*#__PURE__*/React.createElement("polygon", {
    className: "st724",
    points: "79.2,65.7 61.8,60.4 61.8,60.4 79.2,65.7  "
  })), _polygon806 || (_polygon806 = /*#__PURE__*/React.createElement("polygon", {
    className: "st724",
    points: "79.2,65.9 61.8,60.5 61.8,60.4 79.2,65.7  "
  })), _polygon807 || (_polygon807 = /*#__PURE__*/React.createElement("polygon", {
    className: "st723",
    points: "79.2,66 61.8,60.6 61.8,60.5 79.2,65.9  "
  })), _polygon808 || (_polygon808 = /*#__PURE__*/React.createElement("polygon", {
    className: "st722",
    points: "79.2,66.1 61.8,60.7 61.8,60.6 79.2,66  "
  })), _polygon809 || (_polygon809 = /*#__PURE__*/React.createElement("polygon", {
    className: "st721",
    points: "79.2,66.2 61.8,60.8 61.8,60.7 79.2,66.1  "
  })), _polygon810 || (_polygon810 = /*#__PURE__*/React.createElement("polygon", {
    className: "st884",
    points: "79.2,66.3 61.8,60.9 61.8,60.8 79.2,66.2  "
  })), _polygon811 || (_polygon811 = /*#__PURE__*/React.createElement("polygon", {
    className: "st719",
    points: "79.2,66.4 61.8,61 61.8,60.9 79.2,66.3  "
  })), _polygon812 || (_polygon812 = /*#__PURE__*/React.createElement("polygon", {
    className: "st718",
    points: "79.2,66.5 61.8,61.1 61.8,61 79.2,66.4  "
  })), _polygon813 || (_polygon813 = /*#__PURE__*/React.createElement("polygon", {
    className: "st717",
    points: "79.2,66.6 61.8,61.2 61.8,61.1 79.2,66.5  "
  })), _polygon814 || (_polygon814 = /*#__PURE__*/React.createElement("polygon", {
    className: "st716",
    points: "79.2,66.7 61.8,61.3 61.8,61.2 79.2,66.6  "
  })), _polygon815 || (_polygon815 = /*#__PURE__*/React.createElement("polygon", {
    className: "st715",
    points: "79.2,66.8 61.8,61.4 61.8,61.3 79.2,66.7  "
  })), _polygon816 || (_polygon816 = /*#__PURE__*/React.createElement("polygon", {
    className: "st885",
    points: "79.2,66.9 61.8,61.5 61.8,61.4 79.2,66.8  "
  })), _polygon817 || (_polygon817 = /*#__PURE__*/React.createElement("polygon", {
    className: "st886",
    points: "79.2,67 61.8,61.6 61.8,61.5 79.2,66.9  "
  })), _polygon818 || (_polygon818 = /*#__PURE__*/React.createElement("polygon", {
    className: "st887",
    points: "79.2,67.1 61.8,61.8 61.8,61.6 79.2,67  "
  })), _polygon819 || (_polygon819 = /*#__PURE__*/React.createElement("polygon", {
    className: "st888",
    points: "79.2,67.2 61.8,61.9 61.8,61.8 79.2,67.1  "
  })), _polygon820 || (_polygon820 = /*#__PURE__*/React.createElement("polygon", {
    className: "st889",
    points: "79.2,67.3 61.8,62 61.8,61.9 79.2,67.2  "
  })), _polygon821 || (_polygon821 = /*#__PURE__*/React.createElement("polygon", {
    className: "st883",
    points: "79.2,67.4 61.8,62.1 61.8,62 79.2,67.3  "
  })), _polygon822 || (_polygon822 = /*#__PURE__*/React.createElement("polygon", {
    className: "st882",
    points: "79.2,67.5 61.8,62.2 61.8,62.1 79.2,67.4  "
  })), _polygon823 || (_polygon823 = /*#__PURE__*/React.createElement("polygon", {
    className: "st881",
    points: "79.2,67.6 61.8,62.3 61.8,62.2 79.2,67.5  "
  })), _polygon824 || (_polygon824 = /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "79.2,67.7 61.8,62.4 61.8,62.3 79.2,67.6  "
  })), _polygon825 || (_polygon825 = /*#__PURE__*/React.createElement("polygon", {
    className: "st890",
    points: "79.2,67.8 61.8,62.5 61.8,62.4 79.2,67.7  "
  })), _polygon826 || (_polygon826 = /*#__PURE__*/React.createElement("polygon", {
    className: "st891",
    points: "79.2,67.9 61.8,62.6 61.8,62.5 79.2,67.8  "
  })), _polygon827 || (_polygon827 = /*#__PURE__*/React.createElement("polygon", {
    className: "st224",
    points: "79.2,68 61.8,62.7 61.8,62.6 79.2,67.9  "
  })), _polygon828 || (_polygon828 = /*#__PURE__*/React.createElement("polygon", {
    className: "st225",
    points: "79.2,68.1 61.8,62.8 61.8,62.7 79.2,68  "
  })), _polygon829 || (_polygon829 = /*#__PURE__*/React.createElement("polygon", {
    className: "st226",
    points: "79.2,68.2 61.8,62.9 61.8,62.8 79.2,68.1  "
  })), _polygon830 || (_polygon830 = /*#__PURE__*/React.createElement("polygon", {
    className: "st227",
    points: "79.2,68.3 61.8,63 61.8,62.9 79.2,68.2  "
  })), _polygon831 || (_polygon831 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "79.2,68.4 61.8,63.1 61.8,63 79.2,68.3  "
  })), _polygon832 || (_polygon832 = /*#__PURE__*/React.createElement("polygon", {
    className: "st892",
    points: "79.2,68.5 61.8,63.2 61.8,63.1 79.2,68.4  "
  })), _polygon833 || (_polygon833 = /*#__PURE__*/React.createElement("polygon", {
    className: "st893",
    points: "79.2,68.6 61.8,63.3 61.8,63.2 79.2,68.5  "
  })), _polygon834 || (_polygon834 = /*#__PURE__*/React.createElement("polygon", {
    className: "st894",
    points: "79.2,68.7 61.8,63.4 61.8,63.3 79.2,68.6  "
  })), _polygon835 || (_polygon835 = /*#__PURE__*/React.createElement("polygon", {
    className: "st895",
    points: "79.2,68.8 61.8,63.5 61.8,63.4 79.2,68.7  "
  })), _polygon836 || (_polygon836 = /*#__PURE__*/React.createElement("polygon", {
    className: "st896",
    points: "79.2,68.9 61.8,63.6 61.8,63.5 79.2,68.8  "
  })), _polygon837 || (_polygon837 = /*#__PURE__*/React.createElement("polygon", {
    className: "st897",
    points: "79.2,69 61.8,63.7 61.8,63.6 79.2,68.9  "
  })), _polygon838 || (_polygon838 = /*#__PURE__*/React.createElement("polygon", {
    className: "st898",
    points: "79.2,69.1 79.2,69.1 61.8,63.8 61.8,63.7 79.2,69  "
  })), _polygon839 || (_polygon839 = /*#__PURE__*/React.createElement("polygon", {
    className: "st899",
    points: "79.2,69.1 79.2,69.2 61.8,63.9 61.8,63.8  "
  })), _polygon840 || (_polygon840 = /*#__PURE__*/React.createElement("polygon", {
    className: "st900",
    points: "79.2,69.2 79.1,69.3 61.8,64 61.8,63.9  "
  })), _polygon841 || (_polygon841 = /*#__PURE__*/React.createElement("polygon", {
    className: "st901",
    points: "79.1,69.3 79.1,69.4 61.8,64.1 61.8,64  "
  })), _polygon842 || (_polygon842 = /*#__PURE__*/React.createElement("polygon", {
    className: "st902",
    points: "79.1,69.4 79.1,69.5 61.8,64.2 61.8,64.1  "
  })), _polygon843 || (_polygon843 = /*#__PURE__*/React.createElement("polygon", {
    className: "st903",
    points: "79.1,69.5 79,69.6 61.8,64.3 61.8,64.2  "
  })), _polygon844 || (_polygon844 = /*#__PURE__*/React.createElement("polygon", {
    className: "st904",
    points: "79,69.6 79,69.7 61.8,64.4 61.8,64.3  "
  })), _polygon845 || (_polygon845 = /*#__PURE__*/React.createElement("polygon", {
    className: "st905",
    points: "79,69.7 79,69.8 61.8,64.5 61.8,64.4  "
  })), _polygon846 || (_polygon846 = /*#__PURE__*/React.createElement("polygon", {
    className: "st906",
    points: "79,69.8 78.9,69.9 61.8,64.6 61.8,64.5  "
  })), _polygon847 || (_polygon847 = /*#__PURE__*/React.createElement("polygon", {
    className: "st907",
    points: "78.9,69.9 78.9,69.9 61.8,64.7 61.8,64.6  "
  })), _polygon848 || (_polygon848 = /*#__PURE__*/React.createElement("polygon", {
    className: "st908",
    points: "78.9,69.9 78.9,70 61.8,64.8 61.8,64.7  "
  })), _polygon849 || (_polygon849 = /*#__PURE__*/React.createElement("polygon", {
    className: "st909",
    points: "78.9,70 78.9,70.1 61.8,64.9 61.8,64.8  "
  })), _polygon850 || (_polygon850 = /*#__PURE__*/React.createElement("polygon", {
    className: "st910",
    points: "78.9,70.1 78.8,70.2 61.8,65 61.8,64.9  "
  })), _polygon851 || (_polygon851 = /*#__PURE__*/React.createElement("polygon", {
    className: "st911",
    points: "78.8,70.2 78.8,70.3 61.8,65.1 61.8,65  "
  })), _polygon852 || (_polygon852 = /*#__PURE__*/React.createElement("polygon", {
    className: "st912",
    points: "78.8,70.3 78.8,70.4 61.8,65.2 61.8,65.1  "
  })), _polygon853 || (_polygon853 = /*#__PURE__*/React.createElement("polygon", {
    className: "st913",
    points: "78.8,70.4 78.8,70.5 61.8,65.3 61.8,65.2  "
  })), _polygon854 || (_polygon854 = /*#__PURE__*/React.createElement("polygon", {
    className: "st914",
    points: "78.8,70.5 78.7,70.6 61.8,65.4 61.8,65.3  "
  })), _polygon855 || (_polygon855 = /*#__PURE__*/React.createElement("polygon", {
    className: "st915",
    points: "78.7,70.6 78.7,70.6 78.4,70.6 61.8,65.5 61.8,65.4  "
  })), _polygon856 || (_polygon856 = /*#__PURE__*/React.createElement("polygon", {
    className: "st916",
    points: "78.1,70.6 61.8,65.6 61.8,65.5 78.4,70.6  "
  })), _polygon857 || (_polygon857 = /*#__PURE__*/React.createElement("polygon", {
    className: "st917",
    points: "77.7,70.6 61.8,65.7 61.8,65.6 78.1,70.6  "
  })), _polygon858 || (_polygon858 = /*#__PURE__*/React.createElement("polygon", {
    className: "st918",
    points: "77.4,70.6 61.8,65.8 61.8,65.7 77.7,70.6  "
  })), _polygon859 || (_polygon859 = /*#__PURE__*/React.createElement("polygon", {
    className: "st769",
    points: "77.1,70.6 61.8,65.9 61.8,65.8 77.4,70.6  "
  })), _polygon860 || (_polygon860 = /*#__PURE__*/React.createElement("polygon", {
    className: "st768",
    points: "76.7,70.6 61.8,66 61.8,65.9 77.1,70.6  "
  })), _polygon861 || (_polygon861 = /*#__PURE__*/React.createElement("polygon", {
    className: "st919",
    points: "76.4,70.6 61.8,66.1 61.8,66 76.7,70.6  "
  })), _polygon862 || (_polygon862 = /*#__PURE__*/React.createElement("polygon", {
    className: "st920",
    points: "76.1,70.6 61.8,66.2 61.8,66.1 76.4,70.6  "
  })), _polygon863 || (_polygon863 = /*#__PURE__*/React.createElement("polygon", {
    className: "st921",
    points: "75.7,70.6 61.8,66.3 61.8,66.2 76.1,70.6  "
  })), _polygon864 || (_polygon864 = /*#__PURE__*/React.createElement("polygon", {
    className: "st764",
    points: "75.4,70.6 61.8,66.4 61.8,66.3 75.7,70.6  "
  })), _polygon865 || (_polygon865 = /*#__PURE__*/React.createElement("polygon", {
    className: "st764",
    points: "75.4,70.6 61.8,66.4 61.8,66.4 75.4,70.6  "
  })), _polygon866 || (_polygon866 = /*#__PURE__*/React.createElement("polygon", {
    className: "st763",
    points: "75.3,70.6 61.8,66.5 61.8,66.4 75.4,70.6  "
  })), _polygon867 || (_polygon867 = /*#__PURE__*/React.createElement("polygon", {
    className: "st762",
    points: "75.3,70.6 61.8,66.5 61.8,66.5 75.3,70.6  "
  })), _polygon868 || (_polygon868 = /*#__PURE__*/React.createElement("polygon", {
    className: "st922",
    points: "75.3,70.6 61.8,66.5 61.8,66.5 75.3,70.6  "
  })), _polygon869 || (_polygon869 = /*#__PURE__*/React.createElement("polygon", {
    className: "st923",
    points: "75.2,70.6 61.8,66.5 61.8,66.5 75.3,70.6  "
  })), _polygon870 || (_polygon870 = /*#__PURE__*/React.createElement("polygon", {
    className: "st924",
    points: "75.2,70.6 61.8,66.5 61.8,66.5 75.2,70.6  "
  })), _polygon871 || (_polygon871 = /*#__PURE__*/React.createElement("polygon", {
    className: "st925",
    points: "75.1,70.6 61.8,66.5 61.8,66.5 75.2,70.6  "
  })), _polygon872 || (_polygon872 = /*#__PURE__*/React.createElement("polygon", {
    className: "st926",
    points: "75.1,70.6 61.8,66.5 61.8,66.5 75.1,70.6  "
  })), _polygon873 || (_polygon873 = /*#__PURE__*/React.createElement("polygon", {
    className: "st927",
    points: "75.1,70.6 61.8,66.5 61.8,66.5 75.1,70.6  "
  })), _polygon874 || (_polygon874 = /*#__PURE__*/React.createElement("polygon", {
    className: "st928",
    points: "75,70.6 61.8,66.6 61.8,66.5 75.1,70.6  "
  })), _polygon875 || (_polygon875 = /*#__PURE__*/React.createElement("polygon", {
    className: "st929",
    points: "75,70.6 61.8,66.6 61.8,66.6 75,70.6  "
  })), _polygon876 || (_polygon876 = /*#__PURE__*/React.createElement("polygon", {
    className: "st930",
    points: "75,70.6 61.8,66.6 61.8,66.6 75,70.6  "
  })), _polygon877 || (_polygon877 = /*#__PURE__*/React.createElement("polygon", {
    className: "st931",
    points: "74.9,70.6 61.8,66.6 61.8,66.6 75,70.6  "
  })), _polygon878 || (_polygon878 = /*#__PURE__*/React.createElement("polygon", {
    className: "st931",
    points: "74.9,70.6 61.8,66.6 61.8,66.6 74.9,70.6  "
  })), _polygon879 || (_polygon879 = /*#__PURE__*/React.createElement("polygon", {
    className: "st932",
    points: "74.9,70.6 61.8,66.6 61.8,66.6 74.9,70.6  "
  })), _polygon880 || (_polygon880 = /*#__PURE__*/React.createElement("polygon", {
    className: "st933",
    points: "74.8,70.6 61.8,66.6 61.8,66.6 74.9,70.6  "
  })), _polygon881 || (_polygon881 = /*#__PURE__*/React.createElement("polygon", {
    className: "st934",
    points: "74.8,70.6 61.8,66.6 61.8,66.6 74.8,70.6  "
  })), _polygon882 || (_polygon882 = /*#__PURE__*/React.createElement("polygon", {
    className: "st935",
    points: "74.8,70.6 61.8,66.6 61.8,66.6 74.8,70.6  "
  })), _polygon883 || (_polygon883 = /*#__PURE__*/React.createElement("polygon", {
    className: "st936",
    points: "74.8,70.6 61.8,66.6 61.8,66.6 74.8,70.6  "
  })), _polygon884 || (_polygon884 = /*#__PURE__*/React.createElement("polygon", {
    className: "st937",
    points: "74.8,70.6 61.8,66.6 61.8,66.6 74.8,70.6  "
  })), _polygon885 || (_polygon885 = /*#__PURE__*/React.createElement("polygon", {
    className: "st938",
    points: "74.7,70.6 61.8,66.6 61.8,66.6 74.8,70.6  "
  })), _polygon886 || (_polygon886 = /*#__PURE__*/React.createElement("polygon", {
    className: "st939",
    points: "74.7,70.6 61.8,66.7 61.8,66.6 74.7,70.6  "
  })), _polygon887 || (_polygon887 = /*#__PURE__*/React.createElement("polygon", {
    className: "st940",
    points: "74.7,70.6 61.8,66.7 61.8,66.7 74.7,70.6  "
  })), _polygon888 || (_polygon888 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "74.7,70.6 61.8,66.7 61.8,66.7 74.7,70.6  "
  })), _polygon889 || (_polygon889 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "74.6,70.6 61.8,66.7 61.8,66.7 74.7,70.6  "
  })), _polygon890 || (_polygon890 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "74.6,70.6 61.8,66.7 61.8,66.7 74.6,70.6  "
  })), _polygon891 || (_polygon891 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "74.6,70.6 61.8,66.7 61.8,66.7 74.6,70.6  "
  })), _polygon892 || (_polygon892 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "74.6,70.6 61.8,66.7 61.8,66.7 74.6,70.6  "
  })), _polygon893 || (_polygon893 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "74.5,70.6 61.8,66.7 61.8,66.7 74.6,70.6  "
  })), _polygon894 || (_polygon894 = /*#__PURE__*/React.createElement("polygon", {
    className: "st941",
    points: "74.5,70.6 61.8,66.7 61.8,66.7 74.5,70.6  "
  })), _polygon895 || (_polygon895 = /*#__PURE__*/React.createElement("polygon", {
    className: "st942",
    points: "74.5,70.6 61.8,66.7 61.8,66.7 74.5,70.6  "
  })), _polygon896 || (_polygon896 = /*#__PURE__*/React.createElement("polygon", {
    className: "st943",
    points: "74.5,70.6 61.8,66.7 61.8,66.7 74.5,70.6  "
  })), _polygon897 || (_polygon897 = /*#__PURE__*/React.createElement("polygon", {
    className: "st944",
    points: "74.4,70.6 61.8,66.7 61.8,66.7 74.5,70.6  "
  })), _polygon898 || (_polygon898 = /*#__PURE__*/React.createElement("polygon", {
    className: "st945",
    points: "74.4,70.6 61.8,66.7 61.8,66.7 74.4,70.6  "
  })), _polygon899 || (_polygon899 = /*#__PURE__*/React.createElement("polygon", {
    className: "st946",
    points: "74.4,70.6 61.8,66.7 61.8,66.7 74.4,70.6  "
  })), _polygon900 || (_polygon900 = /*#__PURE__*/React.createElement("polygon", {
    className: "st947",
    points: "74.4,70.6 61.8,66.8 61.8,66.7 74.4,70.6  "
  })), _polygon901 || (_polygon901 = /*#__PURE__*/React.createElement("polygon", {
    className: "st948",
    points: "74.4,70.6 61.8,66.8 61.8,66.8 74.4,70.6  "
  })), _polygon902 || (_polygon902 = /*#__PURE__*/React.createElement("polygon", {
    className: "st949",
    points: "74.3,70.6 61.8,66.8 61.8,66.8 74.4,70.6  "
  })), _polygon903 || (_polygon903 = /*#__PURE__*/React.createElement("polygon", {
    className: "st950",
    points: "74.3,70.6 61.8,66.8 61.8,66.8 74.3,70.6  "
  })), _polygon904 || (_polygon904 = /*#__PURE__*/React.createElement("polygon", {
    className: "st951",
    points: "74.3,70.6 61.8,66.8 61.8,66.8 74.3,70.6  "
  })), _polygon905 || (_polygon905 = /*#__PURE__*/React.createElement("polygon", {
    className: "st952",
    points: "74.3,70.6 61.8,66.8 61.8,66.8 74.3,70.6  "
  })), _polygon906 || (_polygon906 = /*#__PURE__*/React.createElement("polygon", {
    className: "st953",
    points: "74.2,70.6 61.8,66.8 61.8,66.8 74.3,70.6  "
  })), _polygon907 || (_polygon907 = /*#__PURE__*/React.createElement("polygon", {
    className: "st954",
    points: "74.2,70.6 61.8,66.8 61.8,66.8 74.2,70.6  "
  })), _polygon908 || (_polygon908 = /*#__PURE__*/React.createElement("polygon", {
    className: "st955",
    points: "74.2,70.6 61.8,66.8 61.8,66.8 74.2,70.6  "
  })), _polygon909 || (_polygon909 = /*#__PURE__*/React.createElement("polygon", {
    className: "st956",
    points: "74.2,70.6 61.8,66.8 61.8,66.8 74.2,70.6  "
  })), _polygon910 || (_polygon910 = /*#__PURE__*/React.createElement("polygon", {
    className: "st956",
    points: "74.1,70.6 61.8,66.8 61.8,66.8 74.2,70.6  "
  })), _polygon911 || (_polygon911 = /*#__PURE__*/React.createElement("polygon", {
    className: "st957",
    points: "74.1,70.6 61.8,66.8 61.8,66.8 74.1,70.6  "
  })), _polygon912 || (_polygon912 = /*#__PURE__*/React.createElement("polygon", {
    className: "st958",
    points: "74.1,70.6 61.8,66.8 61.8,66.8 74.1,70.6  "
  })), _polygon913 || (_polygon913 = /*#__PURE__*/React.createElement("polygon", {
    className: "st959",
    points: "74.1,70.6 61.8,66.8 61.8,66.8 74.1,70.6  "
  })), _polygon914 || (_polygon914 = /*#__PURE__*/React.createElement("polygon", {
    className: "st960",
    points: "74.1,70.6 61.8,66.8 61.8,66.8 74.1,70.6  "
  })), _polygon915 || (_polygon915 = /*#__PURE__*/React.createElement("polygon", {
    className: "st961",
    points: "74.1,70.6 61.8,66.9 61.8,66.8 74.1,70.6  "
  })), _polygon916 || (_polygon916 = /*#__PURE__*/React.createElement("polygon", {
    className: "st962",
    points: "74,70.6 61.8,66.9 61.8,66.9 74.1,70.6  "
  })), _polygon917 || (_polygon917 = /*#__PURE__*/React.createElement("polygon", {
    className: "st963",
    points: "74,70.6 61.8,66.9 61.8,66.9 74,70.6  "
  })), _polygon918 || (_polygon918 = /*#__PURE__*/React.createElement("polygon", {
    className: "st964",
    points: "74,70.6 61.8,66.9 61.8,66.9 74,70.6  "
  })), _polygon919 || (_polygon919 = /*#__PURE__*/React.createElement("polygon", {
    className: "st965",
    points: "74,70.6 61.8,66.9 61.8,66.9 74,70.6  "
  })), _polygon920 || (_polygon920 = /*#__PURE__*/React.createElement("polygon", {
    className: "st966",
    points: "74,70.6 61.8,66.9 61.8,66.9 74,70.6  "
  })), _polygon921 || (_polygon921 = /*#__PURE__*/React.createElement("polygon", {
    className: "st967",
    points: "73.9,70.6 61.8,66.9 61.8,66.9 74,70.6  "
  })), _polygon922 || (_polygon922 = /*#__PURE__*/React.createElement("polygon", {
    className: "st968",
    points: "73.9,70.6 61.8,66.9 61.8,66.9 73.9,70.6  "
  })), _polygon923 || (_polygon923 = /*#__PURE__*/React.createElement("polygon", {
    className: "st969",
    points: "73.9,70.6 61.8,66.9 61.8,66.9 73.9,70.6  "
  })), _polygon924 || (_polygon924 = /*#__PURE__*/React.createElement("polygon", {
    className: "st970",
    points: "73.9,70.6 61.8,66.9 61.8,66.9 73.9,70.6  "
  })), _polygon925 || (_polygon925 = /*#__PURE__*/React.createElement("polygon", {
    className: "st971",
    points: "73.9,70.6 61.8,66.9 61.8,66.9 73.9,70.6  "
  })), _polygon926 || (_polygon926 = /*#__PURE__*/React.createElement("polygon", {
    className: "st972",
    points: "73.8,70.6 61.8,66.9 61.8,66.9 73.9,70.6  "
  })), _polygon927 || (_polygon927 = /*#__PURE__*/React.createElement("polygon", {
    className: "st973",
    points: "73.8,70.6 61.8,66.9 61.8,66.9 73.8,70.6  "
  })), _polygon928 || (_polygon928 = /*#__PURE__*/React.createElement("polygon", {
    className: "st974",
    points: "73.8,70.6 61.8,66.9 61.8,66.9 73.8,70.6  "
  })), _polygon929 || (_polygon929 = /*#__PURE__*/React.createElement("polygon", {
    className: "st975",
    points: "73.8,70.6 61.8,66.9 61.8,66.9 73.8,70.6  "
  })), _polygon930 || (_polygon930 = /*#__PURE__*/React.createElement("polygon", {
    className: "st976",
    points: "73.8,70.6 61.8,66.9 61.8,66.9 73.8,70.6  "
  })), _polygon931 || (_polygon931 = /*#__PURE__*/React.createElement("polygon", {
    className: "st977",
    points: "73.7,70.6 61.8,67 61.8,66.9 73.8,70.6  "
  })), _polygon932 || (_polygon932 = /*#__PURE__*/React.createElement("polygon", {
    className: "st978",
    points: "73.7,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon933 || (_polygon933 = /*#__PURE__*/React.createElement("polygon", {
    className: "st979",
    points: "73.7,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon934 || (_polygon934 = /*#__PURE__*/React.createElement("polygon", {
    className: "st980",
    points: "73.7,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon935 || (_polygon935 = /*#__PURE__*/React.createElement("polygon", {
    className: "st981",
    points: "73.7,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon936 || (_polygon936 = /*#__PURE__*/React.createElement("polygon", {
    className: "st982",
    points: "73.7,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon937 || (_polygon937 = /*#__PURE__*/React.createElement("polygon", {
    className: "st983",
    points: "73.6,70.6 61.8,67 61.8,67 73.7,70.6  "
  })), _polygon938 || (_polygon938 = /*#__PURE__*/React.createElement("polygon", {
    className: "st984",
    points: "73.6,70.6 61.8,67 61.8,67 73.6,70.6  "
  })), _polygon939 || (_polygon939 = /*#__PURE__*/React.createElement("polygon", {
    className: "st985",
    points: "73.6,70.6 61.8,67 61.8,67 73.6,70.6  "
  })), _polygon940 || (_polygon940 = /*#__PURE__*/React.createElement("polygon", {
    className: "st986",
    points: "73.6,70.6 61.8,67 61.8,67 73.6,70.6  "
  })), _polygon941 || (_polygon941 = /*#__PURE__*/React.createElement("polygon", {
    className: "st987",
    points: "73.6,70.6 61.8,67 61.8,67 73.6,70.6  "
  })), _polygon942 || (_polygon942 = /*#__PURE__*/React.createElement("polygon", {
    className: "st988",
    points: "73.5,70.6 61.8,67 61.8,67 73.6,70.6  "
  })), _polygon943 || (_polygon943 = /*#__PURE__*/React.createElement("polygon", {
    className: "st989",
    points: "73.5,70.6 61.8,67 61.8,67 73.5,70.6  "
  })), _polygon944 || (_polygon944 = /*#__PURE__*/React.createElement("polygon", {
    className: "st990",
    points: "73.5,70.6 61.8,67 61.8,67 73.5,70.6  "
  })), _polygon945 || (_polygon945 = /*#__PURE__*/React.createElement("polygon", {
    className: "st991",
    points: "73.5,70.6 61.8,67 61.8,67 73.5,70.6  "
  })), _polygon946 || (_polygon946 = /*#__PURE__*/React.createElement("polygon", {
    className: "st992",
    points: "73.5,70.6 61.8,67 61.8,67 73.5,70.6  "
  })), _polygon947 || (_polygon947 = /*#__PURE__*/React.createElement("polygon", {
    className: "st993",
    points: "73.4,70.6 61.8,67 61.8,67 73.5,70.6  "
  })), _polygon948 || (_polygon948 = /*#__PURE__*/React.createElement("polygon", {
    className: "st994",
    points: "73.4,70.6 61.8,67 61.8,67 73.4,70.6  "
  })), _polygon949 || (_polygon949 = /*#__PURE__*/React.createElement("polygon", {
    className: "st995",
    points: "73.4,70.6 61.8,67.1 61.8,67 73.4,70.6  "
  })), _polygon950 || (_polygon950 = /*#__PURE__*/React.createElement("polygon", {
    className: "st996",
    points: "73.4,70.6 61.8,67.1 61.8,67.1 73.4,70.6  "
  })), _polygon951 || (_polygon951 = /*#__PURE__*/React.createElement("polygon", {
    className: "st997",
    points: "73.4,70.6 61.8,67.1 61.8,67.1 73.4,70.6  "
  })), _polygon952 || (_polygon952 = /*#__PURE__*/React.createElement("polygon", {
    className: "st998",
    points: "73.3,70.6 61.8,67.1 61.8,67.1 73.4,70.6  "
  })), _polygon953 || (_polygon953 = /*#__PURE__*/React.createElement("polygon", {
    className: "st999",
    points: "73.3,70.6 61.8,67.1 61.8,67.1 73.3,70.6  "
  })), _polygon954 || (_polygon954 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1000",
    points: "73.3,70.6 61.8,67.1 61.8,67.1 73.3,70.6  "
  })), _polygon955 || (_polygon955 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1001",
    points: "73.3,70.6 61.8,67.1 61.8,67.1 73.3,70.6  "
  })), _polygon956 || (_polygon956 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1002",
    points: "73.3,70.6 61.8,67.1 61.8,67.1 73.3,70.6  "
  })), _polygon957 || (_polygon957 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1003",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.3,70.6  "
  })), _polygon958 || (_polygon958 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1004",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon959 || (_polygon959 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1005",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon960 || (_polygon960 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1006",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon961 || (_polygon961 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1007",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon962 || (_polygon962 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1007",
    points: "73.2,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon963 || (_polygon963 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1008",
    points: "73.1,70.6 61.8,67.1 61.8,67.1 73.2,70.6  "
  })), _polygon964 || (_polygon964 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1009",
    points: "73.1,70.6 61.8,67.1 61.8,67.1 73.1,70.6  "
  })), _polygon965 || (_polygon965 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1010",
    points: "73.1,70.6 61.8,67.1 61.8,67.1 73.1,70.6  "
  })), _polygon966 || (_polygon966 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1011",
    points: "73.1,70.6 61.8,67.2 61.8,67.1 73.1,70.6  "
  })), _polygon967 || (_polygon967 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1012",
    points: "73.1,70.6 61.8,67.2 61.8,67.2 73.1,70.6  "
  })), _polygon968 || (_polygon968 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1013",
    points: "73.1,70.6 61.8,67.2 61.8,67.2 73.1,70.6  "
  })), _polygon969 || (_polygon969 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1014",
    points: "73,70.6 61.8,67.2 61.8,67.2 73.1,70.6  "
  })), _polygon970 || (_polygon970 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1015",
    points: "73,70.6 61.8,67.2 61.8,67.2 73,70.6  "
  })), _polygon971 || (_polygon971 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1016",
    points: "73,70.6 61.8,67.2 61.8,67.2 73,70.6  "
  })), _polygon972 || (_polygon972 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1017",
    points: "73,70.6 61.8,67.2 61.8,67.2 73,70.6  "
  })), _polygon973 || (_polygon973 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1018",
    points: "73,70.6 61.8,67.2 61.8,67.2 73,70.6  "
  })), _polygon974 || (_polygon974 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1019",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 73,70.6  "
  })), _polygon975 || (_polygon975 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1020",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon976 || (_polygon976 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1021",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon977 || (_polygon977 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1022",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon978 || (_polygon978 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1023",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon979 || (_polygon979 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1024",
    points: "72.9,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon980 || (_polygon980 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1025",
    points: "72.8,70.6 61.8,67.2 61.8,67.2 72.9,70.6  "
  })), _polygon981 || (_polygon981 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1026",
    points: "72.8,70.6 61.8,67.2 61.8,67.2 72.8,70.6  "
  })), _polygon982 || (_polygon982 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1027",
    points: "72.8,70.6 61.8,67.2 61.8,67.2 72.8,70.6  "
  })), _polygon983 || (_polygon983 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1028",
    points: "72.8,70.6 61.8,67.2 61.8,67.2 72.8,70.6  "
  })), _polygon984 || (_polygon984 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1029",
    points: "72.8,70.6 61.8,67.2 61.8,67.2 72.8,70.6  "
  })), _polygon985 || (_polygon985 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1030",
    points: "72.7,70.6 61.8,67.3 61.8,67.2 72.8,70.6  "
  })), _polygon986 || (_polygon986 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1031",
    points: "72.7,70.6 61.8,67.3 61.8,67.3 72.7,70.6  "
  })), _polygon987 || (_polygon987 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1032",
    points: "72.7,70.6 61.8,67.3 61.8,67.3 72.7,70.6  "
  })), _polygon988 || (_polygon988 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1033",
    points: "72.7,70.6 61.8,67.3 61.8,67.3 72.7,70.6  "
  })), _polygon989 || (_polygon989 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1034",
    points: "72.7,70.6 61.8,67.3 61.8,67.3 72.7,70.6  "
  })), _polygon990 || (_polygon990 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1034",
    points: "61.8,67.3 72.7,70.6 61.8,70.6  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088097255368918332850000013344655828455833748_",
    points: "61.8,59.8 61.8,67 57.2,71.3 51.3,69.5  61.8,59.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119831379445518542660000006723405074866543259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088097255368918332850000013344655828455833748_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119831379445518542660000006723405074866543259_)"
    }
  }, _polygon991 || (_polygon991 = /*#__PURE__*/React.createElement("polygon", {
    className: "st626",
    points: "61.5,59.8 51.3,69.7 51.3,59.8  "
  })), _polygon992 || (_polygon992 = /*#__PURE__*/React.createElement("polygon", {
    className: "st626",
    points: "61.6,59.8 51.3,69.8 51.3,69.7 61.5,59.8  "
  })), _polygon993 || (_polygon993 = /*#__PURE__*/React.createElement("polygon", {
    className: "st625",
    points: "61.8,59.8 51.3,70 51.3,69.8 61.6,59.8 61.8,59.8  "
  })), _polygon994 || (_polygon994 = /*#__PURE__*/React.createElement("polygon", {
    className: "st624",
    points: "61.8,60 51.3,70.1 51.3,70 61.8,59.8  "
  })), _polygon995 || (_polygon995 = /*#__PURE__*/React.createElement("polygon", {
    className: "st623",
    points: "61.8,60.1 51.3,70.2 51.3,70.1 61.8,60  "
  })), _polygon996 || (_polygon996 = /*#__PURE__*/React.createElement("polygon", {
    className: "st622",
    points: "61.8,60.2 51.3,70.4 51.3,70.2 61.8,60.1  "
  })), _polygon997 || (_polygon997 = /*#__PURE__*/React.createElement("polygon", {
    className: "st621",
    points: "61.8,60.4 51.3,70.5 51.3,70.4 61.8,60.2  "
  })), _polygon998 || (_polygon998 = /*#__PURE__*/React.createElement("polygon", {
    className: "st620",
    points: "61.8,60.5 51.3,70.6 51.3,70.5 61.8,60.4  "
  })), _polygon999 || (_polygon999 = /*#__PURE__*/React.createElement("polygon", {
    className: "st619",
    points: "61.8,60.6 51.3,70.8 51.3,70.6 61.8,60.5  "
  })), _polygon1000 || (_polygon1000 = /*#__PURE__*/React.createElement("polygon", {
    className: "st618",
    points: "61.8,60.8 51.3,70.9 51.3,70.8 61.8,60.6  "
  })), _polygon1001 || (_polygon1001 = /*#__PURE__*/React.createElement("polygon", {
    className: "st617",
    points: "61.8,60.9 51.3,71 51.3,70.9 61.8,60.8  "
  })), _polygon1002 || (_polygon1002 = /*#__PURE__*/React.createElement("polygon", {
    className: "st616",
    points: "61.8,61 51.3,71.2 51.3,71.2 51.3,71 61.8,60.9  "
  })), _polygon1003 || (_polygon1003 = /*#__PURE__*/React.createElement("polygon", {
    className: "st615",
    points: "61.8,61.2 51.4,71.2 51.3,71.2 61.8,61  "
  })), _polygon1004 || (_polygon1004 = /*#__PURE__*/React.createElement("polygon", {
    className: "st312",
    points: "61.8,61.3 51.5,71.3 51.4,71.2 61.8,61.2  "
  })), _polygon1005 || (_polygon1005 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1036",
    points: "61.8,61.4 51.6,71.3 51.5,71.3 51.5,71.3 61.8,61.3  "
  })), _polygon1006 || (_polygon1006 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1037",
    points: "61.8,61.6 51.7,71.3 51.6,71.3 61.8,61.4  "
  })), _polygon1007 || (_polygon1007 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1038",
    points: "61.8,61.7 51.9,71.3 51.7,71.3 61.8,61.6  "
  })), _polygon1008 || (_polygon1008 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1039",
    points: "61.8,61.8 52,71.3 51.9,71.3 61.8,61.7  "
  })), _polygon1009 || (_polygon1009 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1040",
    points: "61.8,62 52.1,71.3 52,71.3 61.8,61.8  "
  })), _polygon1010 || (_polygon1010 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1041",
    points: "61.8,62.1 52.3,71.3 52.1,71.3 61.8,62  "
  })), _polygon1011 || (_polygon1011 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1042",
    points: "61.8,62.2 52.4,71.3 52.3,71.3 61.8,62.1  "
  })), _polygon1012 || (_polygon1012 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1043",
    points: "61.8,62.4 52.6,71.3 52.4,71.3 61.8,62.2  "
  })), _polygon1013 || (_polygon1013 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1044",
    points: "61.8,62.5 52.7,71.3 52.6,71.3 61.8,62.4  "
  })), _polygon1014 || (_polygon1014 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1045",
    points: "61.8,62.6 52.8,71.3 52.7,71.3 61.8,62.5  "
  })), _polygon1015 || (_polygon1015 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1046",
    points: "61.8,62.8 53,71.3 52.8,71.3 61.8,62.6  "
  })), _polygon1016 || (_polygon1016 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1047",
    points: "61.8,62.9 53.1,71.3 53,71.3 61.8,62.8  "
  })), _polygon1017 || (_polygon1017 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1047",
    points: "61.8,63 53.2,71.3 53.1,71.3 61.8,62.9  "
  })), _polygon1018 || (_polygon1018 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1048",
    points: "61.8,63.2 53.4,71.3 53.2,71.3 61.8,63  "
  })), _polygon1019 || (_polygon1019 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1049",
    points: "61.8,63.3 53.5,71.3 53.4,71.3 61.8,63.2  "
  })), _polygon1020 || (_polygon1020 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1050",
    points: "61.8,63.4 53.6,71.3 53.5,71.3 61.8,63.3  "
  })), _polygon1021 || (_polygon1021 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1051",
    points: "61.8,63.5 53.7,71.3 53.6,71.3 61.8,63.4  "
  })), _polygon1022 || (_polygon1022 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1052",
    points: "61.8,63.6 53.8,71.3 53.7,71.3 61.8,63.5  "
  })), _polygon1023 || (_polygon1023 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1053",
    points: "61.8,63.7 54,71.3 53.8,71.3 61.8,63.6  "
  })), _polygon1024 || (_polygon1024 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1054",
    points: "61.8,63.9 54.1,71.3 54,71.3 61.8,63.7  "
  })), _polygon1025 || (_polygon1025 = /*#__PURE__*/React.createElement("polygon", {
    className: "st333",
    points: "61.8,64 54.2,71.3 54.1,71.3 61.8,63.9  "
  })), _polygon1026 || (_polygon1026 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1055",
    points: "61.8,64.1 54.3,71.3 54.2,71.3 61.8,64  "
  })), _polygon1027 || (_polygon1027 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1056",
    points: "61.8,64.2 54.5,71.3 54.3,71.3 61.8,64.1  "
  })), _polygon1028 || (_polygon1028 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1057",
    points: "61.8,64.3 54.6,71.3 54.5,71.3 61.8,64.2  "
  })), _polygon1029 || (_polygon1029 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1058",
    points: "61.8,64.5 54.7,71.3 54.6,71.3 61.8,64.3  "
  })), _polygon1030 || (_polygon1030 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1059",
    points: "61.8,64.6 54.8,71.3 54.7,71.3 61.8,64.5  "
  })), _polygon1031 || (_polygon1031 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1060",
    points: "61.8,64.7 54.9,71.3 54.8,71.3 61.8,64.6  "
  })), _polygon1032 || (_polygon1032 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1061",
    points: "61.8,64.8 55.1,71.3 54.9,71.3 61.8,64.7  "
  })), _polygon1033 || (_polygon1033 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1062",
    points: "61.8,64.9 55.2,71.3 55.1,71.3 61.8,64.8  "
  })), _polygon1034 || (_polygon1034 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1063",
    points: "61.8,65 55.3,71.3 55.2,71.3 61.8,64.9  "
  })), _polygon1035 || (_polygon1035 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1064",
    points: "61.8,65.2 55.4,71.3 55.3,71.3 61.8,65  "
  })), _polygon1036 || (_polygon1036 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1065",
    points: "61.8,65.3 55.6,71.3 55.4,71.3 61.8,65.2  "
  })), _polygon1037 || (_polygon1037 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1066",
    points: "61.8,65.4 55.7,71.3 55.6,71.3 61.8,65.3  "
  })), _polygon1038 || (_polygon1038 = /*#__PURE__*/React.createElement("polygon", {
    className: "st403",
    points: "61.8,65.5 55.8,71.3 55.7,71.3 61.8,65.4  "
  })), _polygon1039 || (_polygon1039 = /*#__PURE__*/React.createElement("polygon", {
    className: "st402",
    points: "61.8,65.6 55.9,71.3 55.8,71.3 61.8,65.5  "
  })), _polygon1040 || (_polygon1040 = /*#__PURE__*/React.createElement("polygon", {
    className: "st401",
    points: "61.8,65.8 56,71.3 55.9,71.3 61.8,65.6  "
  })), _polygon1041 || (_polygon1041 = /*#__PURE__*/React.createElement("polygon", {
    className: "st400",
    points: "61.8,65.9 56.2,71.3 56,71.3 61.8,65.8  "
  })), _polygon1042 || (_polygon1042 = /*#__PURE__*/React.createElement("polygon", {
    className: "st399",
    points: "61.8,66 56.3,71.3 56.2,71.3 61.8,65.9  "
  })), _polygon1043 || (_polygon1043 = /*#__PURE__*/React.createElement("polygon", {
    className: "st399",
    points: "61.8,66 56.3,71.3 56.3,71.3 61.8,66  "
  })), _polygon1044 || (_polygon1044 = /*#__PURE__*/React.createElement("polygon", {
    className: "st398",
    points: "61.8,66 56.3,71.3 56.3,71.3 61.8,66  "
  })), _polygon1045 || (_polygon1045 = /*#__PURE__*/React.createElement("polygon", {
    className: "st397",
    points: "61.8,66.1 56.4,71.3 56.3,71.3 61.8,66  "
  })), _polygon1046 || (_polygon1046 = /*#__PURE__*/React.createElement("polygon", {
    className: "st396",
    points: "61.8,66.1 56.4,71.3 56.4,71.3 61.8,66.1  "
  })), _polygon1047 || (_polygon1047 = /*#__PURE__*/React.createElement("polygon", {
    className: "st395",
    points: "61.8,66.1 56.4,71.3 56.4,71.3 61.8,66.1  "
  })), _polygon1048 || (_polygon1048 = /*#__PURE__*/React.createElement("polygon", {
    className: "st393",
    points: "61.8,66.1 56.4,71.3 56.4,71.3 61.8,66.1  "
  })), _polygon1049 || (_polygon1049 = /*#__PURE__*/React.createElement("polygon", {
    className: "st392",
    points: "61.8,66.2 56.5,71.3 56.4,71.3 61.8,66.1  "
  })), _polygon1050 || (_polygon1050 = /*#__PURE__*/React.createElement("polygon", {
    className: "st391",
    points: "61.8,66.2 56.5,71.3 56.5,71.3 61.8,66.2  "
  })), _polygon1051 || (_polygon1051 = /*#__PURE__*/React.createElement("polygon", {
    className: "st390",
    points: "61.8,66.2 56.5,71.3 56.5,71.3 61.8,66.2  "
  })), _polygon1052 || (_polygon1052 = /*#__PURE__*/React.createElement("polygon", {
    className: "st390",
    points: "61.8,66.2 56.5,71.3 56.5,71.3 61.8,66.2  "
  })), _polygon1053 || (_polygon1053 = /*#__PURE__*/React.createElement("polygon", {
    className: "st389",
    points: "61.8,66.2 56.5,71.3 56.5,71.3 61.8,66.2  "
  })), _polygon1054 || (_polygon1054 = /*#__PURE__*/React.createElement("polygon", {
    className: "st388",
    points: "61.8,66.3 56.6,71.3 56.5,71.3 61.8,66.2  "
  })), _polygon1055 || (_polygon1055 = /*#__PURE__*/React.createElement("polygon", {
    className: "st387",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1056 || (_polygon1056 = /*#__PURE__*/React.createElement("polygon", {
    className: "st386",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1057 || (_polygon1057 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1067",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1058 || (_polygon1058 = /*#__PURE__*/React.createElement("polygon", {
    className: "st385",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1059 || (_polygon1059 = /*#__PURE__*/React.createElement("polygon", {
    className: "st384",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1060 || (_polygon1060 = /*#__PURE__*/React.createElement("polygon", {
    className: "st367",
    points: "61.8,66.3 56.6,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1061 || (_polygon1061 = /*#__PURE__*/React.createElement("polygon", {
    className: "st368",
    points: "61.8,66.4 56.7,71.3 56.6,71.3 61.8,66.3  "
  })), _polygon1062 || (_polygon1062 = /*#__PURE__*/React.createElement("polygon", {
    className: "st369",
    points: "61.8,66.4 56.7,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1063 || (_polygon1063 = /*#__PURE__*/React.createElement("polygon", {
    className: "st370",
    points: "61.8,66.4 56.7,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1064 || (_polygon1064 = /*#__PURE__*/React.createElement("polygon", {
    className: "st371",
    points: "61.8,66.4 56.7,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1065 || (_polygon1065 = /*#__PURE__*/React.createElement("polygon", {
    className: "st373",
    points: "61.8,66.4 56.7,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1066 || (_polygon1066 = /*#__PURE__*/React.createElement("polygon", {
    className: "st374",
    points: "61.8,66.4 56.7,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1067 || (_polygon1067 = /*#__PURE__*/React.createElement("polygon", {
    className: "st375",
    points: "61.8,66.4 56.8,71.3 56.7,71.3 61.8,66.4  "
  })), _polygon1068 || (_polygon1068 = /*#__PURE__*/React.createElement("polygon", {
    className: "st376",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.4  "
  })), _polygon1069 || (_polygon1069 = /*#__PURE__*/React.createElement("polygon", {
    className: "st377",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1070 || (_polygon1070 = /*#__PURE__*/React.createElement("polygon", {
    className: "st378",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1071 || (_polygon1071 = /*#__PURE__*/React.createElement("polygon", {
    className: "st379",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1072 || (_polygon1072 = /*#__PURE__*/React.createElement("polygon", {
    className: "st380",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1073 || (_polygon1073 = /*#__PURE__*/React.createElement("polygon", {
    className: "st381",
    points: "61.8,66.5 56.8,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1074 || (_polygon1074 = /*#__PURE__*/React.createElement("polygon", {
    className: "st382",
    points: "61.8,66.5 56.9,71.3 56.8,71.3 61.8,66.5  "
  })), _polygon1075 || (_polygon1075 = /*#__PURE__*/React.createElement("polygon", {
    className: "st383",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.5  "
  })), _polygon1076 || (_polygon1076 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1068",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1077 || (_polygon1077 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1068",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1078 || (_polygon1078 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1069",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1079 || (_polygon1079 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1070",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1080 || (_polygon1080 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1071",
    points: "61.8,66.6 56.9,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1081 || (_polygon1081 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1072",
    points: "61.8,66.6 57,71.3 56.9,71.3 61.8,66.6  "
  })), _polygon1082 || (_polygon1082 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1073",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.6  "
  })), _polygon1083 || (_polygon1083 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1074",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.7  "
  })), _polygon1084 || (_polygon1084 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1075",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.7  "
  })), _polygon1085 || (_polygon1085 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1076",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.7  "
  })), _polygon1086 || (_polygon1086 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1077",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.7  "
  })), _polygon1087 || (_polygon1087 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1078",
    points: "61.8,66.7 57,71.3 57,71.3 61.8,66.7  "
  })), _polygon1088 || (_polygon1088 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "61.8,66.7 57.1,71.3 57,71.3 61.8,66.7  "
  })), _polygon1089 || (_polygon1089 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.7  "
  })), _polygon1090 || (_polygon1090 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1091 || (_polygon1091 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1079",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1092 || (_polygon1092 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1080",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1093 || (_polygon1093 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1081",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1094 || (_polygon1094 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1082",
    points: "61.8,66.8 57.1,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1095 || (_polygon1095 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1083",
    points: "61.8,66.8 57.2,71.3 57.1,71.3 61.8,66.8  "
  })), _polygon1096 || (_polygon1096 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1084",
    points: "61.8,66.9 57.2,71.3 57.2,71.3 61.8,66.8  "
  })), _polygon1097 || (_polygon1097 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1085",
    points: "61.8,66.9 57.2,71.3 57.2,71.3 61.8,66.9  "
  })), _polygon1098 || (_polygon1098 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1085",
    points: "57.2,71.3 61.8,66.9 61.8,71.3  "
  })))), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 51.3,
    y: 59.1,
    className: "st697",
    width: 27.9,
    height: 10.4
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6,
    y: 64.9,
    className: "st697",
    width: 10.8,
    height: 10.4
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 95.7,
    className: "st697",
    width: 33,
    height: 17.6
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 94,
    className: "st697",
    width: 25.9,
    height: 10
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 59.7,
    className: "st697",
    width: 18.6,
    height: 5.6
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 40.4,
    className: "st697",
    width: 6.4,
    height: 11.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1086",
    d: "M49.2,109.1c0,0,25.3-16.9,28.9-19.2c3.6-2.4,9.9-4.9,21.9-5.2c12-0.3,18.1-10.7,18.1-10.7 s0.1,13.5-9.2,21.6c-9.4,8-17.7,2.7-19.8,1.6c-2.1-1.1-4.6-2.8-9.9,0.5c-5.3,3.3-27.9,14.7-27.9,14.7L49.2,109.1L49.2,109.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127734334565539202420000001446916269610736317_",
    d: "M112.2,79.2c1.8-9-2.4-17.4-9.3-18.8 c-7-1.4-14.1,4.7-15.9,13.6c-1.8,9,2.4,17.4,9.3,18.8C103.2,94.3,110.4,88.2,112.2,79.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083811748629971598670000014815951656746785459_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127734334565539202420000001446916269610736317_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083811748629971598670000014815951656746785459_)"
    }
  }, _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 93.1,
    className: "st281",
    width: 28.9,
    height: 1.2
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.9,
    className: "st281",
    width: 28.9,
    height: 0.1
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.8,
    className: "st280",
    width: 28.9,
    height: 0.1
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.7,
    className: "st279",
    width: 28.9,
    height: 0.1
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.5,
    className: "st278",
    width: 28.9,
    height: 0.1
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.4,
    className: "st277",
    width: 28.9,
    height: 0.1
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.3,
    className: "st276",
    width: 28.9,
    height: 0.1
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92.1,
    className: "st275",
    width: 28.9,
    height: 0.1
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 92,
    className: "st274",
    width: 28.9,
    height: 0.1
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.9,
    className: "st1088",
    width: 28.9,
    height: 0.1
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.7,
    className: "st1089",
    width: 28.9,
    height: 0.1
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.6,
    className: "st1090",
    width: 28.9,
    height: 0.1
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.5,
    className: "st1091",
    width: 28.9,
    height: 0.1
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.3,
    className: "st1092",
    width: 28.9,
    height: 0.1
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.2,
    className: "st1093",
    width: 28.9,
    height: 0.1
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 91.1,
    className: "st1094",
    width: 28.9,
    height: 0.1
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.9,
    className: "st1095",
    width: 28.9,
    height: 0.1
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.8,
    className: "st1096",
    width: 28.9,
    height: 0.1
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.7,
    className: "st1097",
    width: 28.9,
    height: 0.1
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.6,
    className: "st1098",
    width: 28.9,
    height: 0.1
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.4,
    className: "st1099",
    width: 28.9,
    height: 0.1
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.3,
    className: "st1100",
    width: 28.9,
    height: 0.1
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90.2,
    className: "st1101",
    width: 28.9,
    height: 0.1
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 90,
    className: "st1102",
    width: 28.9,
    height: 0.1
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.9,
    className: "st1103",
    width: 28.9,
    height: 0.1
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.8,
    className: "st1104",
    width: 28.9,
    height: 0.1
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.6,
    className: "st1104",
    width: 28.9,
    height: 0.2
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.4,
    className: "st1105",
    width: 28.9,
    height: 0.2
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.3,
    className: "st1106",
    width: 28.9,
    height: 0.2
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 89.1,
    className: "st1107",
    width: 28.9,
    height: 0.2
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.9,
    className: "st1108",
    width: 28.9,
    height: 0.2
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.8,
    className: "st1109",
    width: 28.9,
    height: 0.2
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.6,
    className: "st1110",
    width: 28.9,
    height: 0.2
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.5,
    className: "st1111",
    width: 28.9,
    height: 0.2
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.3,
    className: "st1112",
    width: 28.9,
    height: 0.2
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88.1,
    className: "st1113",
    width: 28.9,
    height: 0.2
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 88,
    className: "st1114",
    width: 28.9,
    height: 0.2
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87.8,
    className: "st1115",
    width: 28.9,
    height: 0.2
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87.6,
    className: "st1116",
    width: 28.9,
    height: 0.2
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87.5,
    className: "st1117",
    width: 28.9,
    height: 0.2
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87.3,
    className: "st1118",
    width: 28.9,
    height: 0.2
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87.1,
    className: "st1119",
    width: 28.9,
    height: 0.2
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 87,
    className: "st241",
    width: 28.9,
    height: 0.2
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86.8,
    className: "st240",
    width: 28.9,
    height: 0.2
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86.7,
    className: "st239",
    width: 28.9,
    height: 0.2
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86.5,
    className: "st238",
    width: 28.9,
    height: 0.2
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86.3,
    className: "st237",
    width: 28.9,
    height: 0.2
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86.2,
    className: "st236",
    width: 28.9,
    height: 0.2
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 86,
    className: "st235",
    width: 28.9,
    height: 0.2
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85.8,
    className: "st234",
    width: 28.9,
    height: 0.2
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85.7,
    className: "st233",
    width: 28.9,
    height: 0.2
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85.5,
    className: "st232",
    width: 28.9,
    height: 0.2
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85.3,
    className: "st211",
    width: 28.9,
    height: 0.2
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85.2,
    className: "st212",
    width: 28.9,
    height: 0.2
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 85,
    className: "st213",
    width: 28.9,
    height: 0.2
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 84.8,
    className: "st214",
    width: 28.9,
    height: 0.2
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 84.7,
    className: "st215",
    width: 28.9,
    height: 0.2
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 84.5,
    className: "st216",
    width: 28.9,
    height: 0.2
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 84.3,
    className: "st216",
    width: 28.9,
    height: 0.2
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 84.1,
    className: "st217",
    width: 28.9,
    height: 0.2
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 83.8,
    className: "st218",
    width: 28.9,
    height: 0.2
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 83.6,
    className: "st219",
    width: 28.9,
    height: 0.2
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 83.4,
    className: "st220",
    width: 28.9,
    height: 0.2
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 83.2,
    className: "st704",
    width: 28.9,
    height: 0.2
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 82.9,
    className: "st222",
    width: 28.9,
    height: 0.2
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 82.7,
    className: "st223",
    width: 28.9,
    height: 0.2
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 82.5,
    className: "st881",
    width: 28.9,
    height: 0.2
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 82.2,
    className: "st882",
    width: 28.9,
    height: 0.2
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 82,
    className: "st883",
    width: 28.9,
    height: 0.2
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 81.8,
    className: "st889",
    width: 28.9,
    height: 0.2
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 81.6,
    className: "st888",
    width: 28.9,
    height: 0.2
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 78.5,
    className: "st888",
    width: 28.9,
    height: 3
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 75.5,
    className: "st889",
    width: 28.9,
    height: 3
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 72.5,
    className: "st883",
    width: 28.9,
    height: 3
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 69.5,
    className: "st881",
    width: 28.9,
    height: 3
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 66.4,
    className: "st223",
    width: 28.9,
    height: 3
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 66.3,
    className: "st223",
    width: 28.9,
    height: 0.2
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 66.1,
    className: "st222",
    width: 28.9,
    height: 0.2
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 66,
    className: "st221",
    width: 28.9,
    height: 0.2
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.8,
    className: "st220",
    width: 28.9,
    height: 0.2
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.6,
    className: "st219",
    width: 28.9,
    height: 0.2
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.5,
    className: "st218",
    width: 28.9,
    height: 0.2
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.4,
    className: "st218",
    width: 28.9,
    height: 0.1
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.3,
    className: "st217",
    width: 28.9,
    height: 0.1
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.3,
    className: "st216",
    width: 28.9,
    height: 0.1
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.2,
    className: "st215",
    width: 28.9,
    height: 0.1
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.1,
    className: "st214",
    width: 28.9,
    height: 0.1
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65.1,
    className: "st213",
    width: 28.9,
    height: 0.1
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 65,
    className: "st212",
    width: 28.9,
    height: 0.1
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.9,
    className: "st211",
    width: 28.9,
    height: 0.1
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.9,
    className: "st210",
    width: 28.9,
    height: 0.1
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.8,
    className: "st209",
    width: 28.9,
    height: 0.1
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.7,
    className: "st208",
    width: 28.9,
    height: 0.1
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.7,
    className: "st207",
    width: 28.9,
    height: 0.1
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.6,
    className: "st206",
    width: 28.9,
    height: 0.1
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.5,
    className: "st205",
    width: 28.9,
    height: 0.1
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.5,
    className: "st204",
    width: 28.9,
    height: 0.1
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.4,
    className: "st204",
    width: 28.9,
    height: 0
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.4,
    className: "st203",
    width: 28.9,
    height: 0
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.3,
    className: "st202",
    width: 28.9,
    height: 0
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.3,
    className: "st201",
    width: 28.9,
    height: 0
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.2,
    className: "st200",
    width: 28.9,
    height: 0
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.2,
    className: "st199",
    width: 28.9,
    height: 0
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.1,
    className: "st198",
    width: 28.9,
    height: 0
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64.1,
    className: "st197",
    width: 28.9,
    height: 0
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64,
    className: "st196",
    width: 28.9,
    height: 0
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 64,
    className: "st195",
    width: 28.9,
    height: 0
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.9,
    className: "st194",
    width: 28.9,
    height: 0
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.9,
    className: "st193",
    width: 28.9,
    height: 0
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.8,
    className: "st192",
    width: 28.9,
    height: 0
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.8,
    className: "st191",
    width: 28.9,
    height: 0
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.7,
    className: "st190",
    width: 28.9,
    height: 0
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.7,
    className: "st189",
    width: 28.9,
    height: 0
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.6,
    className: "st188",
    width: 28.9,
    height: 0
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.6,
    className: "st187",
    width: 28.9,
    height: 0
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.5,
    className: "st186",
    width: 28.9,
    height: 0
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.5,
    className: "st185",
    width: 28.9,
    height: 0
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.4,
    className: "st184",
    width: 28.9,
    height: 0
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.4,
    className: "st183",
    width: 28.9,
    height: 0
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.3,
    className: "st182",
    width: 28.9,
    height: 0
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.3,
    className: "st181",
    width: 28.9,
    height: 0
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.2,
    className: "st180",
    width: 28.9,
    height: 0
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.2,
    className: "st179",
    width: 28.9,
    height: 0
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.1,
    className: "st179",
    width: 28.9,
    height: 0.1
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63.1,
    className: "st178",
    width: 28.9,
    height: 0.1
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 63,
    className: "st177",
    width: 28.9,
    height: 0.1
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.9,
    className: "st176",
    width: 28.9,
    height: 0.1
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.9,
    className: "st175",
    width: 28.9,
    height: 0.1
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.8,
    className: "st174",
    width: 28.9,
    height: 0.1
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.8,
    className: "st173",
    width: 28.9,
    height: 0.1
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.7,
    className: "st172",
    width: 28.9,
    height: 0.1
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.7,
    className: "st171",
    width: 28.9,
    height: 0.1
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.6,
    className: "st170",
    width: 28.9,
    height: 0.1
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.6,
    className: "st169",
    width: 28.9,
    height: 0.1
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.5,
    className: "st168",
    width: 28.9,
    height: 0.1
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.5,
    className: "st168",
    width: 28.9,
    height: 0
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.4,
    className: "st167",
    width: 28.9,
    height: 0
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.4,
    className: "st166",
    width: 28.9,
    height: 0
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.3,
    className: "st165",
    width: 28.9,
    height: 0
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.3,
    className: "st164",
    width: 28.9,
    height: 0
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.3,
    className: "st163",
    width: 28.9,
    height: 0
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.2,
    className: "st162",
    width: 28.9,
    height: 0
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.2,
    className: "st161",
    width: 28.9,
    height: 0
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.2,
    className: "st161",
    width: 28.9,
    height: 0
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st160",
    width: 28.9,
    height: 0
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st159",
    width: 28.9,
    height: 0
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st158",
    width: 28.9,
    height: 0
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st157",
    width: 28.9,
    height: 0
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st156",
    width: 28.9,
    height: 0
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62.1,
    className: "st155",
    width: 28.9,
    height: 0
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st154",
    width: 28.9,
    height: 0
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st153",
    width: 28.9,
    height: 0
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st152",
    width: 28.9,
    height: 0
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st151",
    width: 28.9,
    height: 0
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st150",
    width: 28.9,
    height: 0
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 62,
    className: "st149",
    width: 28.9,
    height: 0
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st148",
    width: 28.9,
    height: 0
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st147",
    width: 28.9,
    height: 0
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st146",
    width: 28.9,
    height: 0
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st145",
    width: 28.9,
    height: 0
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st144",
    width: 28.9,
    height: 0
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.9,
    className: "st143",
    width: 28.9,
    height: 0
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.8,
    className: "st142",
    width: 28.9,
    height: 0
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.8,
    className: "st142",
    width: 28.9,
    height: 0
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.8,
    className: "st141",
    width: 28.9,
    height: 0
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.8,
    className: "st140",
    width: 28.9,
    height: 0
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.8,
    className: "st139",
    width: 28.9,
    height: 0
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.7,
    className: "st138",
    width: 28.9,
    height: 0
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.7,
    className: "st137",
    width: 28.9,
    height: 0
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.7,
    className: "st136",
    width: 28.9,
    height: 0
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.7,
    className: "st135",
    width: 28.9,
    height: 0
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.7,
    className: "st134",
    width: 28.9,
    height: 0
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.6,
    className: "st133",
    width: 28.9,
    height: 0
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.6,
    className: "st132",
    width: 28.9,
    height: 0
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.6,
    className: "st131",
    width: 28.9,
    height: 0
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.6,
    className: "st130",
    width: 28.9,
    height: 0
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.6,
    className: "st129",
    width: 28.9,
    height: 0
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.5,
    className: "st128",
    width: 28.9,
    height: 0
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.5,
    className: "st127",
    width: 28.9,
    height: 0
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.5,
    className: "st126",
    width: 28.9,
    height: 0
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.5,
    className: "st125",
    width: 28.9,
    height: 0
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.5,
    className: "st124",
    width: 28.9,
    height: 0
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.4,
    className: "st123",
    width: 28.9,
    height: 0
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.4,
    className: "st122",
    width: 28.9,
    height: 0
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.4,
    className: "st121",
    width: 28.9,
    height: 0
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.4,
    className: "st120",
    width: 28.9,
    height: 0
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.4,
    className: "st119",
    width: 28.9,
    height: 0
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.3,
    className: "st118",
    width: 28.9,
    height: 0
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.3,
    className: "st117",
    width: 28.9,
    height: 0
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.3,
    className: "st116",
    width: 28.9,
    height: 0
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.3,
    className: "st115",
    width: 28.9,
    height: 0
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.3,
    className: "st114",
    width: 28.9,
    height: 0
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st113",
    width: 28.9,
    height: 0
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st112",
    width: 28.9,
    height: 0
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st111",
    width: 28.9,
    height: 0
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st111",
    width: 28.9,
    height: 0
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st110",
    width: 28.9,
    height: 0
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.2,
    className: "st109",
    width: 28.9,
    height: 0
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st108",
    width: 28.9,
    height: 0
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st107",
    width: 28.9,
    height: 0
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st106",
    width: 28.9,
    height: 0
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st105",
    width: 28.9,
    height: 0
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st84",
    width: 28.9,
    height: 0
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st85",
    width: 28.9,
    height: 0
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61.1,
    className: "st86",
    width: 28.9,
    height: 0
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st87",
    width: 28.9,
    height: 0
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st88",
    width: 28.9,
    height: 0
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st89",
    width: 28.9,
    height: 0
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st104",
    width: 28.9,
    height: 0
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st103",
    width: 28.9,
    height: 0
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st102",
    width: 28.9,
    height: 0
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st93",
    width: 28.9,
    height: 0
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 61,
    className: "st94",
    width: 28.9,
    height: 0
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st95",
    width: 28.9,
    height: 0
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st96",
    width: 28.9,
    height: 0
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st97",
    width: 28.9,
    height: 0
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st98",
    width: 28.9,
    height: 0
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st99",
    width: 28.9,
    height: 0
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st100",
    width: 28.9,
    height: 0
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.9,
    className: "st101",
    width: 28.9,
    height: 0
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st101",
    width: 28.9,
    height: 0
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st100",
    width: 28.9,
    height: 0
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st99",
    width: 28.9,
    height: 0
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st98",
    width: 28.9,
    height: 0
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st97",
    width: 28.9,
    height: 0
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.8,
    className: "st96",
    width: 28.9,
    height: 0
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.7,
    className: "st95",
    width: 28.9,
    height: 0
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.7,
    className: "st94",
    width: 28.9,
    height: 0
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.7,
    className: "st93",
    width: 28.9,
    height: 0
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.7,
    className: "st92",
    width: 28.9,
    height: 0
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.7,
    className: "st91",
    width: 28.9,
    height: 0
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st90",
    width: 28.9,
    height: 0
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st89",
    width: 28.9,
    height: 0
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st88",
    width: 28.9,
    height: 0
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st87",
    width: 28.9,
    height: 0
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st86",
    width: 28.9,
    height: 0
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.6,
    className: "st85",
    width: 28.9,
    height: 0
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st84",
    width: 28.9,
    height: 0
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st84",
    width: 28.9,
    height: 0
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st105",
    width: 28.9,
    height: 0
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st106",
    width: 28.9,
    height: 0
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st107",
    width: 28.9,
    height: 0
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.5,
    className: "st108",
    width: 28.9,
    height: 0
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st109",
    width: 28.9,
    height: 0
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st110",
    width: 28.9,
    height: 0
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st111",
    width: 28.9,
    height: 0
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st112",
    width: 28.9,
    height: 0
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st113",
    width: 28.9,
    height: 0
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st686",
    width: 28.9,
    height: 0
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.4,
    className: "st687",
    width: 28.9,
    height: 0
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st688",
    width: 28.9,
    height: 0
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st689",
    width: 28.9,
    height: 0
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st690",
    width: 28.9,
    height: 0
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st691",
    width: 28.9,
    height: 0
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st692",
    width: 28.9,
    height: 0
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.3,
    className: "st693",
    width: 28.9,
    height: 0
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.2,
    className: "st694",
    width: 28.9,
    height: 0
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.2,
    className: "st695",
    width: 28.9,
    height: 0
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 60.2,
    className: "st696",
    width: 28.9,
    height: 0
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 59,
    className: "st696",
    width: 28.9,
    height: 1.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000095309680388872791330000017706058709023821199_",
    d: "M111.3,78.9c1.8-8.8-2.2-17.1-9-18.4 c-6.7-1.4-13.6,4.7-15.4,13.5s2.2,17.1,9,18.4C102.6,93.8,109.5,87.8,111.3,78.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056427642239859391870000007357648664426805937_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095309680388872791330000017706058709023821199_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056427642239859391870000007357648664426805937_)"
    }
  }, _polygon1099 || (_polygon1099 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1077",
    points: "97,59.1 85.1,71 85.1,59.1  "
  })), _polygon1100 || (_polygon1100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1077",
    points: "98.7,59.1 85.1,72.7 85.1,71 97,59.1  "
  })), _polygon1101 || (_polygon1101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1076",
    points: "100.3,59.1 85.1,74.4 85.1,72.7 98.7,59.1  "
  })), _polygon1102 || (_polygon1102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1075",
    points: "102,59.1 85.1,76 85.1,74.4 100.3,59.1  "
  })), _polygon1103 || (_polygon1103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "103.7,59.1 85.1,77.7 85.1,76 102,59.1  "
  })), _polygon1104 || (_polygon1104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1121",
    points: "105.3,59.1 85.1,79.4 85.1,77.7 103.7,59.1  "
  })), _polygon1105 || (_polygon1105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1122",
    points: "107,59.1 85.1,81 85.1,79.4 105.3,59.1  "
  })), _polygon1106 || (_polygon1106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1123",
    points: "108,59.1 108.3,59.4 85.1,82.7 85.1,81 107,59.1  "
  })), _polygon1107 || (_polygon1107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1123",
    points: "108.3,59.4 108.8,59.9 85.1,83.6 85.1,82.7  "
  })), _polygon1108 || (_polygon1108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1124",
    points: "108.8,59.9 109.3,60.4 85.1,84.5 85.1,83.6  "
  })), _polygon1109 || (_polygon1109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1125",
    points: "109.3,60.4 109.7,60.8 85.1,85.5 85.1,84.5  "
  })), _polygon1110 || (_polygon1110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1126",
    points: "109.7,60.8 110.2,61.3 85.1,86.4 85.1,85.5  "
  })), _polygon1111 || (_polygon1111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1127",
    points: "110.2,61.3 110.6,61.7 85.1,87.3 85.1,86.4  "
  })), _polygon1112 || (_polygon1112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1128",
    points: "110.6,61.7 111.1,62.2 85.1,88.2 85.1,87.3  "
  })), _polygon1113 || (_polygon1113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1129",
    points: "111.1,62.2 111.6,62.7 85.3,88.9 85.1,88.7 85.1,88.2  "
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1,
    y: 75.7,
    transform: "matrix(0.7061 -0.7081 0.7081 0.7061 -24.8334 92.215)",
    className: "st1130",
    width: 37.1,
    height: 0.6
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 76.2,
    transform: "matrix(0.7061 -0.7081 0.7081 0.7061 -25.0232 92.6743)",
    className: "st1131",
    width: 37.1,
    height: 0.6
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 76.6,
    transform: "matrix(0.7061 -0.7081 0.7081 0.7061 -25.2104 93.1396)",
    className: "st1132",
    width: 37.1,
    height: 0.6
  })), _polygon1114 || (_polygon1114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1133",
    points: "112.9,64 113.1,64.2 113.1,64.8 87.2,90.8 86.7,90.3  "
  })), _polygon1115 || (_polygon1115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1134",
    points: "113.1,65.7 87.6,91.2 87.2,90.8 113.1,64.8  "
  })), _polygon1116 || (_polygon1116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1135",
    points: "113.1,66.6 88.1,91.7 87.6,91.2 113.1,65.7  "
  })), _polygon1117 || (_polygon1117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1136",
    points: "113.1,67.6 88.6,92.2 88.1,91.7 113.1,66.6  "
  })), _polygon1118 || (_polygon1118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1137",
    points: "113.1,68.5 89,92.6 88.6,92.2 113.1,67.6  "
  })), _polygon1119 || (_polygon1119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1138",
    points: "113.1,69.4 89.5,93.1 89,92.6 113.1,68.5  "
  })), _polygon1120 || (_polygon1120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1139",
    points: "113.1,70.3 89.9,93.5 89.5,93.1 113.1,69.4  "
  })), _polygon1121 || (_polygon1121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1140",
    points: "113.1,71.2 90.6,93.8 90.2,93.8 89.9,93.5 113.1,70.3  "
  })), _polygon1122 || (_polygon1122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1141",
    points: "113.1,72.2 91.5,93.8 90.6,93.8 113.1,71.2  "
  })), _polygon1123 || (_polygon1123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1141",
    points: "113.1,72.8 92.2,93.8 91.5,93.8 113.1,72.2  "
  })), _polygon1124 || (_polygon1124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1142",
    points: "113.1,73.5 92.8,93.8 92.2,93.8 113.1,72.8  "
  })), _polygon1125 || (_polygon1125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1143",
    points: "113.1,74.1 93.5,93.8 92.8,93.8 113.1,73.5  "
  })), _polygon1126 || (_polygon1126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1144",
    points: "113.1,74.8 94.1,93.8 93.5,93.8 113.1,74.1  "
  })), _polygon1127 || (_polygon1127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1145",
    points: "113.1,75.4 94.8,93.8 94.1,93.8 113.1,74.8  "
  })), _polygon1128 || (_polygon1128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1146",
    points: "113.1,76 95.4,93.8 94.8,93.8 113.1,75.4  "
  })), _polygon1129 || (_polygon1129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1147",
    points: "113.1,76.7 96.1,93.8 95.4,93.8 113.1,76  "
  })), _polygon1130 || (_polygon1130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1148",
    points: "113.1,77.3 96.7,93.8 96.1,93.8 113.1,76.7  "
  })), _polygon1131 || (_polygon1131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1149",
    points: "113.1,78 97.3,93.8 96.7,93.8 113.1,77.3  "
  })), _polygon1132 || (_polygon1132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1150",
    points: "113.1,78.6 98,93.8 97.3,93.8 113.1,78  "
  })), _polygon1133 || (_polygon1133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1151",
    points: "113.1,79.3 98.6,93.8 98,93.8 113.1,78.6  "
  })), _polygon1134 || (_polygon1134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1152",
    points: "113.1,79.9 99.3,93.8 98.6,93.8 113.1,79.3  "
  })), _polygon1135 || (_polygon1135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1153",
    points: "113.1,80.6 99.9,93.8 99.3,93.8 113.1,79.9  "
  })), _polygon1136 || (_polygon1136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1154",
    points: "113.1,81.2 100.6,93.8 99.9,93.8 113.1,80.6  "
  })), _polygon1137 || (_polygon1137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1155",
    points: "113.1,81.9 101.2,93.8 100.6,93.8 113.1,81.2  "
  })), _polygon1138 || (_polygon1138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1155",
    points: "101.2,93.8 113.1,81.9 113.1,93.8  "
  })))), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 60.4,
    className: "st697",
    width: 24.1,
    height: 33
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 60.4,
    className: "st697",
    width: 24,
    height: 32.9
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124136231330900680180000002626787407317911998_",
    d: "M107.9,78.3c1.3-6.4-1.6-12.3-6.5-13.3 c-4.9-1-9.8,3.4-11.1,9.7C89,81,91.9,87,96.8,88C101.6,89,106.6,84.6,107.9,78.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113345355101235317830000010399684981530342802_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124136231330900680180000002626787407317911998_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000113345355101235317830000010399684981530342802_)"
    }
  }, _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.6,
    className: "st101",
    width: 20.2,
    height: 1.3
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.5,
    className: "st101",
    width: 20.2,
    height: 0.1
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.4,
    className: "st100",
    width: 20.2,
    height: 0.1
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.3,
    className: "st99",
    width: 20.2,
    height: 0.1
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.2,
    className: "st98",
    width: 20.2,
    height: 0.1
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87.1,
    className: "st97",
    width: 20.2,
    height: 0.1
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 87,
    className: "st96",
    width: 20.2,
    height: 0.1
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.9,
    className: "st95",
    width: 20.2,
    height: 0.1
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.8,
    className: "st94",
    width: 20.2,
    height: 0.1
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.7,
    className: "st93",
    width: 20.2,
    height: 0.1
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.6,
    className: "st102",
    width: 20.2,
    height: 0.1
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.5,
    className: "st103",
    width: 20.2,
    height: 0.1
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.4,
    className: "st104",
    width: 20.2,
    height: 0.1
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.3,
    className: "st1157",
    width: 20.2,
    height: 0.1
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.2,
    className: "st1158",
    width: 20.2,
    height: 0.1
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86.1,
    className: "st1159",
    width: 20.2,
    height: 0.1
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 86,
    className: "st1160",
    width: 20.2,
    height: 0.1
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.9,
    className: "st1161",
    width: 20.2,
    height: 0.1
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.8,
    className: "st1162",
    width: 20.2,
    height: 0.1
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.7,
    className: "st1163",
    width: 20.2,
    height: 0.1
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.6,
    className: "st1164",
    width: 20.2,
    height: 0.1
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.5,
    className: "st1165",
    width: 20.2,
    height: 0.1
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.4,
    className: "st1166",
    width: 20.2,
    height: 0.1
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.3,
    className: "st1167",
    width: 20.2,
    height: 0.1
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.2,
    className: "st1168",
    width: 20.2,
    height: 0.1
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85.1,
    className: "st1169",
    width: 20.2,
    height: 0.1
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85,
    className: "st1170",
    width: 20.2,
    height: 0.1
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.9,
    className: "st1171",
    width: 20.2,
    height: 0.1
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.8,
    className: "st1172",
    width: 20.2,
    height: 0.1
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.7,
    className: "st1173",
    width: 20.2,
    height: 0.1
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.6,
    className: "st1174",
    width: 20.2,
    height: 0.1
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.5,
    className: "st1175",
    width: 20.2,
    height: 0.1
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.3,
    className: "st1176",
    width: 20.2,
    height: 0.1
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.2,
    className: "st1177",
    width: 20.2,
    height: 0.1
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84.1,
    className: "st1178",
    width: 20.2,
    height: 0.1
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 84,
    className: "st1179",
    width: 20.2,
    height: 0.1
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.9,
    className: "st1180",
    width: 20.2,
    height: 0.1
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.8,
    className: "st1181",
    width: 20.2,
    height: 0.1
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.7,
    className: "st1182",
    width: 20.2,
    height: 0.1
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.6,
    className: "st1183",
    width: 20.2,
    height: 0.1
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.5,
    className: "st1184",
    width: 20.2,
    height: 0.1
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.4,
    className: "st1185",
    width: 20.2,
    height: 0.1
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.3,
    className: "st1186",
    width: 20.2,
    height: 0.1
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.2,
    className: "st1187",
    width: 20.2,
    height: 0.1
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83.1,
    className: "st1188",
    width: 20.2,
    height: 0.1
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 83,
    className: "st1189",
    width: 20.2,
    height: 0.1
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.9,
    className: "st1190",
    width: 20.2,
    height: 0.1
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.8,
    className: "st1191",
    width: 20.2,
    height: 0.1
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.7,
    className: "st1192",
    width: 20.2,
    height: 0.1
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.6,
    className: "st1193",
    width: 20.2,
    height: 0.1
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.5,
    className: "st659",
    width: 20.2,
    height: 0.1
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.4,
    className: "st1194",
    width: 20.2,
    height: 0.1
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.3,
    className: "st1195",
    width: 20.2,
    height: 0.1
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.2,
    className: "st1196",
    width: 20.2,
    height: 0.1
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82.1,
    className: "st1197",
    width: 20.2,
    height: 0.1
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 82,
    className: "st1198",
    width: 20.2,
    height: 0.1
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.9,
    className: "st1199",
    width: 20.2,
    height: 0.1
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.8,
    className: "st1200",
    width: 20.2,
    height: 0.1
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.7,
    className: "st1201",
    width: 20.2,
    height: 0.1
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.6,
    className: "st1202",
    width: 20.2,
    height: 0.1
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.5,
    className: "st1203",
    width: 20.2,
    height: 0.1
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.4,
    className: "st610",
    width: 20.2,
    height: 0.1
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.3,
    className: "st611",
    width: 20.2,
    height: 0.1
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81.2,
    className: "st612",
    width: 20.2,
    height: 0.1
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 81,
    className: "st613",
    width: 20.2,
    height: 0.1
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.9,
    className: "st614",
    width: 20.2,
    height: 0.1
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.8,
    className: "st615",
    width: 20.2,
    height: 0.1
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.7,
    className: "st616",
    width: 20.2,
    height: 0.1
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.6,
    className: "st617",
    width: 20.2,
    height: 0.1
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.5,
    className: "st618",
    width: 20.2,
    height: 0.1
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.4,
    className: "st619",
    width: 20.2,
    height: 0.1
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.3,
    className: "st620",
    width: 20.2,
    height: 0.1
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.2,
    className: "st621",
    width: 20.2,
    height: 0.1
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80.1,
    className: "st622",
    width: 20.2,
    height: 0.1
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 80,
    className: "st623",
    width: 20.2,
    height: 0.1
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.9,
    className: "st624",
    width: 20.2,
    height: 0.1
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.8,
    className: "st625",
    width: 20.2,
    height: 0.1
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.7,
    className: "st626",
    width: 20.2,
    height: 0.1
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.6,
    className: "st299",
    width: 20.2,
    height: 0.1
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.5,
    className: "st279",
    width: 20.2,
    height: 0.1
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.4,
    className: "st278",
    width: 20.2,
    height: 0.1
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.3,
    className: "st277",
    width: 20.2,
    height: 0.1
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.2,
    className: "st276",
    width: 20.2,
    height: 0.1
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79.1,
    className: "st275",
    width: 20.2,
    height: 0.1
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 79,
    className: "st274",
    width: 20.2,
    height: 0.1
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.9,
    className: "st1088",
    width: 20.2,
    height: 0.1
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.8,
    className: "st1089",
    width: 20.2,
    height: 0.1
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.7,
    className: "st1090",
    width: 20.2,
    height: 0.1
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.6,
    className: "st1091",
    width: 20.2,
    height: 0.1
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.5,
    className: "st1204",
    width: 20.2,
    height: 0.1
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.4,
    className: "st1205",
    width: 20.2,
    height: 0.1
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.3,
    className: "st1206",
    width: 20.2,
    height: 0.1
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.2,
    className: "st1207",
    width: 20.2,
    height: 0.1
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78.1,
    className: "st1208",
    width: 20.2,
    height: 0.1
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 78,
    className: "st1209",
    width: 20.2,
    height: 0.1
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.9,
    className: "st1210",
    width: 20.2,
    height: 0.1
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.7,
    className: "st1211",
    width: 20.2,
    height: 0.1
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.6,
    className: "st1212",
    width: 20.2,
    height: 0.1
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.5,
    className: "st1213",
    width: 20.2,
    height: 0.1
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.4,
    className: "st1214",
    width: 20.2,
    height: 0.1
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.3,
    className: "st1215",
    width: 20.2,
    height: 0.1
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.2,
    className: "st1216",
    width: 20.2,
    height: 0.1
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77.1,
    className: "st1217",
    width: 20.2,
    height: 0.1
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 77,
    className: "st1218",
    width: 20.2,
    height: 0.1
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.9,
    className: "st1219",
    width: 20.2,
    height: 0.1
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.8,
    className: "st1219",
    width: 20.2,
    height: 0.1
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.7,
    className: "st1220",
    width: 20.2,
    height: 0.1
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.6,
    className: "st1221",
    width: 20.2,
    height: 0.1
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.5,
    className: "st1222",
    width: 20.2,
    height: 0.1
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.5,
    className: "st1223",
    width: 20.2,
    height: 0.1
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.4,
    className: "st250",
    width: 20.2,
    height: 0.1
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.3,
    className: "st249",
    width: 20.2,
    height: 0.1
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.2,
    className: "st248",
    width: 20.2,
    height: 0.1
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76.1,
    className: "st247",
    width: 20.2,
    height: 0.1
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 76,
    className: "st246",
    width: 20.2,
    height: 0.1
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.9,
    className: "st245",
    width: 20.2,
    height: 0.1
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.8,
    className: "st244",
    width: 20.2,
    height: 0.1
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.7,
    className: "st243",
    width: 20.2,
    height: 0.1
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.6,
    className: "st242",
    width: 20.2,
    height: 0.1
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.5,
    className: "st241",
    width: 20.2,
    height: 0.1
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.4,
    className: "st240",
    width: 20.2,
    height: 0.1
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.3,
    className: "st239",
    width: 20.2,
    height: 0.1
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.2,
    className: "st238",
    width: 20.2,
    height: 0.1
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75.1,
    className: "st237",
    width: 20.2,
    height: 0.1
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 75,
    className: "st236",
    width: 20.2,
    height: 0.1
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.9,
    className: "st235",
    width: 20.2,
    height: 0.1
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.9,
    className: "st1224",
    width: 20.2,
    height: 0.1
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.8,
    className: "st1225",
    width: 20.2,
    height: 0.1
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.7,
    className: "st1226",
    width: 20.2,
    height: 0.1
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.6,
    className: "st1227",
    width: 20.2,
    height: 0.1
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.5,
    className: "st1228",
    width: 20.2,
    height: 0.1
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.4,
    className: "st1229",
    width: 20.2,
    height: 0.1
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.3,
    className: "st1230",
    width: 20.2,
    height: 0.1
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.2,
    className: "st1231",
    width: 20.2,
    height: 0.1
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74.1,
    className: "st1232",
    width: 20.2,
    height: 0.1
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 74,
    className: "st1233",
    width: 20.2,
    height: 0.1
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.9,
    className: "st878",
    width: 20.2,
    height: 0.1
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.8,
    className: "st879",
    width: 20.2,
    height: 0.1
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.7,
    className: "st880",
    width: 20.2,
    height: 0.1
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.6,
    className: "st221",
    width: 20.2,
    height: 0.1
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.5,
    className: "st222",
    width: 20.2,
    height: 0.1
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.4,
    className: "st223",
    width: 20.2,
    height: 0.1
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.3,
    className: "st881",
    width: 20.2,
    height: 0.1
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.2,
    className: "st882",
    width: 20.2,
    height: 0.1
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.2,
    className: "st883",
    width: 20.2,
    height: 0.1
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73.1,
    className: "st889",
    width: 20.2,
    height: 0.1
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 73,
    className: "st888",
    width: 20.2,
    height: 0.1
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72.8,
    className: "st888",
    width: 20.2,
    height: 0.2
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72.6,
    className: "st889",
    width: 20.2,
    height: 0.2
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72.5,
    className: "st883",
    width: 20.2,
    height: 0.2
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72.3,
    className: "st882",
    width: 20.2,
    height: 0.2
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72.2,
    className: "st881",
    width: 20.2,
    height: 0.2
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 72,
    className: "st223",
    width: 20.2,
    height: 0.2
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71.8,
    className: "st222",
    width: 20.2,
    height: 0.2
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71.7,
    className: "st704",
    width: 20.2,
    height: 0.2
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71.5,
    className: "st220",
    width: 20.2,
    height: 0.2
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71.4,
    className: "st219",
    width: 20.2,
    height: 0.2
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71.2,
    className: "st218",
    width: 20.2,
    height: 0.2
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 71,
    className: "st217",
    width: 20.2,
    height: 0.2
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.9,
    className: "st216",
    width: 20.2,
    height: 0.2
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.8,
    className: "st216",
    width: 20.2,
    height: 0.1
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.6,
    className: "st215",
    width: 20.2,
    height: 0.1
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.5,
    className: "st214",
    width: 20.2,
    height: 0.1
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.4,
    className: "st213",
    width: 20.2,
    height: 0.1
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.3,
    className: "st212",
    width: 20.2,
    height: 0.1
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.2,
    className: "st211",
    width: 20.2,
    height: 0.1
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 70.1,
    className: "st232",
    width: 20.2,
    height: 0.1
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.9,
    className: "st233",
    width: 20.2,
    height: 0.1
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.8,
    className: "st234",
    width: 20.2,
    height: 0.1
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.7,
    className: "st235",
    width: 20.2,
    height: 0.1
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.6,
    className: "st236",
    width: 20.2,
    height: 0.1
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.5,
    className: "st237",
    width: 20.2,
    height: 0.1
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.4,
    className: "st238",
    width: 20.2,
    height: 0.1
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.2,
    className: "st239",
    width: 20.2,
    height: 0.1
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69.1,
    className: "st240",
    width: 20.2,
    height: 0.1
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 69,
    className: "st241",
    width: 20.2,
    height: 0.1
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.9,
    className: "st1119",
    width: 20.2,
    height: 0.1
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.8,
    className: "st1118",
    width: 20.2,
    height: 0.1
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.7,
    className: "st1117",
    width: 20.2,
    height: 0.1
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.5,
    className: "st1116",
    width: 20.2,
    height: 0.1
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.4,
    className: "st1115",
    width: 20.2,
    height: 0.1
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.3,
    className: "st1114",
    width: 20.2,
    height: 0.1
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.2,
    className: "st1113",
    width: 20.2,
    height: 0.1
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68.1,
    className: "st1112",
    width: 20.2,
    height: 0.1
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 68,
    className: "st1111",
    width: 20.2,
    height: 0.1
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.8,
    className: "st1110",
    width: 20.2,
    height: 0.1
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.7,
    className: "st1109",
    width: 20.2,
    height: 0.1
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.6,
    className: "st1108",
    width: 20.2,
    height: 0.1
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.5,
    className: "st1107",
    width: 20.2,
    height: 0.1
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.4,
    className: "st1106",
    width: 20.2,
    height: 0.1
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.3,
    className: "st1105",
    width: 20.2,
    height: 0.1
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.1,
    className: "st1104",
    width: 20.2,
    height: 0.1
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67.1,
    className: "st1104",
    width: 20.2,
    height: 0.1
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 67,
    className: "st1103",
    width: 20.2,
    height: 0.1
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.9,
    className: "st1102",
    width: 20.2,
    height: 0.1
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.8,
    className: "st1101",
    width: 20.2,
    height: 0.1
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.7,
    className: "st1100",
    width: 20.2,
    height: 0.1
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.6,
    className: "st1099",
    width: 20.2,
    height: 0.1
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.5,
    className: "st1098",
    width: 20.2,
    height: 0.1
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.4,
    className: "st1097",
    width: 20.2,
    height: 0.1
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.3,
    className: "st1096",
    width: 20.2,
    height: 0.1
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.2,
    className: "st1095",
    width: 20.2,
    height: 0.1
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66.1,
    className: "st1094",
    width: 20.2,
    height: 0.1
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66,
    className: "st1093",
    width: 20.2,
    height: 0.1
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.9,
    className: "st1092",
    width: 20.2,
    height: 0.1
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.8,
    className: "st1091",
    width: 20.2,
    height: 0.1
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.7,
    className: "st1090",
    width: 20.2,
    height: 0.1
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.7,
    className: "st1089",
    width: 20.2,
    height: 0.1
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.6,
    className: "st1088",
    width: 20.2,
    height: 0.1
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.5,
    className: "st274",
    width: 20.2,
    height: 0.1
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.4,
    className: "st275",
    width: 20.2,
    height: 0.1
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.3,
    className: "st276",
    width: 20.2,
    height: 0.1
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.2,
    className: "st277",
    width: 20.2,
    height: 0.1
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65.1,
    className: "st278",
    width: 20.2,
    height: 0.1
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 65,
    className: "st279",
    width: 20.2,
    height: 0.1
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 64.9,
    className: "st280",
    width: 20.2,
    height: 0.1
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 64.8,
    className: "st281",
    width: 20.2,
    height: 0.1
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 64,
    className: "st281",
    width: 20.2,
    height: 0.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067950543617755828690000015776625308295017607_",
    d: "M108.9,78.3c1.3-6.4-1.6-12.3-6.5-13.3 c-4.9-1-9.8,3.4-11.1,9.7C90,81,92.9,87,97.7,88C102.6,89,107.6,84.6,108.9,78.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121983795999814077600000010401335022402986371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067950543617755828690000015776625308295017607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121983795999814077600000010401335022402986371_)"
    }
  }, _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 64,
    className: "st1235",
    width: 1,
    height: 25
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 64,
    className: "st1235",
    width: 1.1,
    height: 25
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 64,
    className: "st1236",
    width: 1.1,
    height: 25
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 64,
    className: "st1237",
    width: 1.1,
    height: 25
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 64,
    className: "st1238",
    width: 1.1,
    height: 25
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 64,
    className: "st1238",
    width: 0.4,
    height: 25
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 64,
    className: "st1239",
    width: 0.4,
    height: 25
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3,
    y: 64,
    className: "st1240",
    width: 0.4,
    height: 25
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 64,
    className: "st1241",
    width: 0.4,
    height: 25
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 64,
    className: "st1242",
    width: 0.4,
    height: 25
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 64,
    className: "st92",
    width: 0.4,
    height: 25
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 64,
    className: "st1243",
    width: 0.4,
    height: 25
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 64,
    className: "st1244",
    width: 0.4,
    height: 25
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 64,
    className: "st1245",
    width: 0.4,
    height: 25
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 99.2,
    y: 64,
    className: "st1148",
    width: 0.4,
    height: 25
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6,
    y: 64,
    className: "st1246",
    width: 0.4,
    height: 25
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 64,
    className: "st1247",
    width: 0.4,
    height: 25
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 100.4,
    y: 64,
    className: "st1247",
    width: 0.2,
    height: 25
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 64,
    className: "st1248",
    width: 0.2,
    height: 25
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 100.9,
    y: 64,
    className: "st1249",
    width: 0.2,
    height: 25
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 64,
    className: "st1250",
    width: 0.2,
    height: 25
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 101.4,
    y: 64,
    className: "st1251",
    width: 0.2,
    height: 25
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 64,
    className: "st1252",
    width: 0.2,
    height: 25
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 101.8,
    y: 64,
    className: "st1253",
    width: 0.2,
    height: 25
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 64,
    className: "st1254",
    width: 0.2,
    height: 25
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 64,
    className: "st1255",
    width: 0.2,
    height: 25
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 64,
    className: "st1256",
    width: 0.2,
    height: 25
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 64,
    className: "st1257",
    width: 0.2,
    height: 25
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 64,
    className: "st1258",
    width: 0.2,
    height: 25
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 64,
    className: "st1259",
    width: 0.2,
    height: 25
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 64,
    className: "st1260",
    width: 0.2,
    height: 25
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 64,
    className: "st1261",
    width: 0.2,
    height: 25
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 103.9,
    y: 64,
    className: "st1262",
    width: 0.2,
    height: 25
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 64,
    className: "st1263",
    width: 0.2,
    height: 25
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 64,
    className: "st1264",
    width: 0.2,
    height: 25
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 64,
    className: "st1265",
    width: 0.2,
    height: 25
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 104.9,
    y: 64,
    className: "st1266",
    width: 0.2,
    height: 25
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 64,
    className: "st1267",
    width: 0.2,
    height: 25
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 105.3,
    y: 64,
    className: "st1267",
    width: 0.2,
    height: 25
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 64,
    className: "st1268",
    width: 0.2,
    height: 25
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 105.7,
    y: 64,
    className: "st1269",
    width: 0.2,
    height: 25
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 64,
    className: "st1270",
    width: 0.2,
    height: 25
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 64,
    className: "st1271",
    width: 0.2,
    height: 25
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 64,
    className: "st1272",
    width: 0.2,
    height: 25
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 106.4,
    y: 64,
    className: "st1273",
    width: 0.2,
    height: 25
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 106.6,
    y: 64,
    className: "st1274",
    width: 0.2,
    height: 25
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 106.7,
    y: 64,
    className: "st1275",
    width: 0.2,
    height: 25
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 106.9,
    y: 64,
    className: "st1276",
    width: 0.2,
    height: 25
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: 64,
    className: "st1277",
    width: 0.2,
    height: 25
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 64,
    className: "st1278",
    width: 0.2,
    height: 25
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 107.4,
    y: 64,
    className: "st1279",
    width: 0.2,
    height: 25
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 64,
    className: "st1280",
    width: 0.2,
    height: 25
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 107.8,
    y: 64,
    className: "st1281",
    width: 0.2,
    height: 25
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 64,
    className: "st1282",
    width: 0.2,
    height: 25
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 108.1,
    y: 64,
    className: "st1283",
    width: 0.2,
    height: 25
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 64,
    className: "st1284",
    width: 0.2,
    height: 25
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 64,
    className: "st1285",
    width: 0.2,
    height: 25
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 64,
    className: "st1286",
    width: 0.2,
    height: 25
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 64,
    className: "st1287",
    width: 0.2,
    height: 25
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 64,
    className: "st1288",
    width: 0.2,
    height: 25
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 109.2,
    y: 64,
    className: "st1288",
    width: 1,
    height: 25
  })))), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 64.5,
    className: "st697",
    width: 15.6,
    height: 23.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonedThrow);
export default __webpack_public_path__ + "static/media/zoned-throw.ffd4a996e10774657cbe453f4bd3a36a.svg";
export { ForwardRef as ReactComponent };